
//module.import { PrepAggregates } from "./RUtility";

// worker.js
// import api from "./testModule";

 class AggregateManger { 
    userSettings  = null;
   


//    AddDays = (date, days) => {
//      return this.addDays(date, days);
//  }

  




//   addDays(date, days) {
//      var one_day = 1000 * 60 * 60 * 24;
//      return new Date(date.getTime() + (days * one_day));
//  }



  




 

 


  dateFromSDateTime(date) {
    try {
        //console.log("date=" + date);
        if (!date) {
            return;
        }
        if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1) {
            date = date + "Z";
        }
        var nDate = new Date(date);


        var re = /-?\d+/;
        var m = re.exec(date);
        //  console.log(m);
        if (null == m || m.index == 0) {
            nDate.setHours(nDate.getHours() - 5);
            nDate.setMinutes(nDate.getMinutes() - 30);
        }

        return nDate;
    }
    catch (e) {

        //console.log("PLEASE FF" + e);
    }
    return "N/A";
}

 getTimeData(h,m,s,ms,date) {
    var timeNew = new Date(date);
    timeNew.setHours(h,m,s,ms);
   // timeNew.setMinutes(m);
    var timeOfDay = timeNew.getTime();
    return timeOfDay;

}
  




 



  




 










 getUserSettingsValue(key) {
  var configJsonString = this.userSettings; // localStorage.getItem("UserSettings");

  if (configJsonString) {
      var settings = configJsonString.filter(function (e) { return e.Name == key })[0];
      if (settings) {
          return settings.Value;
      }
  }
  return "";
}
  GetHolidaysList(fid) {
    var holidaysList = this.getUserSettingsValue("HOLIDAYSLIST");
    var holidays = holidaysList ? JSON.parse(holidaysList) : [];
    const dates = [];
    for (var i = 0; i < holidays.length; i++) {


        dates.push(...this.getDatesInRange(this.dateFromSDateTime(holidays[i].OccasionFrom), this.dateFromSDateTime(holidays[i].OccasionTo)));
    }

    return dates;
}


 IsSunDayOrSecondOrFourthSaturday(date) {
    if (date.getDay() == 0 || date.getDay() != 6) {

        return date.getDay() == 0 ? true : false;
    }

    var yesSaturday = ((date.getDate() >= 8 && date.getDate() <= 14) || (date.getDate() >= 22 && date.getDate() <= 28));


    return yesSaturday;

}

 IsSunDayOrSaturday(date) {

    return date.getDay() == 0 || date.getDay() == 6 ? true : false;

   

}

 getMonthShortName(monthNo) {
    const date = new Date();
    date.setMonth(monthNo - 1);

    return date.toLocaleString('en-US', { month: 'short' });
}

  GetShortDateandMonth(date) {
    var month = this.getMonthShortName(date.getMonth() + 1);
    var day = date.getDate();
    var dtString = (day <= 9 ? "0" + day : day) + "-" + month;
    return dtString;
}

  GetTelegramTagString(user, altName = "") {
    if (!user || !user.Name) {
        return !altName ? "" : altName;
    }
    else if (!user.TelegramId) {
        return user.Name;
    }
    else {
        return "[" + user.Name + "]" + "(tg://user?id=" + user.TelegramId + ")";
    }

}

  GetShortMonth(date) {
    var month = this.getMonthShortName(date.getMonth() + 1);
    return month;
}

  GetDiffDays(startDate,endDate)
{
    var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();
    return  (Difference_In_Time / (1000 * 3600 * 24));
}

  GetTotalWorkingDays(startDate, endDate) {
    //console.log('GetTotalWorkingDays');

    endDate = endDate > new Date ? new Date() : endDate;
    var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    var holidayList = this.GetHolidaysList();
    var dates = this.GetDatesInRange(startDate, endDate);
    for(var i=0;i<dates.length;i++)
    {
      var date = dates[i];
    // $.map(dates, function (date) {
        var dt = holidayList.filter(function (e) { return e.toDateString() == date.toDateString() })[0];
        // console.log(dt);
        if (this.IsSunDayOrSecondOrFourthSaturday(date) || dt) {
            //console.log(date + " - Is Excluded" );
            Difference_In_Days = Difference_In_Days - 1
        }
    //});
  }

    return Difference_In_Days;

}
differenceInMonths(date1, date2) {
 const monthDiff = date1.getMonth() - date2.getMonth();
 const yearDiff = date1.getYear() - date2.getYear();

 return monthDiff + yearDiff * 12;
}
padTo2Digits(num) {
 return num.toString().padStart(2, '0');
}

 PSdateFormate(date) {
 return (
     [
         date.getFullYear(),
         this.padTo2Digits(date.getMonth() + 1),
         this.padTo2Digits(date.getDate()),
     ].join('-') +
     ' ' +
     [
         this.padTo2Digits(date.getHours()),
         this.padTo2Digits(date.getMinutes()),
         this.padTo2Digits(date.getSeconds()),
     ].join(':')
 );
}
  GetTotalWorkingDaysExcludingSaturdays(startDate, endDate) {
    //console.log('GetTotalWorkingDays');

    endDate = endDate > new Date ? new Date() : endDate;
    var Difference_In_Time = new Date(endDate.toDateString()).getTime() - new Date(startDate.toDateString()).getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    var holidayList = this.GetHolidaysList();
    var dates = this.GetDatesInRange(startDate, endDate);
    for(var i=0;i<dates.length;i++)
    {
      var date = dates[i];
        var dt = holidayList.filter(function (e) { return e.toDateString() == date.toDateString() })[0];
        // console.log(dt);
        if (this.IsSunDayOrSaturday(date) || dt) {
            //console.log(date + " - Is Excluded" );
            Difference_In_Days = Difference_In_Days - 1
        }
   // });
      }

    return Difference_In_Days;

}


  GetDatesInRange(startDate, endDate) {
    return this.getDatesInRange(startDate, endDate)
}


  GetTimeSlotTotal(slot) {
    if (!slot) {
        return 0;
    }

    var values = slot.split(":");
    if (!values || values.length == 0) {
        return 0;
    }

    return (parseInt(values[0]) * 60) + (values.length > 1 && values[1] ? parseInt(values[1]) : 0)
}

  GetCurretnSlot(slot) {
    var exact930 = 9 * 60 + 30;
    var exact11 = 11 * 60;
    var exact13 = 13 * 60;
    var exact16 = 16 * 60;
    var exact18 = 18 * 60;
    var exact19 = 19 * 60;

    var timeslot = this.GetTimeSlotTotal(slot);
    if (timeslot < exact930) {
        return "Before 9:30 AM";
    }
    else if (timeslot >= exact930 && timeslot <= exact11) {
        return "9:30 AM - 11:00 AM";
    }
    else if (timeslot > exact11 && timeslot <= exact13) {
        return "11:00 AM - 01:00 PM";
    }
    else if (timeslot > exact13 && timeslot <= exact16) {
        return "01:00 PM - 04:00 PM";
    }
    else if (timeslot > exact16 && timeslot <= exact18) {
        return "04:00 PM - 06:00 AM";
    }
    else if (timeslot > exact18 && timeslot <= exact19) {
        return "06:00 PM - 07:00 PM";
    }
    else if (timeslot > exact19) {
        return "After 7:00 PM";
    }
}


 mongodateforholidays(date) {
 try {
     //console.log("date=" + date);
     if (!date) {
         return;
     }

     if (date.indexOf("Z") == -1 && date.toLowerCase().indexOf("am") == -1 && date.toLowerCase().indexOf("pm") == -1 && date.indexOf("T") > -1) {
         date = date + "Z";
     }

     var nDate = new Date(date);
     // console.log("dateFromSDateTime NEWDATE :"+nDate)
     var re = /-?\d+/;
     var m = re.exec(date);
     //  console.log(m);
     if (null == m || m.index == 0) {
         nDate.setHours(nDate.getHours() - 5);
         nDate.setMinutes(nDate.getMinutes() - 30);
     }
     return nDate;
 }
 catch (e) {

     //console.log("PLEASE FF" + e);
 }
 return "N/A";
}


  GetPendingMinutes(date) {

    var dateToCheck = this.dateFromSDateTime(date);

    var diff = Math.abs(new Date() - dateToCheck);
    var minutes1 = Math.floor((diff / 1000) / 60);


    let days = diff / (24 * 60 * 60 * 1000);
    let hours = (days % 1) * 24;
    let minutes = (hours % 1) * 60;

    [days, hours, minutes] = [Math.floor(days), Math.floor(hours), Math.floor(minutes)]

    var stringToSend = days > 0 ? days + ' day ' : "";
    stringToSend += hours > 0 ? hours + ' hrs ' : "";
    stringToSend += minutes + ' min'
    return stringToSend;
}
  GetShortDesignation(type) {
    if (!type) {
        return type;
    }

    switch (type.toLowerCase()) {
        case "behavioural therapist":
            return "BT";
            break;
        case "occupational therapist":
            return "OT";
            break;
        case "special educator":
            return "SE";
            break;
        case "speech therapist":
            return "ST";
            break;
    }

    return type;
}

  GetServiceType(type) {
    if (!type) {
        return type;
    }

    switch (type.toLowerCase()) {
        case "behavioural therapist":
            return "Behavioral Modification";
            break;
        case "occupational therapist":
            return "Occupational Therapy";
            break;
        case "special educator":
            return "special education";
            break;
        case "speech therapist":
            return "Speech Therapy";
            break;
    }

    return type;
}
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

  GetDesignationByServiceType(type) {
    if (!type) {
        return type;
    }

    switch (type.toLowerCase()) {
        case "behavioural modification":
        case "behavioral modification":
            return "behavioural therapist";
            break;
        case "occupational therapy":
            return "occupational therapist";
            break;
        case "special education":
            return "special educator";
            break;
        case "speech therapy":
            return "speech therapist";
            break;
    }

    return type;
}

// Accepts the array and key
  groupBy(array, key, isLower) {
  // Return the end result
  isLower = isLower || false;
  return array.reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      if (currentValue && currentValue[key]) {
          if (isLower) {
              (result[currentValue[key].toLowerCase()] = result[currentValue[key].toLowerCase()] || []).push(
                  currentValue
              );
          }
          else {
              (result[currentValue[key]] = result[currentValue[key]] || []).push(
                  currentValue
              );
          }
      }
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
  }, {}); // empty object is the initial value for result object
}

  groupByMultiple(array, key, isLower) {
  // Return the end result
  isLower = isLower || false;
  return array.reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      if (currentValue && currentValue[key]) {
          currentValue[key] = currentValue[key] + "" ? currentValue[key] : "";
          var multiple = (currentValue[key] + "").split(",");
          for (var i = 0; i < multiple.length; i++) {
              var value = multiple[i];
              if (value) {
                  value = value.trim();
                  if (isLower) {
                      (result[value.toLowerCase()] = result[value.toLowerCase()] || []).push(
                          currentValue
                      );
                  }
                  else {
                      (result[value] = result[value] || []).push(
                          currentValue
                      );
                  }
              }
          }

      }
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
  }, {}); // empty object is the initial value for result object
}

  GetGraceCompoCount(dataSource, startDate, endDate, kids) {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    endDate = endDate > new Date() ? new Date() : endDate;
    kids = kids || [];

    //var typeId = dataSource.Types.filter(f => f.Name == "ATTENDANCE" && a.Category == "ActionType")[0].Id;
    var gracetypeId = dataSource.Types.filter(f => f.Name == "Grace Compensation Request" && f.Category == "Service Request")[0].Id;
    var servicerequestAnalytics = Object.entries(this.groupBy((dataSource.ServiceRequestAnalytics||[]), "SRId")).map(m => m[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);

    var srData = this.groupBy((dataSource.ServiceRequestAnalytics || []), "SRId");
    var requests = (dataSource.ServiceRequests||[]).filter(f => f.TypeId == gracetypeId && srData[f.Id] && srData[f.Id].Status == "CLOSED" && srData[f.Id].CBPI == f.CBPI && kids.indexOf(f.TOId) > -1 && (this.dateFromSDateTime(f.FDT) >= startDate) && (this.dateFromSDateTime(f.FDT) <= endDate) && srData[f.Id].Amount > 0);
    requests = requests || [];
   /* var requests = $.grep(dataSource, function (e) { return e.AT == "SERVICEREQUESTANALYTIC" && e.F1 == "Grace Compensation Request" && kids.indexOf(e.OGID) > -1 && (this.dateFromSDateTime(e.FDT) >= startDate) && (this.dateFromSDateTime(e.FDT) <= endDate) && e.TOId == e.CBPI && e.F7 > 0 });*/

    var services = [];
    if (requests && requests.length > 0) {

        for (var i = 0; i < requests.length; i++) {

            var leave = requests[i];
            for (var j = 0; j < leave.Amount; j++) {
                var service = { "FDT": leave.FDT, "TDT": leave.FDT, "ServiceId": leave.Package, "TOId": leave.TOId, "Status": "Absent", "F3": leave.F4, "UId": leave.Id };
                services.push(service);
            }
        }
    }

    return services;




}

  GetLeavesCompoCount(dataSource, startDate, endDate, user, servicesData) {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    endDate = endDate > new Date() ? new Date() : endDate;

    var therapistIds = servicesData ? servicesData.map(function (m) { return m.TherapistId }) : [];
    var leavesData = dataSource.Leaves;
    if (!leavesData) {
        var leaveId = this.GetTypeIdByName(dataSource.Types, "LEAVEREQUEST");
        leavesData = dataSource.PeopleNotes ? dataSource.PeopleNotes.filter(f => f.TypeId == leaveId) : [];
    }
    var $this = this;
    var leaveRequests =  leavesData.filter(function (e) {
        return  e.RS != "DELETEACTIVITY" && $this.dateFromSDateTime(e.TDT) >= startDate && $this.dateFromSDateTime(e.TDT) <= endDate && (null == user ? true : ((e.TOId == user.Id) || (therapistIds && therapistIds.length > 0 ? therapistIds.indexOf(e.TOId) > -1 : false)))


    });



    //&& e.F10 == "Parent" e.S == "Approved"
    if (!leaveRequests || leaveRequests.length == 0) {
        return [];
    }
    var leaves = [];
    var services = [];
    for (var i = 0; i < leaveRequests.length; i++) {
        var leave = leaveRequests[i]
        var already =leaves.filter(function (r) { return r.TDT == leave.TDT && leave.F10 == r.F10 })[0];
        if (!already) {

            if (leave.F1 == "Therapist" || leave.F1 == "AdminForTherapist") {

                var servicesData1 =servicesData.filter(function (r) { return (null == user ? true : r.BossId == user.Id) && r.TherapistId == leave.TOId && $this.dateFromSDateTime(r.StartDate) <= $this.dateFromSDateTime(leave.FDT) });
                if (servicesData1) {

                 for(var i=0;i<servicesData1.length;i++)
                 {
                     var e = servicesData1[i];
                   // servicesData1.forEach(function (e) {
                        var alreadyCompo = services.filter(function (f) { return f.ServiceId == e.Id && e.TDT == leave.TDT })[0];
                        if (!alreadyCompo) {
                            var service = { "AT": "ATTENDANCE", "FDT": leave.TDT, "TDT": leave.TDT, "F5": e.RDT, "TOId": e.TOId, "Status": "Absent", "F3": e.F2, "ServiceId": e.Id };
                            services.push(service);
                        }
                    }
                }
            }
            else {

                var servicesData1 = servicesData.filter(function (r) { return (null == user ? true : r.BossId == user.Id) && r.BossId == leave.TOId && $this.dateFromSDateTime(r.FDT) <= $this.dateFromSDateTime(leave.FDT) });

                //servicesData1.forEach(function (e) {
                 for(var i=0;i<servicesData1.length;i++)
                 {
                     var e = servicesData1[i];
                    var alreadyCompo = services.filter(function (f) {return  f.ServiceId == e.Id && e.TDT == leave.TDT })[0];
                    if (!alreadyCompo) {
                        var service = { "AT": "ATTENDANCE", "FDT": leave.TDT, "TDT": leave.TDT, "F5": e.RDT, "TOId": leave.TOId, "Status": "Absent", "F3": e.F2, "ServiceId": e.UId };
                        services.push(service);
                    }
                }
            }
            leaves.push(leave);
        }
    }

    return services;

}

getMonthDifference(startDate, endDate) {
 return (
     endDate.getMonth() -
     startDate.getMonth() +
     12 * (endDate.getFullYear() - startDate.getFullYear())
 );
}




appMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
appShortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
MileStoneQuestions = [
 {
     "Id": 1,
     "AgeGroup": "Birth to 1 month",
     "Category": "Gross Motor",
     "Question": "Does the baby display equal movement on both sides?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 1
 },
 {
     "Id": 2,
     "AgeGroup": "Birth to 1 month",
     "Category": "Gross Motor",
     "Question": "Does the baby show reflexes like sucking and grasping?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 2
 },
 {
     "Id": 3,
     "AgeGroup": "Birth to 1 month",
     "Category": "Fine Motor",
     "Question": "Exhibits palmar grasp reflex: This primitive reflex involves an infant closing their hand around an object placed in their palm.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 3
 },
 {
     "Id": 4,
     "AgeGroup": "Birth to 1 month",
     "Category": "Fine Motor",
     "Question": "Hand-to-mouth coordination: Infants begin to bring their hands to their mouth as they start to gain control over their arm movements.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 4
 },
 {
     "Id": 5,
     "AgeGroup": "Birth to 1 month",
     "Category": "Communication\/Speech",
     "Question": "Reflexive communication: Expresses through crying, fussing, and other reflexive responses. ",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 5
 },
 {
     "Id": 6,
     "AgeGroup": "Birth to 1 month",
     "Category": "Communication\/Speech",
     "Question": "Alertness to noise: Shows signs of noticing certain sounds.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 6
 },
 {
     "Id": 7,
     "AgeGroup": "Birth to 1 month",
     "Category": "Cognitive",
     "Question": "Does your baby react to bright lights or loud noises?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 7
 },
 {
     "Id": 8,
     "AgeGroup": "Birth to 1 month",
     "Category": "Cognitive",
     "Question": "Have you noticed your baby gazing at faces?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 8
 },
 {
     "Id": 9,
     "AgeGroup": "Birth to 1 month",
     "Category": "Social & Emotional",
     "Question": "Begins to exhibit a differential response to parental stimuli.   E.g. \"Does your baby seem to react differently to your voice or face compared to other sounds or faces?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 9
 },
 {
     "Id": 10,
     "AgeGroup": "Birth to 1 month",
     "Category": "Social & Emotional",
     "Question": "Shows distinct crying patterns for different needs.  E.g. \"Have you noticed different types of crying when your baby is hungry, tired, or uncomfortable?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 10
 },
 {
     "Id": 11,
     "AgeGroup": "Birth to 1 month",
     "Category": "Sensory Development",
     "Question": "Responds to tactile stimuli and exhibits nociceptive (pain) response.\n    E.g. \"Does your baby react to touch or appear uncomfortable when in a certain position?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 11
 },
 {
     "Id": 12,
     "AgeGroup": "Birth to 1 month",
     "Category": "Sensory Development",
     "Question": "Shows sensitivity to bright lights and loud sounds.\n    E.g. \"Does your baby squint or close their eyes in bright light? Do they startle at loud noises?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 12
 },
 {
     "Id": 13,
     "AgeGroup": "1-3 months",
     "Category": "Gross Motor",
     "Question": "Does the baby hold up their head during tummy time?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 13
 },
 {
     "Id": 14,
     "AgeGroup": "1-3 months",
     "Category": "Gross Motor",
     "Question": "Does the baby control movements like kicking and arm waving?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 14
 },
 {
     "Id": 15,
     "AgeGroup": "1-3 months",
     "Category": "Fine Motor",
     "Question": "Hand regard: This is when infants start to notice their hands and observe them.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 16,
     "AgeGroup": "1-3 months",
     "Category": "Fine Motor",
     "Question": "Primitive swiping at objects: Initially, these movements are not directed, but over time they become more purposeful.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 17,
     "AgeGroup": "1-3 months",
     "Category": "Communication\/ Speech",
     "Question": "Cooing: Makes comfort sounds and vowel-like sounds (oo\/ah), often in response to verbal stimulation.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 15
 },
 {
     "Id": 18,
     "AgeGroup": "1-3 months",
     "Category": "Communication\/ Speech",
     "Question": "Attention to speech: Infants display increased attention to speech sounds and may quiet to familiar voices.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 16
 },
 {
     "Id": 19,
     "AgeGroup": "1-3 months",
     "Category": "Cognitive",
     "Question": "Does your baby follow moving objects with their eyes?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 17
 },
 {
     "Id": 20,
     "AgeGroup": "1-3 months",
     "Category": "Cognitive",
     "Question": "Have you noticed your baby losing interest in a toy after playing with it for a while?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 18
 },
 {
     "Id": 21,
     "AgeGroup": "1-3 months",
     "Category": "Social & Emotional",
     "Question": "Exhibits social smiling as a response to social stimuli.\n  E.g. \"Does your baby respond with a smile when you talk or smile at them?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 19
 },
 {
     "Id": 22,
     "AgeGroup": "1-3 months",
     "Category": "Social & Emotional",
     "Question": "Demonstrates self-soothing behaviors.\n  E.g. \"Does your baby calm themselves by sucking their hand or fingers?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 20
 },
 {
     "Id": 23,
     "AgeGroup": "1-3 months",
     "Category": "Sensory Development",
     "Question": "Begins to follow moving objects with eyes.   E.g. \"Does your baby track a toy with their eyes as it moves?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 24,
     "AgeGroup": "1-3 months",
     "Category": "Sensory Development",
     "Question": "Reacts to sounds and begins to turn head towards them.  E.g.  \"Does your baby seem to respond to certain sounds or voices?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 3,
     "RS": "ACTIVE",
     "Sequnce": 21
 },
 {
     "Id": 25,
     "AgeGroup": "3-6 months",
     "Category": "Gross Motor",
     "Question": "Can the baby roll over?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 22
 },
 {
     "Id": 26,
     "AgeGroup": "3-6 months",
     "Category": "Gross Motor",
     "Question": "Can the baby sit with support?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 23
 },
 {
     "Id": 27,
     "AgeGroup": "3-6 months",
     "Category": "Gross Motor",
     "Question": "Does the baby bear weight on their legs?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 28,
     "AgeGroup": "3-6 months",
     "Category": "Fine Motor",
     "Question": "Bilateral reaching: Infants start to reach for objects using both hands simultaneously.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 24
 },
 {
     "Id": 29,
     "AgeGroup": "3-6 months",
     "Category": "Fine Motor",
     "Question": "Begins to show hand preference: Although not definitive at this stage, infants may start to favor one hand over the other.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 30,
     "AgeGroup": "3-6 months",
     "Category": "Fine Motor",
     "Question": "Object transfer from hand to hand: Infants begin to move objects from one hand to the other, demonstrating improved hand coordination.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 25
 },
 {
     "Id": 31,
     "AgeGroup": "3-6 months",
     "Category": "Communication\/ Speech",
     "Question": "Babbling: Begins to produce consonant-vowel combinations, such as \"ba,\" \"ma,\" \"da.\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 26
 },
 {
     "Id": 32,
     "AgeGroup": "3-6 months",
     "Category": "Communication\/ Speech",
     "Question": "Voice imitation: May imitate pitch and volume changes in other people's speech.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 27
 },
 {
     "Id": 33,
     "AgeGroup": "3-6 months",
     "Category": "Cognitive",
     "Question": "Does your baby explore objects by grabbing or mouthing them?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 28
 },
 {
     "Id": 34,
     "AgeGroup": "3-6 months",
     "Category": "Cognitive",
     "Question": "Does your baby shake a rattle to hear the noise it makes?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 29
 },
 {
     "Id": 35,
     "AgeGroup": "3-6 months",
     "Category": "Social & Emotional",
     "Question": "Shows pleasure during social interactions and protests when they end.\n   E.g. \"Does your baby enjoy playtime and seem upset when it's over?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 30
 },
 {
     "Id": 36,
     "AgeGroup": "3-6 months",
     "Category": "Social & Emotional",
     "Question": "Begins to differentiate between familiar individuals and strangers, showing signs of stranger anxiety.\n   E.g. \"Does your baby seem more comfortable with familiar people and anxious around strangers?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 31
 },
 {
     "Id": 37,
     "AgeGroup": "3-6 months",
     "Category": "Sensory Development",
     "Question": "Begins to reach for objects and shows interest in different textures.\n  E.g. \"Does your baby reach for toys or objects? Do they explore different textures?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 32
 },
 {
     "Id": 38,
     "AgeGroup": "3-6 months",
     "Category": "Sensory Development",
     "Question": "Responds to changes in tone of your voice.\n  E.g.  \"Does your baby react differently to changes in the tone of your voice?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 6,
     "RS": "ACTIVE",
     "Sequnce": 33
 },
 {
     "Id": 39,
     "AgeGroup": "6-9 months",
     "Category": "Gross Motor",
     "Question": "Can the baby crawl?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 34
 },
 {
     "Id": 40,
     "AgeGroup": "6-9 months",
     "Category": "Gross Motor",
     "Question": "Can the baby sit without support?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 35
 },
 {
     "Id": 41,
     "AgeGroup": "6-9 months",
     "Category": "Gross Motor",
     "Question": "Does the baby pull up to stand?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 36
 },
 {
     "Id": 42,
     "AgeGroup": "6-9 months",
     "Category": "Fine Motor",
     "Question": "Radial-palmar grasp: Infants can now grasp objects using the thumb and all four fingers.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 37
 },
 {
     "Id": 43,
     "AgeGroup": "6-9 months",
     "Category": "Fine Motor",
     "Question": "Radial-digital grasp: This is the ability to grasp an object using the thumb and just a few fingers, not involving the pinky.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 38
 },
 {
     "Id": 44,
     "AgeGroup": "6-9 months",
     "Category": "Fine Motor",
     "Question": "Voluntary release of objects: Infants begin intentionally letting go of objects, rather than only releasing when they lose their grip.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 39
 },
 {
     "Id": 45,
     "AgeGroup": "6-9 months",
     "Category": "Communication\/ Speech",
     "Question": "Reduplicated babbling: Repeats same syllable (e.g., \"ba ba ba\"). ",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 40
 },
 {
     "Id": 46,
     "AgeGroup": "6-9 months",
     "Category": "Communication\/ Speech",
     "Question": "Understands first words: Although they may not be able to say them, infants often understand a few common words like \"mama\" and \"dada.\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 41
 },
 {
     "Id": 47,
     "AgeGroup": "6-9 months",
     "Category": "Cognitive",
     "Question": "Does your baby look for a toy if you hide it while they are watching?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 42
 },
 {
     "Id": 48,
     "AgeGroup": "6-9 months",
     "Category": "Cognitive",
     "Question": "Does your baby try to imitate your facial expressions or simple actions?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 43
 },
 {
     "Id": 49,
     "AgeGroup": "6-9 months",
     "Category": "Social & Emotional",
     "Question": "Exhibits attachment behaviors toward primary caregivers.\n   E.g. \"Does your baby show a preference for you or other primary caregivers, like reaching out to be picked up?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 44
 },
 {
     "Id": 50,
     "AgeGroup": "6-9 months",
     "Category": "Social & Emotional",
     "Question": "Shows preferential behavior for specific people and objects.\n   E.g. \"Does your baby have favorite people or toys that they prefer over others?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 9,
     "RS": "ACTIVE",
     "Sequnce": 45
 },
 {
     "Id": 51,
     "AgeGroup": "9-12 months",
     "Category": "Gross Motor",
     "Question": "Can the baby stand alone?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 46
 },
 {
     "Id": 52,
     "AgeGroup": "9-12 months",
     "Category": "Gross Motor",
     "Question": "Does the baby cruise around furniture?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 47
 },
 {
     "Id": 53,
     "AgeGroup": "9-12 months",
     "Category": "Gross Motor",
     "Question": "Has the baby taken first steps?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 48
 },
 {
     "Id": 54,
     "AgeGroup": "9-12 months",
     "Category": "Fine Motor",
     "Question": "Pincer grasp: The ability to pick up small objects using the thumb and index finger.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 49
 },
 {
     "Id": 55,
     "AgeGroup": "9-12 months",
     "Category": "Fine Motor",
     "Question": "Neat pincer grasp: The ability to pick up small objects with precision, using the tips of the thumb and index finger.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 50
 },
 {
     "Id": 56,
     "AgeGroup": "9-12 months",
     "Category": "Fine Motor",
     "Question": "Begins to show hand dominance: While not definitive, children may start to consistently favor one hand over the other.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 51
 },
 {
     "Id": 57,
     "AgeGroup": "9-12 months",
     "Category": "Communication\/ Speech",
     "Question": "Variegated babbling: Mixes different sounds and intonations (e.g., \"ba ma goo\").",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 52
 },
 {
     "Id": 58,
     "AgeGroup": "9-12 months",
     "Category": "Communication\/ Speech",
     "Question": "Gesture use: Frequently uses gestures to communicate, such as waving or pointing.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 53
 },
 {
     "Id": 59,
     "AgeGroup": "9-12 months",
     "Category": "Cognitive",
     "Question": "Does your baby try different ways to reach or obtain a toy?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 54
 },
 {
     "Id": 60,
     "AgeGroup": "9-12 months",
     "Category": "Cognitive",
     "Question": "Does your baby mimic complex actions, like clapping hands?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 55
 },
 {
     "Id": 61,
     "AgeGroup": "9-12 months",
     "Category": "Social & Emotional",
     "Question": "May exhibit separation anxiety when apart from primary caregivers.\n   E.g. \"Does your baby cry or show signs of distress when you leave the room?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 56
 },
 {
     "Id": 63,
     "AgeGroup": "9-12 months",
     "Category": "Social & Emotional",
     "Question": "Displays a range of basic emotions such as happiness, sadness, and anger.\n   E.g. \"Does your baby show clear signs of different emotions, like laughing when happy or crying when upset?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 57
 },
 {
     "Id": 64,
     "AgeGroup": "9-12 months",
     "Category": "Sensory Development",
     "Question": "Develops depth perception and hand-eye coordination.\n  E.g. \"Does your baby reach accurately for objects?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "ACTIVE",
     "Sequnce": 58
 },
 {
     "Id": 65,
     "AgeGroup": "9-12 months",
     "Category": "Sensory Development",
     "Question": "Starts to develop an understanding of object permanence.\n  E.g. \"Does your baby look for toys that have been covered up or hidden?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 12,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 66,
     "AgeGroup": "12-18 months",
     "Category": "Gross Motor",
     "Question": "Can the baby walk independently?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 59
 },
 {
     "Id": 67,
     "AgeGroup": "12-18 months",
     "Category": "Gross Motor",
     "Question": "Does the baby squat to pick up toys?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 60
 },
 {
     "Id": 68,
     "AgeGroup": "12-18 months",
     "Category": "Gross Motor",
     "Question": "Can the baby climb stairs with help?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 61
 },
 {
     "Id": 69,
     "AgeGroup": "12-18 months",
     "Category": "Fine Motor",
     "Question": "Mature pincer grasp: The ability to manipulate small objects with the thumb and index finger, such as turning a page in a book.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 62
 },
 {
     "Id": 70,
     "AgeGroup": "12-18 months",
     "Category": "Fine Motor",
     "Question": "Scribbles on paper: The child begins mark-making, often using a whole-hand grasp to control the writing instrument.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 63
 },
 {
     "Id": 71,
     "AgeGroup": "12-18 months",
     "Category": "Communication\/ Speech",
     "Question": "First words: Begins to use one or more words consistently, and those words have meaning to them.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 64
 },
 {
     "Id": 72,
     "AgeGroup": "12-18 months",
     "Category": "Communication\/ Speech",
     "Question": "Receptive vocabulary: Understands simple instructions, particularly if vocal cues are accompanied by gestures.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 65
 },
 {
     "Id": 73,
     "AgeGroup": "12-18 months",
     "Category": "Cognitive",
     "Question": "If you hide a toy under a blanket, does your child look for it?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 74,
     "AgeGroup": "12-18 months",
     "Category": "Cognitive",
     "Question": "Does your child pretend to talk on a toy phone or feed a doll?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 66
 },
 {
     "Id": 75,
     "AgeGroup": "12-18 months",
     "Category": "Social & Emotional",
     "Question": "Shows a wider range of emotions, including complex ones like defiance.\n   E.g. \"Has your child started to test boundaries or say 'no'?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 67
 },
 {
     "Id": 76,
     "AgeGroup": "12-18 months",
     "Category": "Social & Emotional",
     "Question": "Begins to exhibit signs of empathy.\n   E.g. \"Does your child seem to react when they see others upset, like patting another child's back if they're crying?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 68
 },
 {
     "Id": 77,
     "AgeGroup": "12-18 months",
     "Category": "Sensory Development",
     "Question": "Begins to recognize self in mirror.\n  - \"Does your child recognize themselves in the mirror?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 69
 },
 {
     "Id": 78,
     "AgeGroup": "12-18 months",
     "Category": "Sensory Development",
     "Question": "Shows an increase in coordination, such as stacking blocks or using simple tools.\n  - \"Can your child stack blocks or use a spoon?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 18,
     "RS": "ACTIVE",
     "Sequnce": 70
 },
 {
     "Id": 79,
     "AgeGroup": "18-24 months",
     "Category": "Gross Motor",
     "Question": "Can the baby run stably?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 71
 },
 {
     "Id": 80,
     "AgeGroup": "18-24 months",
     "Category": "Gross Motor",
     "Question": "Can the baby kick a ball?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 72
 },
 {
     "Id": 81,
     "AgeGroup": "18-24 months",
     "Category": "Gross Motor",
     "Question": "Can the baby jump off the ground?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 73
 },
 {
     "Id": 82,
     "AgeGroup": "18-24 months",
     "Category": "Gross Motor",
     "Question": "Can the baby climb furniture without help?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 74
 },
 {
     "Id": 83,
     "AgeGroup": "18-24 months",
     "Category": "Fine Motor",
     "Question": "Two-block tower: The child can stack two blocks or similar objects one on top of the other.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 75
 },
 {
     "Id": 84,
     "AgeGroup": "18-24 months",
     "Category": "Fine Motor",
     "Question": "Vertical stroke: The child can imitate a vertical stroke with a crayon or pencil.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 76
 },
 {
     "Id": 85,
     "AgeGroup": "18-24 months",
     "Category": "Communication\/ Speech",
     "Question": "Two-word combinations: Begins to put two words together to form mini sentences (e.g., \"more cookie\").",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 77
 },
 {
     "Id": 86,
     "AgeGroup": "18-24 months",
     "Category": "Communication\/ Speech",
     "Question": "Vocabulary growth: Rapid increase in word learning, known as the \"vocabulary spurt.\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 78
 },
 {
     "Id": 87,
     "AgeGroup": "18-24 months",
     "Category": "Cognitive",
     "Question": "Does your child sort toys by color or shape?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 79
 },
 {
     "Id": 88,
     "AgeGroup": "18-24 months",
     "Category": "Cognitive",
     "Question": "Does your child engage in pretend play, like making a toy animal 'eat' pretend food?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 80
 },
 {
     "Id": 89,
     "AgeGroup": "18-24 months",
     "Category": "Social & Emotional",
     "Question": "Begins to understand possession and may show territorial behaviors.\n   E.g. \"Does your child understand the concept of 'mine' and 'yours'?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 81
 },
 {
     "Id": 90,
     "AgeGroup": "18-24 months",
     "Category": "Social & Emotional",
     "Question": "Demonstrates parallel play (playing alongside other children, not with them).\n   E.g. \"Does your child play next to other children, even if they're not playing together?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 24,
     "RS": "ACTIVE",
     "Sequnce": 82
 },
 {
     "Id": 91,
     "AgeGroup": "2-3 years",
     "Category": "Gross Motor",
     "Question": "Can the child climb stairs step by step with support?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 83
 },
 {
     "Id": 92,
     "AgeGroup": "2-3 years",
     "Category": "Gross Motor",
     "Question": "Can the child pedal a tricycle?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 84
 },
 {
     "Id": 93,
     "AgeGroup": "2-3 years",
     "Category": "Gross Motor",
     "Question": "Can the child run and dodge obstacles?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 85
 },
 {
     "Id": 94,
     "AgeGroup": "2-3 years",
     "Category": "Gross Motor",
     "Question": "Can the child stand on one foot momentarily?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 86
 },
 {
     "Id": 95,
     "AgeGroup": "2-3 years",
     "Category": "Fine Motor",
     "Question": "Can draw a circular motion and starts to create circular scribbles.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 87
 },
 {
     "Id": 96,
     "AgeGroup": "2-3 years",
     "Category": "Fine Motor",
     "Question": "Can string large beads: This demonstrates improved hand-eye coordination and fine motor control.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 88
 },
 {
     "Id": 97,
     "AgeGroup": "2-3 years",
     "Category": "Fine Motor",
     "Question": "Uses a palmar-supinate grasp to hold a crayon: This involves holding the crayon with the palm facing down and the wrist bent back slightly.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 89
 },
 {
     "Id": 98,
     "AgeGroup": "2-3 years",
     "Category": "Communication\/ Speech",
     "Question": "Sentence length: Starts using three- and four-word sentences.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 90
 },
 {
     "Id": 99,
     "AgeGroup": "2-3 years",
     "Category": "Communication\/ Speech",
     "Question": "Vocabulary expansion: Vocabulary typically ranges from 200 to 1,000 words.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 91
 },
 {
     "Id": 100,
     "AgeGroup": "2-3 years",
     "Category": "Communication\/ Speech",
     "Question": "Plurals and pronouns: Begins to correctly use plurals and pronouns (though mistakes are common).",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 92
 },
 {
     "Id": 101,
     "AgeGroup": "2-3 years",
     "Category": "Cognitive",
     "Question": "Can your child count or recognize numbers?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 93
 },
 {
     "Id": 102,
     "AgeGroup": "2-3 years",
     "Category": "Cognitive",
     "Question": "Does your child understand basic time concepts like morning, afternoon, and night?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 94
 },
 {
     "Id": 103,
     "AgeGroup": "2-3 years",
     "Category": "Social & Emotional",
     "Question": "Begins to engage in associative play (sharing materials and following themes, but not yet working toward a common goal).\n   E.g. \"Does your child share toys and follow similar themes in play as other children, even if they're not coordinating their play yet?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 95
 },
 {
     "Id": 104,
     "AgeGroup": "2-3 years",
     "Category": "Social & Emotional",
     "Question": "Expresses a wide range of emotions, which may include intense tantrums.\n   E.g. \"Does your child show a variety of emotions and sometimes have temper tantrums?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 96
 },
 {
     "Id": 105,
     "AgeGroup": "2-3 years",
     "Category": "Sensory Development",
     "Question": "Develops the ability to recognize and match similar shapes and colors.\n  - \"Can your child match and name simple shapes and colors?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 97
 },
 {
     "Id": 106,
     "AgeGroup": "2-3 years",
     "Category": "Sensory Development",
     "Question": "Begins to develop a sense of balance and coordination.\n  - \"Can your child balance on one foot or walk on tiptoes?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 36,
     "RS": "ACTIVE",
     "Sequnce": 98
 },
 {
     "Id": 107,
     "AgeGroup": "3-4 years",
     "Category": "Gross Motor",
     "Question": "Can the child hop and stand on one foot?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 99
 },
 {
     "Id": 108,
     "AgeGroup": "3-4 years",
     "Category": "Gross Motor",
     "Question": "Can the child climb stairs step by step without support?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 100
 },
 {
     "Id": 109,
     "AgeGroup": "3-4 years",
     "Category": "Gross Motor",
     "Question": "Can the child walk on tiptoes?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 101
 },
 {
     "Id": 110,
     "AgeGroup": "3-4 years",
     "Category": "Gross Motor",
     "Question": "Can the child catch a large bouncing ball?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 102
 },
 {
     "Id": 111,
     "AgeGroup": "3-4 years",
     "Category": "Fine Motor",
     "Question": "Can cut across a piece of paper using scissors: This is a complex task that requires coordinated use of both hands and good fine motor control.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 103
 },
 {
     "Id": 112,
     "AgeGroup": "3-4 years",
     "Category": "Fine Motor",
     "Question": "Can copy a circle and a cross: This demonstrates improved control of drawing tools.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 104
 },
 {
     "Id": 113,
     "AgeGroup": "3-4 years",
     "Category": "Communication\/ Speech",
     "Question": "Complex sentences: Begins using sentences with four or more words. Sentences may include more complex ideas through the use of conjunctions (e.g., \"and,\" \"but\").",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 105
 },
 {
     "Id": 114,
     "AgeGroup": "3-4 years",
     "Category": "Communication\/ Speech",
     "Question": "Understanding of prepositions: Shows understanding of spatial prepositions, such as \"in,\" \"on,\" \"under.\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 115,
     "AgeGroup": "3-4 years",
     "Category": "Cognitive",
     "Question": "Can your child sort objects by different categories like color and shape?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 106
 },
 {
     "Id": 116,
     "AgeGroup": "3-4 years",
     "Category": "Cognitive",
     "Question": "Does your child realize that others can have different thoughts and feelings?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 107
 },
 {
     "Id": 117,
     "AgeGroup": "3-4 years",
     "Category": "Social & Emotional",
     "Question": "Engages in cooperative play (working together toward a common goal).\n   E.g. \"Does your child play games with other children where they need to work together, like building a tower of blocks?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 108
 },
 {
     "Id": 118,
     "AgeGroup": "3-4 years",
     "Category": "Social & Emotional",
     "Question": "Begins to understand and occasionally exhibit sharing behaviors.\n   E.g. \"Does your child understand the concept of taking turns or sharing toys?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 109
 },
 {
     "Id": 119,
     "AgeGroup": "3-4 years",
     "Category": "Sensory Development",
     "Question": "Shows increased manual dexterity, such as using scissors or drawing shapes.\n  - \"Can your child manipulate small objects or start to use scissors?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 110
 },
 {
     "Id": 120,
     "AgeGroup": "3-4 years",
     "Category": "Sensory Development",
     "Question": "Begins to develop spatial awareness and understand concept of time.\n  - \"Does your child understand 'near' and 'far', 'before' and 'after'?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 48,
     "RS": "ACTIVE",
     "Sequnce": 111
 },
 {
     "Id": 121,
     "AgeGroup": "4-5 years",
     "Category": "Gross Motor",
     "Question": "Can the child hop consecutively?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 112
 },
 {
     "Id": 122,
     "AgeGroup": "4-5 years",
     "Category": "Gross Motor",
     "Question": "Can the child balance on one foot for 10 seconds?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 113
 },
 {
     "Id": 123,
     "AgeGroup": "4-5 years",
     "Category": "Gross Motor",
     "Question": "Can the child run smoothly?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 114
 },
 {
     "Id": 124,
     "AgeGroup": "4-5 years",
     "Category": "Gross Motor",
     "Question": "Can the child catch a small bouncing ball?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 115
 },
 {
     "Id": 125,
     "AgeGroup": "4-5 years",
     "Category": "Fine Motor",
     "Question": "Can cut out simple shapes: This shows further development of fine motor skills and hand-eye coordination.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 116
 },
 {
     "Id": 126,
     "AgeGroup": "4-5 years",
     "Category": "Fine Motor",
     "Question": "Can copy some capital letters: This requires good fine motor control and the understanding of more complex shapes.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 117
 },
 {
     "Id": 127,
     "AgeGroup": "4-5 years",
     "Category": "Communication\/ Speech",
     "Question": "Fluent speech: Most speech is intelligible and has appropriate rhythm and rate.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 118
 },
 {
     "Id": 128,
     "AgeGroup": "4-5 years",
     "Category": "Communication\/ Speech",
     "Question": "Narrative skills: Can tell a simple story using complete sentences.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 119
 },
 {
     "Id": 129,
     "AgeGroup": "4-5 years",
     "Category": "Cognitive",
     "Question": "Does your child understand that the amount of water remains the same whether it's in a tall glass or a short wide bowl?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 130,
     "AgeGroup": "4-5 years",
     "Category": "Cognitive",
     "Question": "Can your child solve simple math problems using physical objects, like blocks or fingers?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 120
 },
 {
     "Id": 131,
     "AgeGroup": "4-5 years",
     "Category": "Social & Emotional",
     "Question": "Can verbally identify and discuss their own emotions and those of others.\n   E.g. \"Can your child talk about how they're feeling? Can they understand how others might feel in different situations?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 121
 },
 {
     "Id": 132,
     "AgeGroup": "4-5 years",
     "Category": "Social & Emotional",
     "Question": "Shows increasing independence and may start to form friendships.\n   E.g. \"Does your child show signs of independence? Do they have any favorite friends they prefer to play with?\"\n",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "ACTIVE",
     "Sequnce": 122
 },
 {
     "Id": 133,
     "AgeGroup": "4-5 years",
     "Category": "Sensory Development",
     "Question": "Exhibits refined visual perceptual skills, such as identifying letters and numbers.\n  - \"Can your child recognize and name common letters and numbers?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 134,
     "AgeGroup": "4-5 years",
     "Category": "Sensory Development",
     "Question": "Demonstrates understanding of more complex spatial relationships, like 'under', 'above', 'behind'.\n  - \"Can your child understand and follow instructions related to spatial relationships?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 60,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 135,
     "AgeGroup": "5-6 years",
     "Category": "Gross Motor",
     "Question": "Can the child skip and gallop?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 123
 },
 {
     "Id": 136,
     "AgeGroup": "5-6 years",
     "Category": "Gross Motor",
     "Question": "Can the child balance on one foot for more than 10 seconds?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 137,
     "AgeGroup": "5-6 years",
     "Category": "Gross Motor",
     "Question": "Can the child swing and climb with agility?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 124
 },
 {
     "Id": 138,
     "AgeGroup": "5-6 years",
     "Category": "Fine Motor",
     "Question": "Can write some or all letters and numbers: This is a complex task that involves cognitive understanding as well as fine motor control.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 125
 },
 {
     "Id": 139,
     "AgeGroup": "5-6 years",
     "Category": "Fine Motor",
     "Question": "Can cut out a wider range of shapes: This demonstrates further development of fine motor skills.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 126
 },
 {
     "Id": 140,
     "AgeGroup": "5-6 years",
     "Category": "Communication\/ Speech",
     "Question": "Language complexity: Uses complex sentences, understands and uses conditional phrases (e.g., \"if...then\").",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 127
 },
 {
     "Id": 141,
     "AgeGroup": "5-6 years",
     "Category": "Communication\/ Speech",
     "Question": "Understanding of temporal sequences: Understands order of events and can retell a story in order.",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 128
 },
 {
     "Id": 142,
     "AgeGroup": "5-6 years",
     "Category": "Cognitive",
     "Question": "Can your child think hypothetically or make predictions about the future?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 129
 },
 {
     "Id": 143,
     "AgeGroup": "5-6 years",
     "Category": "Cognitive",
     "Question": "Does your child understand that if they were to first add two blocks to a pile of three blocks and then remove those two blocks, they would end up with the original three blocks?",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 144,
     "AgeGroup": "5-6 years",
     "Category": "Social & Emotional",
     "Question": "Begins to understand and conform to social norms and rules.\n   E.g. \"Does your child understand common rules and expectations, like waiting their turn?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 130
 },
 {
     "Id": 145,
     "AgeGroup": "5-6 years",
     "Category": "Social & Emotional",
     "Question": "Exhibits improved emotional self-regulation.\n   E.g. \"Does your child show more control over their emotions, like calming down more quickly after being upset?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 131
 },
 {
     "Id": 146,
     "AgeGroup": "5-6 years",
     "Category": "Sensory Development",
     "Question": "Shows mature fine motor skills, such as tying shoelaces.\n  - \"Can your child complete tasks that require fine motor skills, like buttoning a shirt or tying shoelaces?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "ACTIVE",
     "Sequnce": 132
 },
 {
     "Id": 147,
     "AgeGroup": "5-6 years",
     "Category": "Sensory Development",
     "Question": "Exhibits mature spatial and temporal understanding, such as understanding maps or sequencing events.\n  - \"Can your child follow along with a simple map? Can they understand and sequence events in a story?\"",
     "Type": "Radio",
     "Options": "Yes,No",
     "Age": 72,
     "RS": "DELETEACTIVITY"
 },
 {
     "Id": 148,
     "AgeGroup": "Learning Style",
     "Category": "Learning Style",
     "Question": "Child's preferred learning style",
     "Type": "Radio",
     "Options": "Visual-Spatial Learners: \n    - Does your child remember visuals well like images or diagrams?\n   - Do they enjoy drawing painting or watching videos?\n    - Do they organize their thoughts by creating mind maps or flowcharts?,\nAuditory-Musical Learners:\n    - Does your child remember information better after hearing it?\n    - Do they enjoy songs rhythms or rhymes?\n    - Do they prefer to have stories read out loud to them?,\nVerbal-Linguistic Learners:\n    - Does your child enjoy reading and writing?\n    - Do they express themselves well in words both spoken and written?\n    - Do they enjoy word games poetry or journaling?,\nPhysical-Kinesthetic Learners:\n    - Does your child learn by doing and touching?\n    - Do they enjoy hands-on activities or crafts?\n    - Do they move around a lot while thinking or expressing a point?,\n Logical-Mathematical Learners:\n    - Does your child enjoy working with numbers patterns or puzzles?\n    - Do they like to conduct experiments or figure out how things work?\n    - Do they prefer structured environments and logical reasoning?,\nSocial-Interpersonal Learners:\n    - Does your child enjoy group activities and discussions?\n    - Do they learn better when they can share and collaborate with others?\n    - Do they often seek advice from family members or friends when facing difficulties?,\nSolitary-Intrapersonal Learners:\n    - Does your child prefer studying alone or need quiet time for reflection?\n    - Do they enjoy independent tasks like reading or creative writing?\n    - Do they understand their feelings and thoughts better when they have some alone time?",
     "Age": 1,
     "RS": "ACTIVE",
     "Sequnce": 133
 }
];

GetMappedValues(kid) {
 return (kid.MileStone || "").split(",").map(function (m) { return { Q: m.substring(0, m.length - 1), V: m.substring(m.length - 1, m.length) } })
}
IsAllMileStoneQuestionsAnsweredForKPI(kid) {
 if (!kid) {
     return false;
 }
 var months = this.getMonthDifference(new Date(kid.DOB ? kid.DOB : kid.CDT), new Date())
 var filteredQuestions = this.MileStoneQuestions.filter(f => f.Age <= months && f.RS != "DELETEACTIVITY");
 var response = this.GetMappedValues(kid);
 var qids = response.filter(f => f);
 return (qids || []).length >= filteredQuestions.length;
}

  getSlotsByDataByTherapist(therapies,compos,leaves,types, user, date) {

    var isSaturDay = false;
    try {
        var date = new Date(date);
        var  data = []; //CF ERROR FIXING NEED TO FIND DATA
        isSaturDay = date.getDay() === 6;
        if (isSaturDay && data && data.length > 0) {

            data = data.filter(function (e) { return e.AT != "USERSERVICE" });
        }

    } catch (e) {

    }


    var tleave = leaves.map(m => m.TOId == user.Id);
    if (tleave && tleave.length > 0) {
        return;
    }
    try {
        var parentLeaves = leaves.map(function (e) { return e.TOId });


        therapies = therapies.filter(function (e) { return !(parentLeaves.indexOf(e.BossId) > -1) && e.RS != "DELETEACTIVITY" });
    } catch (e) {

    }

    therapies = therapies || [];

    if (compos && compos.length > 0) {
        var obj = {};
        for (var i = 0; i < compos.length; i++) {
            try {
                obj.TherapistId = compos[i].CBPI;
                obj.Time = compos[i].Status;
                obj.TypeId = parseInt(compos[i].TypeId);
                obj.BossId = parseInt(compos[i].HomeWork);
                therapies.push(obj);
            } catch (e) {

            }
            
        }
       
    }
    var serviceType = this.GetServiceType(user.Designation.trim());
    var summary = [];
    var serviceId = types.filter(f => f.Name && f.Name == serviceType)[0].Id;
   
    if (!therapies || therapies.length == 0) {

        
        var cloud =
        {
            TherapistId: user.Id,
            Name: user.Name,
            TypeId: serviceId,
            CenterId: user.CenterId
        }

        var cservices = this.CalcSlotsMC("8:45", "19:01", cloud);
        if (cservices && cservices.length > 0) {
            summary.push(...cservices);
        }



    }
    else {
        if (therapies && therapies.length > 0) {
            var sortedServices = therapies.sort(function (a, b) {
                return this.GetTimeSlotTotal(a.Time) - this.GetTimeSlotTotal(b.Time);
            });
            console.log(sortedServices);

            var first = sortedServices[0];
            var last = sortedServices[sortedServices.length - 1];
            if (this.GetTimeSlotTotal(first.Time) > 570) {
                var cservices = this.CalcSlotsMC("8:45", first.Time, first);
                if (cservices && cservices.length > 0) {
                    summary.push(...cservices);
                }
            }
            for (var i = 0; i <= sortedServices.length - 1; i++) {
                // tServices[i].RS = Utility.GetMeridiem(time1);
                sortedServices[i].S = "Fill";
                sortedServices[i].F7 = this.GetTimeSlotTotal(sortedServices[i].Time);
                summary.push(sortedServices[i]);
                if (sortedServices.length - 1 != i) {
                    var cservices = this.CalcSlotsMC(sortedServices[i].Time, sortedServices[i + 1].Time, first);
                    if (cservices && cservices.length > 0) {
                        summary.push(...cservices);
                    }
                }
            }

            if (this.GetTimeSlotTotal(last.Time) + 45 < 1140) {
                var cservices = this.CalcSlotsMC(last.Time, "19:01", first);
                if (cservices && cservices.length > 0) {
                    summary.push(...cservices);
                }
            }




        }
    }
    try {
        if (isSaturDay && summary && summary.length > 0) {
            var alreadybooked = summary.filter(function (e) { return e.S != 'Fill' && this.GetTimeSlotTotal(e.Time) >= 660 && this.GetTimeSlotTotal(e.Time) < 750 });
            if (alreadybooked && alreadybooked.length > 0) {
                for (var i = 0; i < alreadybooked.length; i++) {
                    alreadybooked[i].S = 'Fill';
                }
            }
        }
    } catch (e) {

    }


    try {

    } catch (e) {

    }
    return summary;
}

getDateByType(type) {
 var currentDate = new Date();


 if (type == 'today') {

     return currentDate;
 }
 else if (type == 'tomorrow') {

     return currentDate;
 }

 else if (type == 'thisweekstart') {
     var firstdayofWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1));
     return firstdayofWeek;
 }
 else if (type == 'thisweekend') {
     var lastdayofWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
     return lastdayofWeek;
 }
 else if (type == 'nextweekend') {
     var lastdayofnextWeek = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 13));
     return lastdayofnextWeek;
 }
}
 getDatesInRange(startDate, endDate) {
    const date = new Date(startDate.getTime());

    const dates = [];

    while (date <= endDate) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }

    return dates;
}

 getTimeDay(date) {
    var param1 = new Date();
    var start_actual_time = new Date(date);
    // alert(start_actual_time + ' ' + end_actual_time);
    var diff = param1 - start_actual_time;
    var diffSeconds = diff / 1000;

    var hh = start_actual_time.getHours();
    var min = start_actual_time.getMinutes();
    var s = start_actual_time.getSeconds();

    var ampm = (hh >= 12) ? 'PM' : 'AM';
    hh = hh % 12;

    var time = hh + ":" + min + " " + ampm;


    // alert(HH);
    if (start_actual_time.getDate() == param1.getDate()) {
        return "Today " + time;
    }
    else if (start_actual_time.getDate() == (param1.getDate() - 1)) {
        return "Yesterday " + time;
    }
    else {
        // return HH + " Hours ago";
        var monthstring = parseInt(start_actual_time.getMonth() + 1);
        if (monthstring <= 9) {
            monthstring = "0" + monthstring;
        }

        return start_actual_time.getDate() + "/" + monthstring + "/" + start_actual_time.getFullYear() + " " + time;
    }
}

 getTimeSpan(date) {
    var param1 = new Date();
    var start_actual_time1 = new Date(date);

    var start_actual_time = Date.parse(start_actual_time1);//start_actual_time1.setMinutes(start_actual_time1.getMinutes() - 330);

    var epochTime = Date.parse(param1);
    var diff = epochTime - start_actual_time;

    var diffSeconds = diff / 1000;
    var HH = parseInt(Math.floor(diffSeconds / 3600));
    var MM = parseInt(Math.floor(diffSeconds % 3600) / 60);

    if (HH < 1) {
        if (MM <= 1) {
            return "Few Seconds ago";
        }
        else {
            return MM + " Minutes ago";
        }
    }
    else if (HH < 23) {
        return HH + " Hours ago";
    }
    else if (HH > 23 && HH < 36) {
        return "Yesterday";
    }
    else if (HH > 36 && HH < 150) {
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days[start_actual_time1.getDay()];
    }
    else {
        return start_actual_time1.getDate() + "-" + (start_actual_time1.getMonth() + 1) + "-" + start_actual_time1.getFullYear();
    }
}

 getTime(date) {
    var param1 = new Date();
    var start_actual_time = new Date(date);
    var min = start_actual_time.getMinutes();
    if (min <= 9) {
        min = "0" + min
    }
    return start_actual_time.getHours() + " : " + min;
}


 invoicePrices = [18000, 15000, 16333, 14500, 14000, 10417, 12000, 10000, 8333, 9999, 8334, 9416, 9417, 9360, 9333, 10416, 10418, 9167, 9166, 8335, 21960, 19926, 19927, 17690, 14640];
 servicesOfeering = [
    { Name: "behavioral modification", Id: 4,ShortName:"BT" },
    { Name: "occupational therapy", Id: 3,ShortName: "OT" },
    { Name: "special education", Id: 6, ShortName: "SE" },
    { Name: "speech therapy", Id: 1, ShortName: "ST" }
];


 KidStateCategoryEnum = {
 Condition: 398,
 Tantrum: 399
};
  GetTypeIdByName(types, name) {
    try {
        let returnData = types.filter(f => f.Name == name)[0];
        if (returnData) {
            return returnData.Id;
        }
        return 0;
    } catch (e) {

    }
}

  GetTypeNameById(types, Id) {
    try {
        let returnData = types.filter(f => f.Id == Id)[0];
        if (returnData) {
            return returnData.Name;
        }
        return 0;
    } catch (e) {

    }
}


 CalcSlotsMC(start, end, service) {
    try {

        var tsStart = this.GetTimeSlotTotal(start);
        var tsEnd = this.GetTimeSlotTotal(end);

        var availableSlots = [];
      //  console.log(tsStart);
      //  console.log(tsEnd);
        var time = 45;

        while (tsStart < tsEnd) {
            tsStart = tsStart + time;
            if (tsStart + time <= tsEnd) {
                var timeString = (tsStart % 60) + "";
                timeString = timeString.length == 0 ? "00" : timeString.length == 1 ? "0" + timeString : timeString;
                availableSlots.push(
                    {
                        TherapistId: service.TherapistId,
                        TypeId: service.TypeId,
                        Time: Math.floor(tsStart / 60) + ":" + timeString,

                        S: "available",
                        F7: tsStart
                    });
            }


        }
        return availableSlots;
    }
    catch (Exception) {

        console.log(Exception);
    }
}

  getSlotsByData(therapies, therapistsData) {
    console.log('getSlotsByData')
    var summary = [];

    therapies = therapies || [];
    var $this = this;
    var therapists = Object.entries(this.groupBy(therapies, "TherapistId"));
    var alreadyTaking = therapists.map(m => parseInt(m[0]));
    var nottaking = therapistsData.filter(f => alreadyTaking.indexOf(f.Id) == -1);
    if (nottaking && nottaking.length > 0) {
       for(var i=0;i<nottaking.length;i++)
       {
         var e= nottaking[i];
        //nottaking.forEach(function (e) {
            /* var fId = (data.Facilities.filter(function (m) { return (null != e.MG && e.MG.indexOf(parseInt(m._key)) > -1) || (null != e.AG && e.AG.indexOf(parseInt(m._key)) > -1) })[0]);*/
            var fId = 0;
            var cloud =
            {
                F3: e.RDT,
                TypeId: $this.GetServiceType(e.Designation ? e.Designation : ""),
                FId: 0,
                TherapistId: e.Id,
            }

            var cservices = $this.CalcSlotsMC("8:45", "19:00", cloud);
            if (cservices && cservices.length > 0) {
                summary.push(...cservices);
            }

        }
    }

    if (therapists && therapists.length > 0) {

       // therapists.forEach(function (e) {
          for(var j=0;j<therapists.length;j++)
          {
             var e= therapies[i];
            var services = e[1];
            if (services && services.length > 0) {
                var sortedServices = services.sort(function (a, b) {
                    return $this.GetTimeSlotTotal(a.Time) - $this.GetTimeSlotTotal(b.Time);
                });

                var first = sortedServices[0];
                var last = sortedServices[sortedServices.length - 1];

                if ($this.GetTimeSlotTotal(first.Time) > 570) {


                    var cservices = $this.CalcSlotsMC("8:45", first.Time, first);
                    if (cservices && cservices.length > 0) {
                        summary.push(...cservices);
                    }

                }


                for (var i = 0; i <= sortedServices.length - 1; i++) {


                    // tServices[i].RS = Utility.GetMeridiem(time1);
                    // summary.Add(tServices[i]);

                    if (sortedServices.length - 1 != i) {
                        var cservices = $this.CalcSlotsMC(sortedServices[i].Time, sortedServices[i + 1].Time, first);
                        if (cservices && cservices.length > 0) {
                            summary.push(...cservices);
                        }
                    }
                }

                if ($this.GetTimeSlotTotal(last.Time) + 45 < 1140) {
                    var cservices = $this.CalcSlotsMC(last.Time, "19:00", first);
                    if (cservices && cservices.length > 0) {
                        summary.push(...cservices);
                    }
                }




            }

        }


    }
    return summary;
}


  GetAllTherapistsData(data, isUserTherapist, fids) {
    if (!(data && data.People)) {
        return;
    }

    var people = data.People;
    var therapiesAll = data.Therapies;
    therapiesAll = therapiesAll || [];
    people = people || [];
    var facilityTherapies = data.FacilityTherapies || [];
    var facilityPeople = data.FacilityPeople || [];
    people.push(...facilityPeople);
    therapiesAll.push(...facilityTherapies);
    try {
    //var fids = [];
    if (!fids) {
        fids = data.Centers.map(m => m.Id);
    }
    

    var therapistRoleId = this.GetTypeIdByName(data.Types, "Therapist");
        var therapists = Object.entries(this.groupBy(people.filter(f => therapistRoleId == f.RoleId && fids.indexOf(f.CenterId) > -1), "Id")).map(m => m[1][0]);
        var therapies = therapiesAll ? therapiesAll.filter(f =>  fids.indexOf(f.CenterId) > -1) : [];

        var serviceIds = Object.entries(this.groupBy(therapiesAll, "BossId"));




    var pollination = [];
    for (var i = 0; i < this.servicesOfeering.length; i++) {
        var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(this.servicesOfeering[i].Id) == -1).map(m => m[0]);
        boss = (boss || []);

        for (var b = 0; b < boss.length; b++) {
            pollination.push({ BossId: boss[b], ServiceId: this.servicesOfeering[i].Id, ShortName: this.servicesOfeering[i].ShortName });
        }
    }

    var therapistsData = [];
    for (var i = 0; i < therapists.length; i++) {
        var therapist = { ...therapists[i] };
        var bossIds = therapiesAll.filter(f => f.TherapistId == therapist.Id).map(m => m.BossId+"");
        therapist.C = 0;
        if (bossIds) {
            var pollinations = pollination.filter(f => bossIds.indexOf(f.BossId) > -1);
            pollinations = pollinations || [];
            var psString = Object.entries(this.groupBy(pollinations, "ShortName")).map(m => m[0] + ":" + m[1].length);
            therapist.Pollination = pollinations;
            therapist.PC = pollinations.length;
            therapist.C = bossIds.length;
            therapist.Pollinate = psString;
            if (!isUserTherapist) {
                therapist.Totals = therapies.length;
            }
        }
        therapist.F1 = this.GetShortDesignation(therapist.Designation) + ", " + therapist.C + " kids";

        therapistsData.push(therapist);
    }


        return therapistsData;
    } catch (e) {
        return [];
    }
}

GetReportsData(type, dataConst, isItKPI, FDT, TDT, facility) {
 try {

  var $$this = this;
     isItKPI = isItKPI || false;



     /*DateTime seetaDateString = DateTime.Now.Date < to.Date ? DateTime.Now.Date.AddDays(-8) : to.Date.AddDays(-8);*/

     switch (type.toLowerCase()) {
         case "kuberamonthlyfee":
             if (dataConst.Fee && dataConst.Fee.length > 0) {
                 var filtered = dataConst.Fee.filter(m => m.Amount == 21960 || m.Amount == 25229).map(m => m.BOSSId).filter(this.onlyUnique);
                 if (isItKPI) {
                     return filtered;
                 }
             }
             else {
                 return [];
             }
             break;
         case "kuberamissing":

             if (dataConst.Therapies) {
                 dataConst.Fee = dataConst.Fee || [];
                 var ids = dataConst.Fee ? dataConst.Fee.filter(f => f.Type && f.Type.toLowerCase() == "services").map(m => m.ServiceId) : [];
                 TDT = TDT >= new Date() ? new Date() : TDT;
                 return dataConst.Therapies.filter(f => ids.indexOf(f.Id) == -1 && $$this.dateFromSDateTime(f.StartDate) <= TDT && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE");

             }
             else {
                 return [];
             }

             break;
         case "kuberaabnormal":

             if (dataConst.Fee && dataConst.Fee.length > 0) {

                 var filtered = dataConst.Fee.filter(f => f.Type && f.Type.toLowerCase() == "services").filter(m => $$this.invoicePrices.indexOf(m.Amount) == -1);
                 if (isItKPI) {
                     return filtered;
                 }
             }
             else {
                 return [];
             }

             break;
         case "allinvoicesthismonth":

             if (dataConst.Fee && dataConst.Fee.length > 0) {

                 var filtered = dataConst.Fee;
                 if (isItKPI) {
                     return filtered;
                 }
             }
             else {
                 return [];
             }

             break;
         case "empwoer2monthly":
             var filtered = dataConst.Fee.filter(m => m.NoOfTherapies == 1).map(m => m.BOSSId).filter(this.onlyUnique);
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "empwoer2single":
             var therapy = dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE")
             var filtered = $$this.groupBy(therapy, "BossId");
             if (isItKPI) {
                 return Object.values(filtered).filter(f => f.length == 1);
             }
             break;
         case "empwoer2lostparents":
             var filtered = $$this.groupBy(dataConst.InActive, "BossId");
             if (isItKPI) {
                 return Object.keys(filtered);
             }
             break;
         case "mirraclestotal":
             var filtered = dataConst.MirraclesData ? dataConst.MirraclesData : "";
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "mirraclescontributed":
             var filtered = dataConst.MirraclesData ? Object.keys($$this.groupBy(dataConst.MirraclesData, "PersonId")) : "";
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "mnotcontributed":
             var adminId = dataConst.Types.filter(m => m.Name == "Receptionist")[0].Id;
             var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
             var filtered = Object.keys($$this.groupBy(dataConst.People.filter(m => (m.RoleId == therapistId || m.RoleId == adminId) && m.F8 != 1 && m.RS != "DELETEACTIVITY"), "Id"))

             return filtered;

             break;
         case "allmirraclesviews":
             var mirraclesview = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && $$this.dateFromSDateTime(f.UDT) >= FDT && $$this.dateFromSDateTime(f.UDT) <= TDT)) : "";
             var filtered = (mirraclesview || []).reduce(function (accumulator, item) {
                 return accumulator + item.F8;
             }, 0);
             if (isItKPI) {
                 return filtered;
             }
             break
         case "mirraclestop100":
             var top100Mirracles = (dataConst.MirraclesData || []).slice(0, 99).map(m => m.Id);

             var filtered = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && $$this.dateFromSDateTime(f.UDT) >= FDT && $$this.dateFromSDateTime(f.UDT) <= TDT)).filter(m => top100Mirracles.indexOf(m.Id) > -1) : "";
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "mirraclesbottom100":
             var bottom100Mirracles = (dataConst.MirraclesData || []).slice(-100).map(m => m.Id);
             var filtered = dataConst.MirraclesData ? dataConst.MirraclesData.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) || (f.UDT && $$this.dateFromSDateTime(f.UDT) >= FDT && $$this.dateFromSDateTime(f.UDT) <= TDT)).filter(m => bottom100Mirracles.indexOf(m.Id) > -1) : "";
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "mirracleslc":
             var filtered = Object.keys($$this.groupBy(dataConst.MirraclesData, "LanguageId"));
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "mirraclesnotcovered":
             var languageIds = dataConst.Types.filter(m => m.Category == "Languages").map(m => m.Id);
             var languages = Object.keys($$this.groupBy(dataConst.MirraclesData, "LanguageId"));
             var filtered = languageIds.length - languages.length;
             if (isItKPI) {
                 return filtered;
             }
             break;



         case "renewals":
             dataConst.FutureInvoices = dataConst.FutureInvoices || [];
             var currentInvoices = dataConst.Fee.filter(f => f.NoOfTherapies > 1);
             var ids = (currentInvoices || []).map(m => m.BOSSId)
             var futureInvoiceCreatedOld = dataConst.FutureInvoices.filter(f => $$this.dateFromSDateTime(f.CDT) < FDT);
             //var futureInvoiceCreatedInthisMonth = dataConst.FutureInvoices.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT);
             var futureInvoiceCreatedInthisMonth = dataConst.FutureInvoicesCDTThisMonth;
             var bossIds = Object.entries($$this.groupBy(dataConst.Therapies.filter(f => ids.indexOf(f.BossId) > -1 && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE"), "BossId"));
             var renewals = [];
             futureInvoiceCreatedOld = futureInvoiceCreatedOld || [];
             futureInvoiceCreatedInthisMonth = futureInvoiceCreatedInthisMonth || [];
             for (var i = 0; i < bossIds.length; i++) {
                 var bid = parseInt(bossIds[i][0]);
                 var length = bossIds[i][1].length;
                 var invoiceslength = futureInvoiceCreatedOld.filter(f => f.BOSSId == bid).length;
                 if (length > invoiceslength) {
                     var status = futureInvoiceCreatedInthisMonth.filter(f => f.BOSSId == bid);
                     var currentInvoice = currentInvoices.filter(f => f.BOSSId == bid);
                     var invoice = {
                         ...bossIds[i][1][0], Renewed: status && status.length > 0 ? "Yes" : "No", Package: (currentInvoice[0].NoOfTherapies)
                     }
                     renewals.push(invoice);
                 }
             }

             if (isItKPI) {
                 return renewals;
             }

         case "seetatotal":
         case "seetapending":
         case "seetapartiallypaid":
         case "seetapaid":
         case "seetakids":
         case "seetaallinvoicedata":
             var cDT = TDT > new Date() ? new Date() : TDT;// new Date(TDT.toString());
             cDT.setDate(cDT.getDate() - 10);
             var start = new Date();
             var t = dataConst.Attendance;//.filter(f =>  f.ForDate >= cDT);
             console.log("seetaallinvoicedata time", $$this.GetDateDiff(start, new Date()));
             t = t || [];
             var values = Object.entries($$this.groupBy(t, "ServiceId"));

             var filtered = values.filter(f => f[1][0] && f[1][0].Status == "Absent" && f[1][1] && f[1][1].Status == "Absent" && f[1][2] && f[1][2].Status == "Absent");


             if (type.toLowerCase() == "seetatotal") {
                 return filtered;
             }

             if (filtered && filtered.length > 0) {

                 var ids = filtered.map(function (m) { return { "A": (m[0]) } });
                 var groupedIds = $$this.groupBy(ids, "A");
                 //var bossIds = Object.keys();
                 var therapiesGroup = $$this.groupBy(dataConst.Therapies.filter(f => groupedIds && (groupedIds[f.Id] || []).length > 0 && f.RS != "DELETEACTIVITY" && (!f.Status || f.Status.toUpperCase() != "INACTIVE")), "BossId");
                 if (type.toLowerCase() == "seetakids") {
                     return Object.keys(therapiesGroup);
                 }
                 dataConst.Fee = dataConst.Fee || [];
                 var invoices = dataConst.Fee.filter(f => f.Type != "ASSESSMENTS" && (therapiesGroup && therapiesGroup[f.BossId] || []).length > 0);
                 if (type.toLowerCase() == "seetaallinvoicedata") {
                     return invoices;
                 }
                 if (type.toLowerCase() == "seetapending") {
                     return invoices.filter(f => !f.Status);
                 }
                 else if (type.toLowerCase() == "seetapartiallypaid") {
                     return invoices.filter(f => f.Status == "PARTIALLYPAID");
                 }
                 else if (type.toLowerCase() == "seetapaid") {
                     return invoices.filter(f => f.Status == "PAID");
                 }

             }


             if (isItKPI) {
                 return filtered;
             }
             break;
         case "goalspending":
             try {
                 //var therapiesfiltered = dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE").map(t => t.Id) : [];
                 //var therapiesfiltered = dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
                 var groupedTherapies = dataConst.Therapies ? $$this.groupBy(dataConst.Therapies, "Id") : [];
                 var filteredgoaldata = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(t => groupedTherapies && groupedTherapies[t.TherapyId] && groupedTherapies[t.TherapyId].length > 0).sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1)).map(x => [x.TherapyId, $$this.dateFromSDateTime(x.CDT)]) : []
                 var goalDictionary = filteredgoaldata && filteredgoaldata.length > 0 && dataConst.Goals.length > 0 ? Object.fromEntries(filteredgoaldata) : null;
                 var attendanceForGoals = goalDictionary != null && dataConst.Attendance ? dataConst.Attendance.filter(m => m.Status == 'Present' && goalDictionary && goalDictionary[m.ServiceId] && $$this.dateFromSDateTime(m.ForDate) >= (goalDictionary[m.ServiceId])) : [];
                 var attendanceDictionary = attendanceForGoals ? $$this.groupBy(attendanceForGoals, "ServiceId") : null;
                 var allGoalsPending = attendanceDictionary && dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(m => groupedTherapies && groupedTherapies[m.TherapyId] && groupedTherapies[m.TherapyId].length > 0 && attendanceDictionary && attendanceDictionary[m.TherapyId] && (m.Services - 1) <= attendanceDictionary[m.TherapyId].length && m.Review == null) : [];
                 return allGoalsPending;
             } catch (error) {
                 console.log(error)
                 return [];
             }
             break;
         case "goalsnotset":
             var dt = new Date()
             var filtered = [];
             var therapiesfiltered = dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE")
             // $.each(therapiesfiltered, function (key, therapy) {
             //     let currentGoal = $.grep(dataConst.Goals, function (e) { return e.TherapyId == therapy.Id })[0];
             //     if (!currentGoal) {
             //         filtered.push(therapy);
             //     }
             // });

             var goalsforTherapy = dataConst.Goals ? dataConst.Goals.map(e => e.TherapyId) : []
             var therapiesData = dataConst.Therapies.filter(e => goalsforTherapy && goalsforTherapy.indexOf(e.Id) == -1);
             var dat = new Date()
             console.log("goal not set", $$this.GetDateDiff(dt, dat))
             return therapiesData;
             break;
         case "aigoalsnotset":
             var therapies = (dataConst.Therapies).filter(f =>  f.RS != "DELETEACTIVITY"  && f.Status!="INACTIVE" && new Date(f.StartDate) <= new Date());
             var tIds = (therapies || []).map(m => m.Id);

             var allGoals = dataConst.Goals.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && f.Status!="REVIEWED" && f.AIId && tIds.indexOf(f.TherapyId) > -1);
             var setGoals=(allGoals || []).map(e=>e.TherapyId);
             var TherapyForGoals=therapies.filter(e=>setGoals && setGoals.indexOf(e.Id) == -1)
             return TherapyForGoals;
         break;
         case "homeworkpending":

             var fIds = (dataConst.Feedback || []).map(m=> m.AttendanceId);
             var therapies = (dataConst.Therapies).filter(f =>  f.RS != "DELETEACTIVITY"  && f.Status!="INACTIVE" && new Date(f.StartDate) <= new Date());
             var tIds = (therapies || []).map(m => m.Id);
            
             return dataConst.Attendance.filter(f=> tIds.indexOf(f.ServiceId) > -1 && $$this.dateFromSDateTime(f.ForDate) >= FDT  &&  $$this.dateFromSDateTime(f.ForDate) <= TDT && f.Status && f.Status.toLowerCase() == 'present' && fIds.indexOf(f.Id) == -1);

             var filtered = dataConst.Attendance.filter(m => m.Status && m.Status.toLowerCase() == 'present' && m.Feedback == 0);
             if (isItKPI) {
                 return filtered;
             }
             break;
             
             case "homeworkcompleted":

             var fIds = (dataConst.Feedback || []).map(m=> m.AttendanceId);
             //var therapies = (dataConst.Therapies).filter(f =>  f.RS != "DELETEACTIVITY"  && f.Status!="INACTIVE" && new Date(f.StartDate) <= new Date());
           //  var tIds = (therapies || []).map(m => m.Id);
            
             return dataConst.Attendance.filter(f=> $$this.dateFromSDateTime(f.ForDate) >= FDT  &&  $$this.dateFromSDateTime(f.ForDate) <= TDT && f.Status && f.Status.toLowerCase() == 'present' && fIds.indexOf(f.Id) > -1);

             var filtered = dataConst.Attendance.filter(m => m.Status && m.Status.toLowerCase() == 'present' && m.Feedback == 0);
             if (isItKPI) {
                 return filtered;
             }
             break;

         case "homeworkgiven":
             var filtered = dataConst.Attendance.filter(m => m.Status && m.Status.toLowerCase() == 'present');
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "feespending":
             return [];
             break;
         case "kpiattendancepending":
             var todayDate = new Date();
             TDT = TDT >= todayDate ? todayDate : TDT;
             var services = dataConst.Therapies ? dataConst.Therapies.filter(r => r.RS != "DELETEACTIVITY" && r.Status != "INACTIVE") : [];
             var servicesforTherapist = services ? services.map(e => e.TherapistId) : []
             var leaves = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(r => r.RS != "DELETEACTIVITY" && FDT <= $$this.dateFromSDateTime(r.FDT) && $$this.dateFromSDateTime(r.FDT) <= TDT && r.TypeId == 234) : [];
             var groupByleaves = $$this.groupBy(leaves, "FDT")
             var excludecompos = dataConst.Compos ? dataConst.Compos.filter(m => m.RS != "DELETEACTIVITY" && FDT <= $$this.dateFromSDateTime(m.ForDate) && $$this.dateFromSDateTime(m.ForDate) <= TDT && servicesforTherapist.includes(m.CBPI)).map(e => e.Id) : [];
             //var excludecompos = composOfAll ? composOfAll.map(e => e.Id) : [];
             // var $$this.groupBycompos = composOfAll.reduce((Atttendances, val) => {
             //     var splitDate = val.ForDate.split(' ')[0];
             //     if (!Atttendances[splitDate]) {
             //         Atttendances[splitDate] = [];
             //     }
             //     Atttendances[splitDate].push(val);
             //     return Atttendances;
             // }, {});

             var currentTime = $$this.GetTimeSlotTotal(todayDate.getHours() + ":" + todayDate.getMinutes()) - 45;
             console.log("kpi att-1", $$this.GetDateDiff(todayDate, new Date()))

             //var $$this.groupBycompos=$$this.groupBy(composOfAll,"ForDate")
             var completedattendance = dataConst.Attendance ? dataConst.Attendance.filter(m => m.TypeId != 238 && (!excludecompos.includes(parseInt(m.F2)))) : [];
             var totalattendance = 0;
             var fdate = new Date(FDT);
             console.log("kpi att-2", $$this.GetDateDiff(todayDate, new Date()))
             var holidaysList = $$this.getUserSettingsValue("HOLIDAYSLIST");
             var specialHolidays = $$this.getUserSettingsValue("SpecialHolidays");
             var Atttendances = completedattendance.reduce((Atttendances, val) => {
                 var splitDate = val.ForDate.split(' ')[0];
                 if (!Atttendances[splitDate]) {
                     Atttendances[splitDate] = [];
                 }
                 Atttendances[splitDate].push(val);
                 return Atttendances;
             }, {});
             var specialHolidayDates = [];
             var arraySHD = specialHolidays.split("{#}");
             if (arraySHD) {
                 for(var i=0;i<arraySHD.length;i++)
                 {
                     var val = arraySHD[i];
                 //arraySHD.forEach(function (val, index) {
                     if (val) {
                         specialHolidayDates.push($$this.dateFromSDateTime(val.split("{=}")[0]));

                     }
                 }
             }

             var holidays = holidaysList ? JSON.parse(holidaysList) : [];
             console.log("kpi att-3", $$this.GetDateDiff(todayDate, new Date()))
             for (var date = fdate; date <= TDT; date.setDate(date.getDate() + 1)) {

                 if (new Date(date).getDay() == 6 || new Date(date).getDay() == 0) {
                     continue;
                 }
                 if (holidays) {
                     var onHoliday =holidays.filter(function (e) {
                         return $$this.mongodateforholidays(e.OccasionTo) >= date && $$this.mongodateforholidays(e.OccasionFrom) <= date
                     })[0];
                     if (onHoliday) {
                         continue;
                     }
                 }
                 if (specialHolidayDates) {

                     
                     var yesSpecialHoliday = specialHolidayDates.filter(function (e) { return e.getDate() == date.getDate() && e.getMonth() == date.getMonth() && e.getFullYear() == date.getFullYear() })[0]
                     if (yesSpecialHoliday) {
                         continue;
                     }
                 }
                 var currentDates = $$this.PSdateFormate(date);

                 //var composData = [];// ($$this.groupBycompos[currentDates.split(" ")[0]]) || [];
                 var isToday = new Date().toDateString() == date.toDateString();
                 //totalattendance += isToday ? (composData.filter(f=> GetTimeSlotTotal(f.Status) <= currentTime) || []).length : composData.length;
                 // var filteredCompos=composData?composData.filter(e=>new Date(e.ForDate).getDate()==new Date().getDate()? e.Status.split(":")[0]<=new Date().getHours():true):[]
                 //totalattendance+= (composData || []).length;
                 totalattendance -= Object.keys($$this.groupBy((Atttendances[currentDates.split(" ")[0]] || []), "ServiceId") || []).length;
                 //totalattendance-= (Atttendances[currentDates.split(" ")[0]] || []).length;

                 var leavesforday = groupByleaves[currentDates];
                 var leavesDate = leavesforday ? leavesforday.map(e => e.TOId) : [];

                 var activeservices = services.filter(e => $$this.dateFromSDateTime(e.StartDate).setHours(0, 0, 0) <= new Date(date) && (isToday ? $$this.GetTimeSlotTotal(e.Time) < currentTime : true) && (leavesDate ? (!leavesDate.includes(e.BossId) && !leavesDate.includes(e.TherapistId)) : true))
                 // if(activeservices){
                 //    var service= activeservices.map(e=>e.Id)
                 //    var attendancess=Atttendances[currentDates.split(" ")[0]]
                 //    var byattendance=attendancess?attendancess.filter(e=>service.indexOf(e.ServiceId) > -1):[]
                 //    totalattendance -= Object.keys($$this.groupBy((byattendance || []), "ServiceId") || []).length;
                 // }

                 totalattendance += ((activeservices || []).length);
                 //composOfAll[]
                 //var $$this.groupByattendance=$$this.groupBy(Atttendances,"ForDate");

                 //totalattendance-=$$this.groupBycompos[date].length;
             }
             var last = new Date();
             var hahh = $$this.GetDateDiff(todayDate, last)
             console.log(hahh, "date for attendance")
             return (totalattendance > 0 ? totalattendance : 0);

             break;
         case "attendancepending":

             console.log("Attendance ", new Date());
             var filtered = [];


             //var totalAttendance = dataConst.TWD * dataConst.Therapies.length;
             var todayDate = new Date();
             TDT = TDT >= todayDate ? todayDate : TDT;
             var todatlWorkingDays = $$this.GetTotalWorkingDaysExcludingSaturdays(FDT, TDT);
             var currentTime = $$this.GetTimeSlotTotal(todayDate.getHours() + ":" + todayDate.getMinutes()) - 45;

             var filteredoftherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];

             var leavsOfAll = dataConst.Leaverequestall.filter(m => FDT <= $$this.dateFromSDateTime(m.FDT) && $$this.dateFromSDateTime(m.FDT) <= TDT && m.RS != "DELETEACTIVITY")
             var composOfAll = dataConst.Compos.filter(m => m.ForDate && FDT <= $$this.dateFromSDateTime(m.ForDate) && $$this.dateFromSDateTime(m.ForDate) <= TDT);
             var atendanceexcludecompos = composOfAll.map(e => e.Id)
             // var filteredLeaves = Object.entries($$this.groupBy(leavsOfAll,"FDT")).map(m=> m[1][0]);
             var leavesGroup = $$this.groupBy(leavsOfAll, "TOId");
             var composGroup = $$this.groupBy(composOfAll, "ServiceId");
             var attendancesData = (dataConst.Attendance.filter(m => m.TypeId != 238 && !atendanceexcludecompos.includes(parseInt(m.F2))) || [])
             var presentattendancesData = (attendancesData.filter(m => m.Status && m.Status.toLowerCase() == "present") || []);
             var absentattendancesData = (attendancesData.filter(m => (!m.Status || m.Status.toLowerCase() != "present")) || []);

             var attendanceCounts = $$this.groupBy(attendancesData, "ServiceId");
             console.log("Attendance-v1 ", new Date());
             var totalAttendance = filteredoftherapies.reduce(function (accumulator, item) {

                 // item.StartDate=new Date(item.StartDate).setHours(0,0,0,0)
                 var due = (leavesGroup[item.BossId] || []);
                 due.push(...(leavesGroup[item.TherapistId] || []));
                 var filters = [];// due.filter(m=> ($$this.dateFromSDateTime(item.StartDate)) <=  $$this.dateFromSDateTime(m.FDT));
                 // var filters =  dataConst.Leaverequestall.filter(m=> (m.TOId == item.BossId || m.TOId == item.TherapistId) && ($$this.dateFromSDateTime(item.StartDate)) <=  $$this.dateFromSDateTime(m.FDT) && FDT <= $$this.dateFromSDateTime(m.FDT) && $$this.dateFromSDateTime(m.FDT) <= TDT);
                 var compos = [];//(composGroup[item.Id] || []);// (composGroup[item.Id] || []);// dataConst.Compos.filter(m=> m.ForDate && m.ServiceId == item.Id &&  FDT <= $$this.dateFromSDateTime(m.ForDate) && $$this.dateFromSDateTime(m.ForDate) <= TDT);

                 var total = ($$this.dateFromSDateTime(item.StartDate) <= FDT ? todatlWorkingDays : (($$this.dateFromSDateTime(item.StartDate) > FDT && $$this.dateFromSDateTime(item.StartDate) <= TDT) ? $$this.GetTotalWorkingDaysExcludingSaturdays($$this.dateFromSDateTime(item.StartDate), TDT) : 0)) - (filters || []).length + (compos || []).length;
                 var completed = (attendanceCounts[item.Id] || []).length;

                 if (new Date().getDay() != 6 && new Date().getDay() != 0 && TDT.toDateString() == (new Date()).toDateString() && $$this.GetTimeSlotTotal(item.Time) > currentTime) {
                     total -= 1;
                 }
                 // var leavesperson = leavsOfAll.filter(e => e.RS != "DELETEACTIVITY" && e.TOId == item.TherapistId)
                 // if (leavesperson && leavesperson.length > 0) {
                 //     total -= leavesperson.length
                 // }
                 // var leavesforKid = leavsOfAll.filter(e => e.RS != "DELETEACTIVITY" && e.TOId == item.BossId)
                 // if (leavesforKid && leavesforKid.length > 0) {
                 total -= (due.length)
                 //}
                 var pending = total - completed;
                 pending = pending > 0 ? pending : 0;
                 if (!isItKPI) {
                     item.totalAttendance = total;
                     item.CompletedAttendance = completed;
                     item.PendingAttendance = pending;


                     item.Present = (presentattendancesData[item.Id] || []).length;
                     item.Absent = (absentattendancesData[item.Id] || []).length;
                 }
                 return pending + accumulator;

             }, 0);
             console.log("Attendance-v2 ", new Date());
             if (isItKPI) {
                 return totalAttendance;
             }


             return dataConst.Therapies;
             //if (isItKPI) {
             //    return pending;
             //}
             // return dataConst.Attendance;
             break;

             case "kidattendancepending":

             console.log("kidattendancepending ", new Date());
             var filtered = [];


             //var totalAttendance = dataConst.TWD * dataConst.Therapies.length;
             var todayDate = new Date();
          //var ChangedFDT= new Date(todayDate.getFullYear(), todayDate.getMonth(), 28);
             TDT = TDT >= todayDate ? todayDate : TDT;
             var todatlWorkingDays = $$this.GetTotalWorkingDaysExcludingSaturdays(FDT, TDT);
             var currentTime = $$this.GetTimeSlotTotal(todayDate.getHours() + ":" + todayDate.getMinutes()) - 45;

             var filteredoftherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
             var BossTherapiesData=filteredoftherapies?filteredoftherapies.map(e=>e.BossId):[]

             var leavsOfAll = dataConst.Leaverequestall.filter(m => FDT <= $$this.dateFromSDateTime(m.FDT) && $$this.dateFromSDateTime(m.FDT) <= TDT && m.RS != "DELETEACTIVITY")
             var composOfAll = dataConst.Compos.filter(m => m.ForDate && FDT <= $$this.dateFromSDateTime(m.ForDate) && $$this.dateFromSDateTime(m.ForDate) <= TDT);
             var atendanceexcludecompos = []//composOfAll.map(e => e.Id)
             var leavesGroup = $$this.groupBy(leavsOfAll, "TOId");
             var peopleGroup = $$this.groupBy(dataConst.People, "Id");
             var composGroup = $$this.groupBy(composOfAll, "ServiceId");
             var attendancesData = (dataConst.Attendance.filter(m => m.TypeId != 238 && FDT <= $$this.dateFromSDateTime(m.ForDate)&& !atendanceexcludecompos.includes(parseInt(m.F2))) || [])
             var presentattendancesData = (attendancesData.filter(m => m.Status && m.Status.toLowerCase() == "present") || []);
             var absentattendancesData = (attendancesData.filter(m => (!m.Status || m.Status.toLowerCase() != "present")) || []);

             var attendanceCounts = $$this.groupBy(attendancesData, "ServiceId");
             var allkids=dataConst.People.filter(e=>e.RS!="DELETEACTIVITY" && e.F8!=1 && BossTherapiesData && BossTherapiesData.indexOf(e.Id)>-1)
             if(!allkids || allkids.length <=0){
                 allkids=dataConst.FacilityPeople.filter(e=>e.RS!="DELETEACTIVITY" && e.F8!=1 && BossTherapiesData && BossTherapiesData.indexOf(e.Id)>-1)
             }

             var allKidDataPending=[]


             for(var i=0;i<allkids.length;i++){
                 var kidtherapies=filteredoftherapies?filteredoftherapies.filter(r=>r.BossId== allkids[i].Id):[];
                 var obj={};
                 var Totals=0;
                 var therapistNames = [];
                 var totalAttendance = kidtherapies.reduce(function (accumulator, item) {

                 var due = (leavesGroup[item.BossId] || []);

                
                 due.push(...(leavesGroup[item.TherapistId] || []));
                 var filters = [];

                 var compos = [];

                 var total = ($$this.dateFromSDateTime(item.StartDate) <= FDT ? todatlWorkingDays : (($$this.dateFromSDateTime(item.StartDate) > FDT && $$this.dateFromSDateTime(item.StartDate) <= TDT) ? $$this.GetTotalWorkingDaysExcludingSaturdays($$this.dateFromSDateTime(item.StartDate), TDT) : 0)) - (filters || []).length + (compos || []).length;
                 var completedData = (attendanceCounts[item.Id] || []);
                 var completed = completedData && completedData.length >0 ? Object.keys($$this.groupBy(completedData, "ForDate")).length:0;

                 if (new Date().getDay() != 6 && new Date().getDay() != 0 && TDT.toDateString() == (new Date()).toDateString() && $$this.GetTimeSlotTotal(item.Time) > currentTime) {
                     total -= 1;
                 }

                 if(due && due.length > 0){
                     var groups = due.reduce((groups, val) => {
                         var splitDate = val.FDT.split(' ')[0];
                         if (!groups[splitDate]) {
                             groups[splitDate] = [];
                         }
                         groups[splitDate].push(val);
                         return groups;
                     }, {});

                     var allKeys = Object.keys(groups);


                     for(var i=0;i<allKeys.length;i++)
                     {
                         var leav = allKeys[i];
                   //  allKeys.forEach(leav => {
                         var leaveDate =  leav+" 00:00:00";
                         var isSaturday = new Date(leaveDate);
                         if (isSaturday.getDay() == 6){
                             total += 1;
                         }
                   //  });
                 }
                     

                 }
              


                 total -= (due.length)

                 var pending = total - completed;
                 pending = pending > 0 ? pending : 0;
                 if(pending > 0 )
                 {
                     var t= peopleGroup && peopleGroup[item.TherapistId] && peopleGroup[item.TherapistId][0].Name;
                     
                    // console.log("ATTENDANCE TherapistId",peopleGroup[item.TherapistId][0])
                     if(t)
                     {
                         therapistNames.push(t);
                         //console.log("ATTENDANCE PUSHED",therapistNames)
                     } 
                 }
                 Totals += pending


             }, 0);

             obj.Id=allkids[i].Id;
             obj.Pending=Totals;
             //console.log("HELLO ME ",therapistNames);
             obj.TherapistNames = therapistNames && therapistNames.length > 0 ?  therapistNames.join(",") : "";
            // console.log("HELLO ME 2",obj.TherapistNames);
             filtered.push(obj);
              }
              if (isItKPI) {
                 var Total = filtered.reduce(function (accumulator, item) {
                     return accumulator + (item.Pending);
                 }, 0);
                 return Total;
             }

             return filtered;
             break;
         case "credits":
         case "availablecredits":
             return dataConst.FutureInvoices ? dataConst.FutureInvoices : [];
             break;
         case "compospending":
             var filtered = [];

             var leaves = $$this.GetLeavesCompoCount(dataConst, FDT, TDT, null, dataConst.Therapies);

             var absent = dataConst.Attendance.filter(f => f.Status == "Absent");
             var filterdcompospending = dataConst.Compos.filter(e => new Date(e.ForDate) > FDT)
             return (leaves.length + absent.length) - filterdcompospending.length;
             //var absent = dataConst.Compos.length;
             //return filtered;
             break;

         case "compos":
             return dataConst.Compos;

             break;
         case "mirraclepending":
             var pendingmirracle = dataConst.MirraclesAssigned.filter(f => !f.Status || f.Status == "pending");
             return pendingmirracle;
             break;
         case "inactivations":
             var now = new Date();
             var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
             return dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => $$this.dateFromSDateTime(t.F14) >= fromDate) : [];
             break;
         case "admissions":
             var totalAdmissions = 0;
             var allServices = dataConst.Therapies;
             var currentUserServices =allServices.filter( function (r) { return $$this.dateFromSDateTime(r.StartDate) >= FDT && $$this.dateFromSDateTime(r.StartDate) <= TDT });
             var previousUserServices = allServices.filter( function (r) { return $$this.dateFromSDateTime(r.StartDate) < FDT });
             if (currentUserServices) {
                 var groupedKidIds = $$this.groupBy(currentUserServices, "BossId");
                 var previousKidIds = $$this.groupBy(previousUserServices, "BossId");
                 // console.log(groupedKidIds);
                 var currentMonthKids = Object.keys(groupedKidIds);
                 var prevMonthKids = Object.keys(previousKidIds);
                 totalAdmissions = currentMonthKids.filter(function (e) { return prevMonthKids.indexOf(e) <= -1 });

             }
             return totalAdmissions;
             break;
         case "additions":
             var totalAdditions = 0;
             var allServices = dataConst.Therapies;
             var currentUserServices = allServices.filter( function (r) { return $$this.dateFromSDateTime(r.StartDate) >= FDT && $$this.dateFromSDateTime(r.StartDate) <= TDT });
             var previousUserServices = allServices.filter( function (r) { return $$this.dateFromSDateTime(r.StartDate) < FDT });
             if (currentUserServices) {
                 var groupedKidIds = $$this.groupBy(currentUserServices, "BossId");
                 var previousKidIds = $$this.groupBy(previousUserServices, "BossId");
                 // console.log(groupedKidIds);
                 var currentMonthKids = Object.keys(groupedKidIds);
                 var prevMonthKids = Object.keys(previousKidIds);
                 // totalAdmissions = $.grep(currentMonthKids, function (e) { return prevMonthKids.indexOf(e) <= -1 }).length;
                 totalAdditions = currentMonthKids.filter( function (e) { return prevMonthKids.indexOf(e) >= 0 });


                 //var inactive = this.props.currentAggregate && this.props.currentAggregate.TCS ? parseInt(this.props.currentAggregate.TCS) : 0;
                 //var result = (40 / 100) * inactive;
                 //console.log(result);
                 //flagInactivations = (inactive + result) > totalAdditions

                 //  console.log(totalAdmissions);
                 //  console.log(totalAdditions);

             }
             return totalAdditions;
             break;
         case "walkinsold":
             var availableLeads = [];
             for (let i = 0; i < dataConst.Leads.length; ++i) {
                 var leadObj = {};
                 leadObj = dataConst.Leads[i];
                 if (leadObj.F3) {
                     var f3Index = leadObj.F3.indexOf("{");
                     leadObj.F3 = leadObj.F3.slice(0, f3Index);
                     availableLeads.push(leadObj);
                 }
                 else {
                     continue;
                 }

             }
             var leads = Object.entries($$this.groupBy(availableLeads, "F3"));
             var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
             var filteredData = resultleads.filter((k) => k.F1.toLowerCase() == "walkin");
             return filteredData;

             break;
         case "paymentpending":
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva");
             var thismonthInvoice = dataConst.Fee ? dataConst.Fee.filter(f => (($$this.dateFromSDateTime(f.CDT) <= TDT && $$this.dateFromSDateTime(f.CDT) >= FDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation"))) : [];
             var data = thismonthInvoice.map(m => m.Id);


             if (isItKPI && false) {
                 const paymnet = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => data.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];

                 var invoiceamount = thismonthInvoice.reduce(function (accumulator, item) {
                     return accumulator + (item.Amount - item.SevaAmount);
                 }, 0);
                 var paymentamount = paymnet ? paymnet.reduce(function (accc, items) {
                     return accc + items.Amount;
                 }, 0) : 0;
                 var filtered = invoiceamount - paymentamount;
                 return filtered;
             }
             else {
                 const paymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => data.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];

                 var paymentsGroup = $$this.groupBy(paymnets, "FeeId");


                 var paymentsWithGrouping = Object.entries(paymentsGroup);

                 var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                     [m[0]]: m[1].reduce(function (accc, items) {
                         return accc + items.Amount;
                     }, 0)
                 }))));

                 var amounts = thismonthInvoice.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));


                 if (isItKPI) {
                     var invoiceamount = amounts.reduce(function (accumulator, item) {

                         var amount = (item.Amount - item.SevaAmount - (paymentDict[item.Id] ? paymentDict[item.Id] : 0));
                         amount = amount > 0 ? amount : 0;
                         return accumulator + amount;
                     }, 0);

                     return invoiceamount;
                 }

                 var peopleGroup = $$this.groupBy(dataConst.People, "Id");
                 var typesGroup = $$this.groupBy(dataConst.Types, "Id");
                 var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");

                 var data = [];
                 for(var i=0;i<amounts.length;i++)
                 {
                     var a = amounts[i];
               //  amounts.forEach(function (k, a) {
                     var obj = {};
                     var opending = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                     opending = opending ? opending : 0;
                     obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                     obj.MonthId = $$this.appMonthNames[$$this.dateFromSDateTime(a.CDT).getMonth()];
                     obj.Id = a.Id;
                     obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                     obj.KidId = a.BOSSId;
                     obj.Created = a.CDT;
                     obj.From = a.FDT;
                     obj.To = a.TDT;
                     obj.ETA = a.ETA;
                     obj.Total = a.Amount;
                     obj.Seva = a.SevaAmount;
                     //obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                     obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                     obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                     obj.PendingAmt = opending;
                     data.push(obj);
                 } //);

                 return data;
             }
             break;
         case "inflow":
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva");
             var allPayments = dataConst.FeeReceipt.filter(f => typeId != f.TypeId && ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT));
             var invoiceIds = allPayments.map(m => m.FeeId);
             var amounts = dataConst.FeeAll.filter(f => invoiceIds.indexOf(f.Id) > -1);

             const inflowpaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => invoiceIds.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];

             var paymentsGroup = $$this.groupBy(inflowpaymnets, "FeeId");
             var paymentsWithGrouping = Object.entries(paymentsGroup);
             var paymentDict = Object.assign({}, ...paymentsWithGrouping.map(m => ({
                 [m[0]]: m[1].reduce(function (accc, items) {
                     return accc + items.Amount;
                 }, 0)
             })));


             var peopleGroup = $$this.groupBy(dataConst.People, "Id");
             var typesGroup = $$this.groupBy(dataConst.Types, "Id");
             var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");
             var data = [];
           //  amounts.forEach(function (k, a) {
                 for(var i=0;i<amounts.length;i++)
                 {
                     var a = amounts[i];
                 var obj = {};
                 obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                 obj.MonthId = $$this.appMonthNames[$$this.dateFromSDateTime(a.CDT).getMonth()];
                 obj.Id = a.Id;
                 obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                 obj.Created = a.CDT;
                 obj.From = a.FDT;
                 obj.To = a.TDT;
                 obj.Total = a.Amount;

                 obj.Seva = a.SevaAmount;
                 obj.Amount = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                 obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                 obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                 obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                 obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                 data.push(obj);
             } //);
             return data;

             break;

         case "business":
             var advancedata = dataConst.FeeAll.filter(f => (f.Remarks && f.Remarks.toLowerCase() == "system automation") ? (($$this.dateFromSDateTime(f.FDT) >= FDT && $$this.dateFromSDateTime(f.FDT) <= TDT)) : ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT));
             var advances = advancedata ? advancedata.map(m => m.Id) : [];
             const buspaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => advances.indexOf(f.FeeId) > -1) : [];

             var paymentsGroup = $$this.groupBy(buspaymnets, "FeeId");


             var paymentsWithGrouping = Object.entries(paymentsGroup);

             var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                 [m[0]]: m[1].reduce(function (accc, items) {
                     return accc + items.Amount;
                 }, 0)
             }))));

             var amounts = advancedata;
             var peopleGroup = $$this.groupBy(dataConst.People, "Id");
             var typesGroup = $$this.groupBy(dataConst.Types, "Id");
             var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");
             var data = [];
             for(var i=0;i<amounts.length;i++)
             {
                 var a = amounts[i];
                 var obj = {};
                 obj.Facility = facilitiesGroup[a.CenterId][0].Name;//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                 obj.MonthId = $$this.appMonthNames[$$this.dateFromSDateTime(a.CDT).getMonth()];
                 obj.Id = a.Id;
                 obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                 obj.Created = a.CDT;
                 obj.From = a.FDT;
                 obj.To = a.TDT;
                 obj.Total = a.Amount;

                 obj.Seva = a.SevaAmount;
                 obj.Amount = a.Amount - a.SevaAmount;
                 obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                 obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                 obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                 obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                 data.push(obj);
             } //);






             return data;

         case "advancepending":
             //var advancedata = dataConst.FutureInvoices ? dataConst.FutureInvoices.filter(f => ($$this.dateFromSDateTime(f.CDT) <= TDT && $$this.dateFromSDateTime(f.CDT) >= FDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")) : [];
             var advancedata = dataConst.FutureInvoicesCDTThisMonth ? dataConst.FutureInvoicesCDTThisMonth.filter(f => (!f.Remarks || f.Remarks.toLowerCase() != "system automation")) : [];
             var advances = advancedata ? advancedata.map(m => m.Id) : [];
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva");
             const adpaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => f.TypeId != typeId && advances.indexOf(f.FeeId) > -1) : [];


             if (isItKPI && false) {

                 var paymentsGroup = $$this.groupBy(adpaymnets, "FeeId");


                 var paymentsWithGrouping = Object.entries(paymentsGroup);

                 var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                     [m[0]]: m[1].reduce(function (accc, items) {
                         return accc + items.Amount;
                     }, 0)
                 }))));

                 advancedata = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0))


                 var invoicesamount = advancedata ? advancedata.reduce(function (accumulator, item) {
                     return accumulator + (item.Amount - item.SevaAmount);
                 }, 0) : 0;

                 advances = advancedata.map(f => f.Id);
                 var paymentsamount = adpaymnets ? adpaymnets.filter(a => advances.indexOf(a.Id) > -1).reduce(function (accc, items) {
                     return accc + items.Amount;
                 }, 0) : 0;
                 var filtered = invoicesamount - paymentsamount;
                 return filtered;
             }
             else {
                 const paymnets = adpaymnets;

                 var paymentsGroup = $$this.groupBy(paymnets, "FeeId");


                 var paymentsWithGrouping = Object.entries(paymentsGroup);

                 var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                     [m[0]]: m[1].reduce(function (accc, items) {
                         return accc + items.Amount;
                     }, 0)
                 }))));
                 dataConst.Centers = dataConst.Centers ? dataConst.Centers : [];
                 var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
                 var peopleGroup = $$this.groupBy(dataConst.People, "Id");
                 var typesGroup = $$this.groupBy(dataConst.Types, "Id");
                 var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");
                 var data = [];
                 for(var i=0;i<amounts.length;i++)
                 {
                     var a = amounts[i];
                     var obj = {};
                     obj.Facility = facilitiesGroup[a.CenterId] ? facilitiesGroup[a.CenterId][0].Name : '';//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                     obj.MonthId = $$this.appMonthNames[$$this.dateFromSDateTime(a.CDT).getMonth()];
                     obj.Id = a.Id;
                     obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                     obj.KidId = a.BOSSId;
                     obj.Created = a.CDT;
                     obj.From = a.FDT;
                     obj.To = a.TDT;
                     obj.Total = a.Amount;
                     obj.Seva = a.SevaAmount;
                     // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                     obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                     obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                     obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                     data.push(obj);
                 } //);

                 if (isItKPI) {
                     var invoicesamount = data ? data.reduce(function (accumulator, item) {
                         return accumulator + (item.PendingAmt);
                     }, 0) : 0;
                     return invoicesamount;
                 }

                 return data;
             }
             break;
         case "overallpending":
         case "etapending":
             var stDate = new Date();
             //var bids = dataConst.Therapies.map(m => m.BossId);
             var groupedTherapies = $$this.groupBy(dataConst.Therapies, "BossId");
             var allData = dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.RS != "DELETEACTIVITY" && f.Status != "PAID" && groupedTherapies && (groupedTherapies[f.BOSSId] || []).length > 0) : [];
             //console.log("GROUPED:"+GetDateDiff(stDate,new Date()));
             // stDate = new Date();
             // var allData1 = dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.RS != "DELETEACTIVITY" && f.Status != "PAID" && bids.indexOf(f.BOSSId) > -1) : [];
             // console.log("INDESXOF:"+GetDateDiff(stDate,new Date()));
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva");
             //stDate = new Date();
             const paymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => f.TypeId != typeId) : [];
             //console.log("PAYMENTS:"+GetDateDiff(stDate,new Date()));
             var paymentsGroup = $$this.groupBy(paymnets, "FeeId");


             var paymentsWithGrouping = Object.entries(paymentsGroup);

             stDate = new Date();
             // var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
             //     [m[0]]: m[1].reduce(function (accc, items) {
             //         return accc + items.Amount;
             //     }, 0)
             // }))));

             var paymentDict = Object.entries(paymentsGroup).reduce((acc, [key, values]) => {
                 // Use whatever logic you need to reduce the values (sum, average, etc.)
                 const reducedValue = values.reduce(function (accc, items) {
                     return accc + items.Amount;
                 }, 0)

                 // Assign the reduced value to the key in the accumulator
                 acc[key] = reducedValue;

                 return acc;
             }, {});


             dataConst.Centers = dataConst.Centers ? dataConst.Centers : [];
             console.log("paymentDict:" + $$this.GetDateDiff(stDate, new Date()));
             var amounts = allData.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));

             var peopleGroup = $$this.groupBy(dataConst.People, "Id");
             var typesGroup = $$this.groupBy(dataConst.Types, "Id");
             var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");
             var data = [];
             for(var i=0;i<amounts.length;i++)
             {
                 var a = amounts[i];
                 var obj = {};
                 obj.Facility = facilitiesGroup[a.CenterId] ? facilitiesGroup[a.CenterId][0].Name : '';//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                 obj.MonthId = $$this.appMonthNames[$$this.dateFromSDateTime(a.CDT).getMonth()];
                 obj.Id = a.Id;
                 obj.Kid = peopleGroup[a.BOSSId] ? peopleGroup[a.BOSSId][0].Name : "";
                 obj.KidId = a.BOSSId;
                 obj.Created = a.CDT;
                 obj.From = a.FDT;
                 if (type.toLowerCase() == "etapending") {
                     obj.ETA = a.ETA;
                 }
                 obj.To = a.TDT;
                 obj.Total = a.Amount;
                 obj.Seva = a.SevaAmount;
                 // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                 obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                 obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                 obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                 data.push(obj);
             }; //);

             if (isItKPI && type.toLowerCase() != "etapending") {
                 var invoicesamount = data ? data.reduce(function (accumulator, item) {
                     return accumulator + (item.PendingAmt);
                 }, 0) : 0;
                 return invoicesamount;
             }
             if (type.toLowerCase() == "etapending") {

                 var data = data.filter(e => !e.ETA);
                 if (isItKPI) {
                     var invoicesamount = data ? data.reduce(function (accumulator, item) {
                         return accumulator + (item.PendingAmt);
                     }, 0) : 0;
                     return invoicesamount;
                 }
                 return data;
             }

             return data;

             break;
         case "pastpending":
             var start = new Date();

             var bids = dataConst.Therapies.map(m => m.BossId);
             var therapiesGroup = $$this.groupBy(dataConst.Therapies, "BossId");
             // console.log("pastpending bids",GetDateDiff(start,new Date()));
             start = new Date();
             // bids.indexOf(f.BOSSId) > -1
             var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => (!f.Status || f.Status.toLowerCase() != "paid") && therapiesGroup && (therapiesGroup[f.BOSSId] || []).length > 0 && ($$this.dateFromSDateTime(f.CDT) < FDT)) : [];
             //console.log("pastpending advancedata",GetDateDiff(start,new Date()));
             start = new Date();
             var advances = advancedata ? advancedata.map(m => m.Id) : [];
             var groupBypendings = $$this.groupBy(advancedata, "Id");
             //console.log("pastpending advancedata",GetDateDiff(start,new Date()));
             start = new Date();
             // console.log(advances);
             const papaymnets = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => groupBypendings && (groupBypendings[f.FeeId] || []).length > 0) : [];
             // console.log("pastpending papaymnets",GetDateDiff(start,new Date()));

             // console.log("pastpending papaymnets",isItKPI);
             start = new Date();
             if (isItKPI) {

                 var paymentsGroup = $$this.groupBy(papaymnets, "FeeId");
                 // console.log("pastpending paymentsGroup",GetDateDiff(start,new Date()));
                 start = new Date();

                 var paymentsWithGrouping = Object.entries(paymentsGroup);
                 // console.log("pastpending paymentsWithGrouping",GetDateDiff(start,new Date()));
                 start = new Date();
                 var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                     [m[0]]: m[1].reduce(function (accc, items) {
                         return accc + items.Amount;
                     }, 0)
                 }))));
                 console.log("pastpending paymentDict", $$this.GetDateDiff(start, new Date()));
                 start = new Date();
                 advancedata = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
                 // console.log("pastpending advancedata",GetDateDiff(start,new Date()));
                 start = new Date();
                 var invoicesamount = advancedata ? advancedata.reduce(function (accumulator, item) {
                     return accumulator + item.Amount;
                 }, 0) : 0;
                 // console.log("pastpending invoicesamount",GetDateDiff(start,new Date()));
                 start = new Date();
                 advances = advancedata.map(f => f.Id);
                 // console.log("pastpending advances",GetDateDiff(start,new Date()));
                 start = new Date();
                 var paymentsamount = papaymnets ? papaymnets.filter(a => advances.indexOf(a.Id) > -1).reduce(function (accc, items) {
                     return accc + items.Amount;
                 }, 0) : 0;
                 // console.log("pastpending advances",GetDateDiff(start,new Date()));
                 start = new Date();
                 var filtered = invoicesamount - paymentsamount;

                 return filtered;
             }
             else {
                 const paymnets = papaymnets;

                 var paymentsGroup = $$this.groupBy(paymnets, "FeeId");


                 var paymentsWithGrouping = Object.entries(paymentsGroup);

                 var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                     [m[0]]: m[1].reduce(function (accc, items) {
                         return accc + items.Amount;
                     }, 0)
                 }))));

                 var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));
                 var peopleGroup = $$this.groupBy(dataConst.People, "Id");
                 var typesGroup = $$this.groupBy(dataConst.Types, "Id");
                 var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");
                 var data = [];
                 for(var i=0;i<amounts.length;i++)
                 {
                     var a = amounts[i];
                     var obj = {};
                     obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                     obj.MonthId = $$this.appMonthNames[$$this.dateFromSDateTime(a.CDT).getMonth()];
                     obj.Id = a.Id;
                     obj.Kid = peopleGroup[a.BOSSId] && peopleGroup[a.BOSSId][0] ? peopleGroup[a.BOSSId][0].Name : "";
                     obj.KidId = a.BOSSId;
                     obj.Created = a.CDT;
                     obj.From = a.FDT;
                     obj.To = a.TDT;
                     obj.Total = a.Amount;
                     obj.Seva = a.SevaAmount;
                     obj.Remarks = a.Remarks;
                     // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";
                     obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                     obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                     obj.PendingAmt = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);
                     data.push(obj);
                 }; //);

                 if (isItKPI) {
                     var invoicesamount = data ? data.reduce(function (accumulator, item) {
                         return accumulator + (item.PendingAmt);
                     }, 0) : 0;
                     return invoicesamount;
                 }


                 return data;
             }
             break;
         case "leadspending":
         case "closedleadsdata":
         case "activeleadsdata":
         case "leadselsewhere":
         case "leadstoadmission":
         case "newleads":
         case "additionleads":
         case "admissionleads":
         case "joinedelsewhere":
         case "assessmentsleads":
         case "walkinleads":
         case "closedleadsnew":
         case "newleadsnew":
         case "pendingleads":
         case "activeleadsnew":
         case "activeleads":
         case "closedleads":
         case "totalleads":
         case "walkins":
         case "walkintoadmisssion":
         case "activewalkins":
         case "closedwalkins":

             let leadsClosedSTatus = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
             var availLeads = [];
             //var startDate = new Date()
             var leadsGroups = dataConst && dataConst.LeadGroups && dataConst.LeadGroups.length > 0 ? dataConst.LeadGroups : dataConst && dataConst.Leads && dataConst.Leads.length > 0 ? Object.entries($$this.groupBy(dataConst.Leads, "F17")) : [];
             var leadsData = dataConst && dataConst.GroupedLeads && dataConst.GroupedLeads.length > 0 ? dataConst.GroupedLeads : leadsGroups && leadsGroups.length ? leadsGroups.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))) : [];
             //var leadsData = leadsGroups && leadsGroups.length ? leadsGroups.map(m => m[1].sort((a, b) => (new Date(b.CDT) - new Date(a.CDT)))) : [];
             var curRoles = localStorage.getItem("UserRoles");
             var isUserBDC = curRoles && curRoles.indexOf("BDC") > -1;
             var currentUser = dataConst.CFUser;

             if (type.toLowerCase() == "leadspending" || type.toLowerCase() == "pendingleads") {

                 return leadsData.filter(f => (!f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase())) && (!f[0].FDT || $$this.dateFromSDateTime(f[0].FDT) <= (TDT > new Date() ? new Date() : TDT)));
             }
             if (type.toLowerCase() == "newleads" || type.toLowerCase() == "additionleads" || type.toLowerCase() == "newleadsnew") {

                 var newLeads = leadsData.filter(f => f[f.length - 1].CDT && new Date(f[f.length - 1].CDT) >= new Date(FDT) && new Date(f[f.length - 1].CDT) <= new Date(TDT));
                 return newLeads;
             }
             else if (type.toLowerCase() == "closedleadsdata" || type.toLowerCase() == "closedleads" || type.toLowerCase() == "closedleadsnew") {
                 return leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
             }
             else if (type.toLowerCase() == "activeleadsdata" || type.toLowerCase() == "activeleadsnew" || type.toLowerCase() == "activeleads") {
                 return leadsData.filter(f => !f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase()));
             }
             else if (type.toLowerCase() == "leadselsewhere" || type.toLowerCase() == "joinedelsewhere") {
                 leadsClosedSTatus = ['ALREADY JOINED SOMEWHERE'];
                 return leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
             }
             else if (type.toLowerCase() == "leadstoadmission" || type.toLowerCase() == "admissionleads") {
                 leadsClosedSTatus = ["enrolled", "enroled"];
                 var newLeadSData = leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toLowerCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
                 var filteredleads = newLeadSData ? dataConst.People.map(e => e.Id) : []
                 return newLeadSData.filter(e => filteredleads.includes(e[0].TOId));
             }
             else if (type.toLowerCase() == "walkins" || type.toLowerCase() == "walkinleads") {

                 // var mobiles = dataConst.Leads.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.Status && f.Status.toLowerCase() == "walkin").map(m => m.F17);
                 // return leadsGroups.filter(f => mobiles.indexOf(f[0]) > -1).map(m => m[1]);
                 //startDate = new Date()
                 var mobiles = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? f.RId == currentUser.Id : true));
                 // console.log("Walkin T3 : "+GetDateDiff(startDate,new Date()))
                 // startDate = new Date()
                 var groupedData = $$this.groupBy(mobiles, 'F17');
                 // console.log("Walkin T4: "+GetDateDiff(startDate,new Date()))
                 // startDate = new Date()
                 return leadsGroups.filter(f => groupedData[f[0]] && groupedData[f[0]].length > 0).map(m => m[1]);

             }
             else if (type.toLowerCase() == "totalleads") {

                 return leadsData.filter(f => (f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase())) || (!f[0].Status || leadsClosedSTatus.indexOf(f[0].Status.toUpperCase()) == -1) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
             }
             else if(type.toLowerCase() == "walkintoadmisssion"){
                 leadsClosedSTatus = ["enrolled", "enroled"];
                 var newLeadSData = leadsData.filter(f => f[0].Status && leadsClosedSTatus.includes(f[0].Status.toLowerCase()) && (!f[0].CDT || new Date(f[0].CDT) >= FDT) && (!f[0].CDT || new Date(f[0].CDT) <= TDT));
                 var filteredleads = newLeadSData ? dataConst.People.map(e => e.Id) : [];
                 var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? f.RId == currentUser.Id : true));
                 var groupByTOId = Object.keys($$this.groupBy(filteredThisMonth,"TOId"));

                 return newLeadSData.filter(e => filteredleads.includes(e[0].TOId) && groupByTOId.includes(e[0].TOId+""));
             }
             else if(type.toLowerCase() == "activewalkins"){
                 var allActiveLeads = leadsData.filter(f => !f[0].Status || !leadsClosedSTatus.includes(f[0].Status.toUpperCase()));
                 var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? f.RId == currentUser.Id : true));
                 var groupByTOId = Object.keys($$this.groupBy(filteredThisMonth,"TOId"));
                 return allActiveLeads.filter(e => groupByTOId.includes(e[0].TOId+""));
             }
             else if(type.toLowerCase() == "closedwalkins"){
                 var allActiveLeads = leadsData.filter(f => f[0] && f[0].Status && leadsClosedSTatus.includes(f[0].Status.toUpperCase()));
                 var filteredThisMonth = dataConst.Leads.filter(f => (!f.RS || f.RS != "DELETEACTIVITY") && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.F1 && f.F1.toLowerCase() == "walkin" && (isUserBDC ? f.RId == currentUser.Id : true));
                 var groupByTOId = Object.keys($$this.groupBy(filteredThisMonth,"TOId"));
                 return allActiveLeads.filter(e => groupByTOId.includes(e[0].TOId+""));
             }

             for (let i = 0; i < dataConst.Leads.length; ++i) {
                 var leadObj = {};
                 leadObj = dataConst.Leads[i];
                 if (leadObj.F3) {
                     var f3Index = leadObj.F3.indexOf("{");
                     leadObj.F3 = leadObj.F3.slice(0, f3Index);
                     availLeads.push(leadObj);
                 }
                 else {
                     continue;
                 }

             }
             var leads = Object.entries($$this.groupBy(availLeads, "F3"));
             leads.filter(f => !f[1] || leadsClosedSTatus.indexOf(f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0].Status) == -1);

             return leads;
             break;
         case "assessmentpending":
             var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata.filter(m => m.Status.toLowerCase() != "completed" && $$this.dateFromSDateTime(m.CDT) >= FDT) : [];
             if (isItKPI) {
                 return filteredasss;
             }

             break;
         case "assessmentcompleted":
             var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata.filter(m => m.Status && m.Status.toLowerCase() == "completed" && $$this.dateFromSDateTime(m.CDT) >= FDT) : [];
             if (isItKPI) {
                 return filteredasss;
             }

             break;
         case "assessmentall":
             var filteredasss = dataConst.Assessmentsdata ? dataConst.Assessmentsdata.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT) : [];
             if (isItKPI) {
                 return filteredasss;
             }

             break;
         case "leavespending":
             var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status != "APPROVED" && m.Status != "CANCELED" && m.F8 == "" && m.F1 != "Parent") : [];
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "leavesall":
             var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.F1 != "Parent") : [];
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "leavesapproved":
             var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status == "APPROVED" && m.F1 != "Parent") : [];
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "leavesunapproved":
             var filtered = dataConst.Leaverequestall ? dataConst.Leaverequestall.filter(m => m.Status == "UNAPPROVED" && m.F1 != "Parent") : [];
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestpending":

             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             // var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             // var responses = $$this.groupBy(analytics, "SRId");

             var analytics = $$this.groupBy(dataConst.ServiceRequestAnalytic, "SRId");
             var responses = Object.entries(analytics).reduce((acc, [key, values]) => {
                 const reducedValue = values.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1))
                 acc[key] = reducedValue;

                 return acc;
             }, {});

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });

             var service = serviceRequests ? serviceRequests.map(m => m.Id) : [];
             //const analticsdta = dataConst.ServiceRequestAnalytic ? dataConst.ServiceRequestAnalytic.filter(f => service.indexOf(f.SRId) > -1) : [];
             var filtered = srs.LastAnalytic ? srs.filter(m => m.LastAnalytic.Status != "CLOSED") : "";

             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestall":
             //var filtered = [];
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             //var empty = []
             var servicee = serviceRequests ? serviceRequests.map(m => m.Id) : [];
             var SRRO = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");

             var SRR = srs.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
             var SRW = srs.filter(m => m.LastAnalytic && (m.LastAnalytic.Status == "CLOSED" || m.LastAnalytic.Status == "UPDATED") && m.CBPI != m.LastAnalytic.CBPI)
             var SRIPdata = dataConst.ServiceRequestAnalytic ? dataConst.ServiceRequestAnalytic.filter(f => servicee.indexOf(f.SRId) > -1) : [];
             var SRIP = SRIPdata.filter(m => m.Status != "CLOSED");

             //empty.push(...SRRO, ...SRR, ...SRIP, ...SRW)
             var newdata = SRRO.concat(SRR, SRW)
             //var filtered = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
             var filtered = newdata;
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestactive":
             var filtered = [];

             //var filtered = aggregate.SRT + aggregate.SRW + aggregate.SRIP + aggregate.SRRO;
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestwaiting":
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             var filtered = srs.filter(m => m.LastAnalytic && (m.LastAnalytic.Status == "CLOSED" || m.LastAnalytic.Status == "UPDATED") && m.CBPI != m.LastAnalytic.CBPI);
             if (isItKPI) {
                 return filtered;
             }
             break;

         case "servicerequestresolved":
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             var filtered = srs.filter(m =>  m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestreopened":
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             var filtered = srs.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN")
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestrating5":
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             var filtered = srs.filter(m => m.Rating == 5)
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestrating4":
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             var filtered = srs.filter(m => m.Rating == 4)
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestrating3":
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             var filtered = srs.filter(m => m.Rating == 3)
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestrating2":
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             var filtered = srs.filter(m => m.Rating == 2)
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "servicerequestrating1":
             var serviceRequests = dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             var filtered = srs.filter(m => m.Rating == 1)
             if (isItKPI) {
                 return filtered;
             }
             break;
         case "chipending":
             dataConst.Types = dataConst.Types || [];
             var typeId = dataConst.Types.filter(m => m.Name == "CHI" && m.Category == "ASSESSMENT")[0].Id;
             var ids = dataConst.Responses ? dataConst.Responses.map(m => m.CenterNoteId) : [];
             return dataConst.CenterNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && m.TypeId == typeId && (!m.RS || m.RS != "DELETEACTIVITY"));
             break;
         case "whipending":
             dataConst.Types = dataConst.Types || [];
             var typeId = dataConst.Types.filter(m => m.Name == "WHI" && m.Category == "ASSESSMENT")[0].Id;
             var ids = dataConst.Responses ? dataConst.Responses.map(m => m.PeopleNoteId) : [];
             return dataConst.PeopleNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && ids.indexOf(m.Id) == -1 && m.TypeId == typeId);

             // return [];
             break;

         case "pisipending":
             dataConst.Types = dataConst.Types || [];
             var ids = dataConst.Responses ? dataConst.Responses.map(m => m.PeopleNoteId) : [];
             var typeId = dataConst.Types.filter(m => m.Name == "PISI" && m.Category == "ASSESSMENT")[0].Id
             return dataConst.PeopleNotes.filter(m => !(m.Status == "COMPLETED" || ids.indexOf(m.Id) > -1) && m.TypeId == typeId);

             // return [];
             break;

         case "therapiesprovided":
             return dataConst.Therapies;
             break;
         case "activeservices":
             if (TDT > new Date()) {
                 // TDT = new Date();
                 return dataConst.Therapies.filter(m => $$this.dateFromSDateTime(m.StartDate) <= new Date() && (!m.Status || (m.Status && m.Status.toLowerCase() != "inactive")))
             }
             TDT = TDT > new Date() ? new Date() : TDT;

             return dataConst.Therapies.filter(m => $$this.dateFromSDateTime(m.StartDate) <= TDT && ((m.UDT >= $$this.dateFromSDateTime(TDT) ? (m.Status && m.Status.toLowerCase() == "inactive") : false) || (!m.Status || m.Status && m.Status.toLowerCase() != "inactive")));
             break;

         case "pendingmilestones":

             var activeServices = dataConst.Therapies.filter(m => m.RS != "DELETEACTIVITY");
             var servicesGroup = $$this.groupBy(activeServices, "BossId");
             var bossIds = Object.keys(servicesGroup);

             var peopleGroup = $$this.groupBy(dataConst.People.filter(f => bossIds.indexOf(f.Id + "")) || [], "Id");
             var notAttendedKids = bossIds.filter(f => $$this.IsAllMileStoneQuestionsAnsweredForKPI(peopleGroup[f] ? peopleGroup[f][0] : null) == false);
             if (isItKPI) {
                 return notAttendedKids.length;
             }

             var results = [];
             var centers = $$this.groupBy(dataConst.Centers, "Id");
             for (var i = 0; i < notAttendedKids.length; i++) {
                 var kidId = notAttendedKids[i];

                 var kid = peopleGroup[kidId] ? peopleGroup[kidId][0] : null;
                 if (kid) {
                     var obj = {};
                     obj.Facility = centers[kid.CenterId] ? centers[kid.CenterId][0].Name : "";
                     obj.Name = kid.Name;
                     obj.Therapist = servicesGroup[kidId] ? servicesGroup[kidId].map(m => peopleGroup[m.TherapistId] ? peopleGroup[m.TherapistId][0].Name : "").join(",") : ""
                     results.push(obj);
                 }
             }

             return results;




             break;
         case "completedmilestones":

             var activeServices = dataConst.Therapies.filter(m => m.RS != "DELETEACTIVITY");
             var servicesGroup = $$this.groupBy(activeServices, "BossId");
             var bossIds = Object.keys(servicesGroup);

             var peopleGroup = $$this.groupBy(dataConst.People.filter(f => bossIds.indexOf(f.Id + "")) || [], "Id");
             var notAttendedKids = bossIds.filter(f => $$this.IsAllMileStoneQuestionsAnsweredForKPI(peopleGroup[f] ? peopleGroup[f][0] : null) == true);
             if (isItKPI) {
                 return notAttendedKids.length;
             }

             var results = [];
             var centers = $$this.groupBy(dataConst.Centers, "Id");
             for (var i = 0; i < notAttendedKids.length; i++) {
                 var kidId = notAttendedKids[i];

                 var kid = peopleGroup[kidId] ? peopleGroup[kidId][0] : null;
                 if (kid) {
                     var obj = {};
                     obj.Facility = centers[kid.CenterId] ? centers[kid.CenterId][0].Name : "";
                     obj.Name = kid.Name;
                     obj.Therapist = servicesGroup[kidId] ? servicesGroup[kidId].map(m => peopleGroup[m.TherapistId] ? peopleGroup[m.TherapistId][0].Name : "").join(",") : ""
                     results.push(obj);
                 }
             }

             return results;




             break;
         case "futureservices":

             TDT = TDT > new Date() ? new Date() : TDT;
             return dataConst.Therapies.filter(m => $$this.dateFromSDateTime(m.StartDate) > TDT && ((m.UDT >= $$this.dateFromSDateTime(TDT) ? (m.Status && m.Status.toLowerCase() == "inactive") : false) || (!m.Status || m.Status && m.Status.toLowerCase() != "inactive")));
             break;

         case "newservices":
             return dataConst.Therapies.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE")
             break;
         case "newservicesst":
             dataConst.Types = dataConst.Types || [];
             var typeId = dataConst.Types.filter(m => m.Name == "Speech Therapy" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
             return dataConst.Therapies.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
             break;
         case "newservicesbt":
             dataConst.Types = dataConst.Types || [];
             var typeId = dataConst.Types.filter(m => m.Name == "Behavioral Modification" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
             return dataConst.Therapies.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
             break;

         case "newservicesse":
             dataConst.Types = dataConst.Types || [];
             var typeId = dataConst.Types.filter(m => m.Name == "Special Education" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
             return dataConst.Therapies.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
             break;
         case "newservicesot":
             dataConst.Types = dataConst.Types || [];
             var typeId = dataConst.Types.filter(m => m.Name == "Occupational Therapy" && m.Category && m.Category.toLowerCase() == "service")[0].Id;
             return dataConst.Therapies.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT && m.TypeId == typeId && m.RS != "DELETEACTIVITY" && m.Status != "INACTIVE");
             break;

         case "inactiveservices":
             var now = new Date();
             var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
             return dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => $$this.dateFromSDateTime(t.F14) >= fromDate) : [];
             break;
         case "inactivecausepending":
             var now = new Date();
             var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
             return dataConst.InActive && dataConst.InActive.length > 0 ? dataConst.InActive.filter(t => $$this.dateFromSDateTime(t.F14) >= fromDate && (!t.F23 || !t.F24)) : [];
             break;

         case "attendancepresent":
             return dataConst.Attendance.filter(m => m.Status == "Present");
             break;
         case "attendanceabsent":
             return dataConst.Attendance.filter(m => m.Status == "Absent");
             break;
         case "renewalclarityall":
         case "renewalclarityoverdue":
         case "renewalclaritytoday":
         case "renewalclaritytomorrow":
         case "renewalclaritythisweek":
         case "renewalclaritynextweek":
         case "renewalclaritythismonth":
         case "renewalclaritynextmonth":
         case "renewalclarityothers":
         case "renewalclaritypending":
         case "renewalclarityrenewed":
         case "renewalclaritytoberenewed":
             var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.Category && e.Category.toLowerCase().indexOf("renewal") > -1 && ($$this.dateFromSDateTime(e.FDT) >= FDT && $$this.dateFromSDateTime(e.FDT) <= TDT))) : [];
             var inactivationType = allPinnacleClarity && allPinnacleClarity.length > 0 ? allPinnacleClarity[0].Category.replace("Renewals", "Inactivation") : "";
             var inactivations = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.Category && e.Category == inactivationType && e.Reply)) : [];
             inactivations = inactivations ? inactivations : [];
             var inactivationsByKid = $$this.groupBy(inactivations, "ForId");
             var todayDate = new Date();
             todayDate.setHours(0, 0, 0, 0);
             var tomorrowRC = new Date();
             tomorrowRC.setDate(tomorrowRC.getDate() + 1);
             var peopleGroup = $$this.groupBy(dataConst.People, "Id");
             var typesGroup = $$this.groupBy(dataConst.Types, "Id");
             var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");






             var data = [];

             var ncc = dataConst && dataConst.UserSettings ? dataConst.UserSettings.filter(f => f.Name == "NCC")[0] : null;
             var nccArray = [];
             try {
                 nccArray = dataConst.IsUserOwner && ncc ? ncc.Value.split("{##}").map(m => ({ "Centers": m.split("{==}")[1], "Name": m.split("{==}")[3] })) : [];

             }
             catch (e) {
                 nccArray = []
             }
             //var nccIds = ncc ? ncc.split("{==}") : [];


             var activetherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
             if (allPinnacleClarity) {
                 var forIds = allPinnacleClarity.map(m => m.ForId + "");
                 var dt = new Date();
                 var usedCredits = dataConst && dataConst.FeeAll && dataConst.FeeAll.length > 0 ? dataConst.FeeAll.filter(f => $$this.dateFromSDateTime(f.FDT) <= dt && forIds.indexOf(f.BOSSId + "") > -1) : [];
                 var usedCreditsOfBoss = $$this.groupBy(usedCredits, "BOSSId");

                 for(var i=0;i<allPinnacleClarity.length;i++)
                 {
                     var a = allPinnacleClarity[i];
              // allPinnacleClarity.forEach( function (k, a) {

                     var obj = {};
                     var details = a.F5 == "RENEWED" || a.F5 == "Renewed" ? "Renewed" : !a.Reply ? "Pending" : ($$this.dateFromSDateTime(a.Reply) <= 0 || $$this.dateFromSDateTime(a.Reply) == "Invalid Date") ? "Others" : $$this.dateFromSDateTime(a.Reply) < todayDate ? "OverDue" : ($$this.dateFromSDateTime(a.Reply)).toDateString() == todayDate.toDateString() ? "Today" :
                         ($$this.dateFromSDateTime(a.Reply)).toDateString() == tomorrowRC.toDateString() ? "Tomorrow" :
                             ($$this.dateFromSDateTime(a.Reply) > $$this.getDateByType("thisweekstart") && $$this.dateFromSDateTime(a.Reply) <= $$this.getDateByType("thisweekend")) ? "ThisWeek" :
                                 $$this.dateFromSDateTime(a.Reply) > $$this.getDateByType("thisweekend") && $$this.dateFromSDateTime(a.Reply) <= $$this.getDateByType("nextweekend") ? "NextWeek" :
                                     ($$this.dateFromSDateTime(a.Reply)).getMonth() == todayDate.getMonth() ? "ThisMonth" :
                                         ($$this.dateFromSDateTime(a.Reply)).getMonth() == (todayDate.getMonth() + 1) ? "NextMonth" :
                                             "Future";

                     try {
                         if (isItKPI) {
                             obj.Details = details.toLowerCase();
                         }
                         else {


                             var therapistName = "";
                             var therapistNames = "";
                             var nccCat = "";
                             if (!isItKPI) {
                                 var alltherapiesforkid = activetherapies.filter(e => e.BossId == a.ForId)
                                 for (i = 0; i < alltherapiesforkid.length; i++) {
                                     var names = dataConst.People.filter(e => e.Id && e.Id == alltherapiesforkid[i].TherapistId)[0]
                                     therapistName += names.Id + "#" + names.Name + "{#}"
                                     therapistNames += names.Name + ",";
                                 }
                                 try {
                                     nccCat = nccArray.filter(f => f.Centers.indexOf(a.CenterId) > -1)[0].Name;
                                 }
                                 catch (e) {
                                     console.log(e);
                                 }
                             }
                             var myRegExp = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/g;


                             var noOfMonths = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? $$this.differenceInMonths(new Date(), $$this.dateFromSDateTime(peopleGroup[a.ForId][0].CDT)) : 0;



                             obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                             obj.For = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";

                             obj.HBDT = a.HBDT;
                             obj.Category = nccCat;
                             obj.Package = a.F4;
                             obj.Message = a.Message;
                             obj.KidId = a.ForId;
                             obj.MobileId = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Handle : "";
                             obj.Therapist = therapistName ? therapistName : null;
                             obj.TherapistId = therapistNames ? therapistNames : "";

                             obj.Details = details;
                             obj.ETAs = a.Reply && (a.Reply).match(myRegExp) ? (a.Reply).split(" ")[0] : "Other";
                             obj.TOId = a.UBPI;
                             obj.Remarks = a.F5;
                             obj.Reply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";

                             obj.Amount = a.F2 ? a.F2 : a.Message.replace(obj.For + " ", "").replace(" Fee Clearing ETA ?", "");
                             obj.Longitivity = noOfMonths == 0 ? "" : noOfMonths >= 12 ? "L" : noOfMonths >= 6 ? "M" : "S";
                             obj.OfferAmount = a.F1;
                             obj.AdminDiscontinueMarked = inactivationsByKid && inactivationsByKid[a.ForId] ? inactivationsByKid[a.ForId].filter(f => (f.Reply && f.Reply.toLowerCase().indexOf("continue empowerment") > -1))[0] ? "" : "Discontinue" : "";
                             obj.TherapistDiscontinueMarked = inactivationsByKid && inactivationsByKid[a.ForId] ? inactivationsByKid[a.ForId].filter(f => (f.TherapistReply && f.TherapistReply.toLowerCase().indexOf("continue empowerment") > -1))[0] ? "" : "Discontinue" : "";
                             obj.CreditsUsed = usedCreditsOfBoss && usedCreditsOfBoss[a.ForId + ""] ? usedCreditsOfBoss[a.ForId + ""].length : 0;
                             if (a.Category.indexOf("Renewals") > -1) {
                                 obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                                 obj.Uneven = obj.Reply == obj.TherapistReply ? "No" : "Yes";
                             }
                             obj.NCCReply = a.NCCReply && a.NCCReply.trim() != "" ? a.NCCReply : "Pending";
                             obj.UnevenNCC = obj.Reply == obj.TherapistReply == obj.NCCReply ? "No" : "Yes";
                         }
                         data.push(obj);
                     }
                     catch (e) {
                         console.log(e);
                     }
                 } //);
             }

             var tobeRenewed = ["others", "renewed", "pending"];

             var AllFeeETA = data && data.length > 0 ? data.filter(e => (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity" + e.Details.toLowerCase() + "")) : [];
             //    if (isItKPI) {
             //        return AllFeeETA.length;
             //    }


             return AllFeeETA;


             break;
         case "pollinationclaritypromised":
         case "pollinationclaritycompleted":
         case "pollinationclarityyetto":
         case "pollinationclarityzero":
         case "pollinationclaritylessthanthree":
         case "pollinationclaritygreaterthanthree":
         case "pollinationopty":

             var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.RS != "DELETEACTIVITY" && e.Category && e.Category.toLowerCase().indexOf("therapist pollination") > -1) && $$this.dateFromSDateTime(e.CDT) >= FDT && $$this.dateFromSDateTime(e.CDT) <= TDT) : [];

             var data = $$this.groupBy(allPinnacleClarity, 'ForId');
             var currentPeopleData = dataConst.People.filter(e => e.RS != "DELETEACTIVITY" && e.F8 != 1)
             var peopleGroup = $$this.groupBy(currentPeopleData, "Id");
             var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");
             var addedSessions = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && peopleGroup[f.BossId] && $$this.dateFromSDateTime(peopleGroup[f.BossId][0].CDT) < FDT) : [];
             addedSessions = addedSessions || [];
             var newelyAddeddSessionGroup = $$this.groupBy(addedSessions, 'TherapistId');
             var allOppertunities = [];
             for(var k=0;k<data.length;k++)
             {
                var byGroupData = data[i];
             //data.forEach(function (k, byGroupData) {
                 var obj = {};

                 // const reducer = (accumulator, curr) => accumulator + parseInt(curr.Reply);
                 //var promise = (byGroupData.filter(m=> !isNaN(m.Reply)) || []).reduce(reducer);
                 var tobeprocessed = byGroupData.filter(m => m.Reply && !isNaN(m.Reply));
                 var promise = tobeprocessed && tobeprocessed.length > 0 ? tobeprocessed.reduce(function (accumulator, item) {
                     return accumulator + parseInt(item.Reply);
                 }, 0) : 0;

                 obj.Facility = facilitiesGroup[byGroupData[0].CenterId] && facilitiesGroup[byGroupData[0].CenterId][0] ? facilitiesGroup[byGroupData[0].CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";

                 obj.Therapist = peopleGroup[k] && peopleGroup[k][0].Name;
                 obj.Discipline = peopleGroup[k] && peopleGroup[k][0].Designation;

                 obj.ThrapistId = k;
                 obj.Promise = parseInt(promise);
                 obj.Completed = newelyAddeddSessionGroup[k] ? newelyAddeddSessionGroup[k].length : 0;
                 obj.YetTo = obj.Promise - obj.Completed > 0 ? obj.Promise - obj.Completed : 0;

                 obj.ShortName = $$this.GetShortDesignation(peopleGroup[k] && peopleGroup[k][0].Designation);
                 obj.Opty = byGroupData[0].F2;
                 obj.Count = type.toLowerCase() == "pollinationclaritypromised" ? parseInt(promise) :
                     type.toLowerCase() == "pollinationclaritycompleted" ? obj.Completed :
                         type.toLowerCase() == "pollinationclarityyetto" ? obj.YetTo :
                             type.toLowerCase() == "pollinationclarityzero" ? promise == 0 ? 1 : 0 :
                                 type.toLowerCase() == "pollinationopty" ? parseInt(obj.Opty) :
                                     type.toLowerCase() == "pollinationoptyst" ? obj.ShortName == "ST" ? obj.Promise : 0 :
                                         type.toLowerCase() == "pollinationoptyot" ? obj.ShortName == "OT" ? obj.Promise : 0 :
                                             type.toLowerCase() == "pollinationoptyaba" ? obj.ShortName == "BT" ? obj.Promise : 0 :
                                                 type.toLowerCase() == "pollinationoptyse" ? obj.ShortName == "SE" ? obj.Promise : 0 :
                                                     type.toLowerCase() == "pollinationclaritylessthanthree" ? promise < 3 ? 1 : 0 :
                                                         type.toLowerCase() == "pollinationclaritygreaterthanthree" ? promise >= 3 ? 1 : 0 : 0
                 allOppertunities.push(obj);
             }//);

             //    console.log("---ALL-CLARTIY--");
             //    console.log(type.toLowerCase());
             //    console.log(allOppertunities);

             var allcount = "Count"
             if (isItKPI) {
                 var invoicesamount = allOppertunities ? allOppertunities.reduce(function (accumulator, item) {
                     return accumulator + parseInt(item[allcount]);
                 }, 0) : 0;
                 return invoicesamount;
             }
             return allOppertunities;



             break;

         case "dueall":
         case "dueoverdue":
         case "duetoday":
         case "duetomorrow":
         case "duethisweek":
         case "duenextweek":
         case "duethismonth":
         case "duenextmonth":
         case "duefuture":

             var todayDate = new Date();
             todayDate.setHours(0, 0, 0, 0);
             let tomorrow = new Date();
             tomorrow.setDate(tomorrow.getDate() + 1);
             //var bids = dataConst.Therapies.map(m => m.BossId);


             //var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => !f.ETA) : [];


             var advancedata = dataConst.FeeAll ? dataConst.FeeAll.filter(f => f.ETA && f.ETA != null) : [];

             //var advances = advancedata ? advancedata.map(m => m.Id) : [];
             var groupedAdvance = $$this.groupBy(advancedata, "Id");

             var j1 = new Date();
             let feereciepts = dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(e => groupedAdvance && (groupedAdvance[e.FeeId] || []).length > 0) : [];

             var j2 = new Date();
             console.log("T7");
             console.log(j2.getTime() - j1.getTime());

             var paymentsGroup = $$this.groupBy(feereciepts, "FeeId");

             var paymentsWithGrouping = Object.entries(paymentsGroup);

             var paymentDict = Object.assign({}, ...(paymentsWithGrouping.map(m => ({
                 [m[0]]: m[1].reduce(function (accc, items) {
                     return accc + items.Amount;
                 }, 0)
             }))));


             var amounts = advancedata.filter(f => (f.Amount - f.SevaAmount) > (paymentDict[f.Id] ? paymentDict[f.Id] : 0));

             var peopleGroup = $$this.groupBy(dataConst.People, "Id");
             var typesGroup = $$this.groupBy(dataConst.Types, "Id");
             var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");

             var data = [];
             for(var i=0;i<amounts.length;i++)
             {
                 var a = amounts[i];
            //amounts.forEach(function (k, a) {

                 var obj = {};
                 if (isItKPI) {
                 }
                 else {
                     obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";//peopleGroup[a.BOSSId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId] ? facilitiesGroup[peopleGroup[a.BOSSId][0].CenterId][0].Name : "" : "";
                     obj.MonthId = $$this.appMonthNames[$$this.dateFromSDateTime(a.CDT).getMonth()];
                     obj.Id = a.Id;
                     obj.Kid = peopleGroup[a.BOSSId] && peopleGroup[a.BOSSId][0] ? peopleGroup[a.BOSSId][0].Name : "";
                     obj.KidId = a.BOSSId;
                     obj.Created = a.CDT;
                     obj.From = a.FDT;
                     obj.To = a.TDT;
                     obj.Total = a.Amount;
                     obj.Seva = a.SevaAmount;
                     obj.PayingDate = a.ETA;
                 }


                 obj.ETA = !a.ETA ? null : $$this.dateFromSDateTime(a.ETA) < todayDate ? "OverDue" : ($$this.dateFromSDateTime(a.ETA)).toDateString() == todayDate.toDateString() ? "Today" :
                     ($$this.dateFromSDateTime(a.ETA)).toDateString() == tomorrow.toDateString() ? "Tomorrow" :
                         ($$this.dateFromSDateTime(a.ETA) > $$this.getDateByType("thisweekstart") && $$this.dateFromSDateTime(a.ETA) <= $$this.getDateByType("thisweekend")) ? "ThisWeek" :
                             $$this.dateFromSDateTime(a.ETA) > $$this.getDateByType("thisweekend") && $$this.dateFromSDateTime(a.ETA) <= $$this.getDateByType("nextweekend") ? "NextWeek" :
                                 ($$this.dateFromSDateTime(a.ETA)).getMonth() == todayDate.getMonth() ? "ThisMonth" :
                                     ($$this.dateFromSDateTime(a.ETA)).getMonth() == (todayDate.getMonth() + 1) ? "NextMonth" :
                                         "Future";
                 // obj.PaymentType = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => typesGroup[m.TypeId] ? typesGroup[m.TypeId][0].Name : "").join() : "";

                 obj.Amount = a.Amount - a.SevaAmount - (paymentDict[a.Id] ? paymentDict[a.Id] : 0);


                 if (!isItKPI) {
                     obj.ReceivedDates = paymentsGroup[a.Id] ? paymentsGroup[a.Id].map(m => m.CDT ? m.CDT : "").join(",") : "";
                     obj.PaidAmt = paymentDict[a.Id] ? paymentDict[a.Id] : 0;
                 }
                 data.push(obj);
             }//);

             // return data;

             var amountField = "Amount";

             var AllFeeETA = data.filter(e => e.ETA && null != e.ETA && (type.toLowerCase() == "dueall" ? true : type.toLowerCase() == "due" + e.ETA.toLowerCase() + ""));
             //  if (isItKPI) {
             //     var invoicesamount = AllFeeETA ? AllFeeETA.reduce(function (accumulator, item) {
             //         return accumulator + (item[amountField]);
             //     }, 0) : 0;
             //     return invoicesamount;
             // }
             return AllFeeETA;

             if (type.toLowerCase() == "dueall") {
                 var AllFeeETA = data.filter(e => e.ETA && null != e.ETA)
                 if (isItKPI) {
                     var invoicesamount = AllFeeETA ? AllFeeETA.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }

                 return AllFeeETA
             }
             if (type.toLowerCase() == "dueoverdue") {
                 var DueETA = data.filter(e => e.ETA && new Date(e.ETA) < todayDate);

                 if (isItKPI) {
                     var invoicesamount = DueETA ? DueETA.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }
                 return DueETA
             }
             if (type.toLowerCase() == "duetoday") {
                 var TodayETA = data.filter(e => e.ETA && (new Date(e.ETA)).toDateString() == todayDate.toDateString())

                 if (isItKPI) {
                     var invoicesamount = TodayETA ? TodayETA.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }
                 return TodayETA
             }
             if (type.toLowerCase() == "duetomorrow") {
                 let currentDate = todayDate;
                 currentDate.setDate(currentDate.getDate() + 1);
                 var TomorrowETA = data.filter(e => e.ETA && (new Date(e.ETA)).toDateString() == currentDate.toDateString());

                 if (isItKPI) {
                     var invoicesamount = TomorrowETA ? TomorrowETA.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }

                 return TomorrowETA
             }

             if (type.toLowerCase() == "duethisweek") {
                 var ThisWeek = data.filter(e => e.ETA && (new Date(e.ETA) > $$this.getDateByType("thisweekstart") && new Date(e.ETA) <= $$this.getDateByType("thisweekend")))
                 if (isItKPI) {
                     var invoicesamount = ThisWeek ? ThisWeek.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }


                 return ThisWeek;
             }
             if (type.toLowerCase() == "duenextweek") {
                 var NextWeeek = data.filter(e => e.ETA && new Date(e.ETA) > $$this.getDateByType("thisweekend") && new Date(e.ETA) > $$this.getDateByType("nextweekend"))

                 if (isItKPI) {
                     var invoicesamount = NextWeeek ? NextWeeek.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }
                 return NextWeeek
             }
             if (type.toLowerCase() == "duethismonth") {
                 var Thismonth = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() == todayDate.getMonth());
                 if (isItKPI) {
                     var invoicesamount = Thismonth ? Thismonth.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }
                 return Thismonth;
             }
             if (type.toLowerCase() == "duenextmonth") {
                 var NextMonth = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() == (todayDate.getMonth() + 1));
                 if (isItKPI) {
                     var invoicesamount = NextMonth ? NextMonth.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }
                 return NextMonth;
             }
             if (type.toLowerCase() == "duefuture") {
                 var FutureDues = data.filter(e => e.ETA && (new Date(e.ETA)).getMonth() > (todayDate.getMonth() + 1))
                 if (isItKPI) {
                     var invoicesamount = FutureDues ? FutureDues.reduce(function (accumulator, item) {
                         return accumulator + (item[amountField]);
                     }, 0) : 0;
                     return invoicesamount;
                 }
                 return FutureDues;
             }
             //  if (type.toLowerCase() == "etapending") {
             //     var etapendigamount=data.filter(e=>!e.ETA)
             //     if (isItKPI) {
             //         var invoicesamount = etapendigamount ? etapendigamount.reduce(function (accumulator, item) {
             //             return accumulator + (item[amountField]);
             //         }, 0) : 0;
             //         return invoicesamount;
             //     }
             //     return etapendigamount;
             //  }


             break;


         case "compenstationcompleted":

             // var compoIds = dataConst.Compos.map(m => m.Id + "");
             var composGroup = $$this.groupBy(dataConst.Compos, "Id");
             var composGiven = dataConst.Attendance.filter(m => composGroup && (composGroup[m.F2] || []).length > 0);
             var composGivenGroup = $$this.groupBy(composGiven, "F2");

             return dataConst.Compos.filter(m => composGivenGroup && (composGivenGroup[m.Id + ""] || []).length > 0);
             // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
             break;
         case "compenstationfuture":
             var cdt = new Date();
             return dataConst.Compos.filter(m => m.ForDate && $$this.dateFromSDateTime(m.ForDate) > cdt && m.RS != "DELETEACTIVITY");

             // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
             break;
         case "compenstationtoday":
             var cdt = new Date();
             return dataConst.Compos.filter(m => m.ForDate && $$this.dateFromSDateTime(m.ForDate).toDateString() == cdt.toDateString() && m.RS != "DELETEACTIVITY");

             // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
             break;
         case "compenstationcanceled":

             return dataConst.Compos.filter(m => m.RS == "DELETEACTIVITY");

             // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
             break;

         case "compenstationorphan":
             var cdt = TDT > new Date() ? new Date() : TDT;
             var attendanceGroup = $$this.groupBy(dataConst.Attendance, "F2")
             //var compoids = dataConst.Attendance.filter(f => f.F2).map(m => m.F2);
             return dataConst.Compos.filter(m => $$this.dateFromSDateTime(m.ForDate) <= cdt && m.RS != "DELETEACTIVITY" && (attendanceGroup && (attendanceGroup[m.Id + ""] || []).length > 0));
             // return dataConst.Attendance.filter(m => compoIds.indexOf(m.F2) > -1);
             break;
         case "totalgoals":
             var totalgoaldata = dataConst.Goals ? dataConst.Goals : []
             return totalgoaldata
             break;

         case "activegoals":
             var goalsreview = dataConst.Goals ? dataConst.Goals.filter(m => m.Status != "REVIEWED") : []
             return goalsreview;
             break;
         case "todaypendinggoals":
             var goalDictionary = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? Object.fromEntries(dataConst.Goals.map(x => [x.TherapyId, x.CDT])) : null;
             var attendanceForGoals = goalDictionary != null && dataConst && dataConst.Attendance && dataConst.Attendance.length > 0 ? dataConst.Attendance.filter(m => m.Status == 'Present' && goalDictionary[m.ServiceId] && new Date(goalDictionary[m.ServiceId]) > new Date(m.ForDate)) : null;
             var attendanceDictionary = attendanceForGoals ? $$this.groupBy(attendanceForGoals, "ServiceId") : null;
             var allGoalsPending = attendanceDictionary && dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(m => attendanceDictionary[m.TherapyId] && m.Services == attendanceDictionary[m.TherapyId].length) : [];
             return allGoalsPending
             break;
         case "goalreviewed":
             var goalsreview = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && (!m.RS || m.RS != "DELETEACTIVITY" || m.RS != "DELETE") && $$this.dateFromSDateTime(m.UDT) >= FDT && $$this.dateFromSDateTime(m.UDT) < TDT) : []
             return goalsreview;
             break;

         case "activeleadsdataOLD":
             var leadsClosedStatusesforactive = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
             var availableLeads = [];
             for (let i = 0; i < dataConst.Leads.length; ++i) {
                 var leadObj = {};
                 leadObj = dataConst.Leads[i];
                 if (leadObj.F3) {
                     var f3Index = leadObj.F3.indexOf("{");
                     leadObj.F3 = leadObj.F3.slice(0, f3Index);
                     availableLeads.push(leadObj);
                 }
                 else {
                     continue;
                 }

             }
             var leads = Object.entries($$this.groupBy(availableLeads, "F3"));
             var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
             var filteredData = resultleads.filter((k) => leadsClosedStatusesforactive.indexOf(k.Status) == -1);
             return filteredData;
             break;
         case "closedleadsdataOLD":
             let closedLeadsStatus = ['CLOSED', 'NOT INTRESTED', 'ALREADY JOINED SOMEWHERE', 'WRONG CALL', 'ENROLED', 'ENROLLED', 'ENROLLED AGAIN', 'ENQUIRED FOR JOB', 'VENDOR'];
             var closedLeads = [];
             for (let i = 0; i < dataConst.Leads.length; ++i) {
                 var leadObj = {};
                 leadObj = dataConst.Leads[i];
                 if (leadObj.F3) {
                     var f3Index = leadObj.F3.indexOf("{");
                     leadObj.F3 = leadObj.F3.slice(0, f3Index);
                     closedLeads.push(leadObj);
                 }
                 else {
                     continue;
                 }

             }
             var leads = Object.entries($$this.groupBy(closedLeads, "F3"));

             var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
             var filteredData = resultleads.filter((k) => closedLeadsStatus.indexOf(k.Status) > -1);
             return filteredData;

             break;
         case "leadselsewhereOLD":
             var closedLeads = [];
             for (let i = 0; i < dataConst.Leads.length; ++i) {
                 var leadObj = {};
                 leadObj = dataConst.Leads[i];
                 if (leadObj.F3) {
                     var f3Index = leadObj.F3.indexOf("{");
                     leadObj.F3 = leadObj.F3.slice(0, f3Index);
                     closedLeads.push(leadObj);
                 }
                 else {
                     continue;
                 }

             }
             var leads = Object.entries($$this.groupBy(closedLeads, "F3"));

             var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
             var filteredData = resultleads.filter((k) => k.Status.toLowerCase() == "already joined somewhere");
             return filteredData;

             break;
         case "leadstoadmissionOLD":
             var LeadAdmission = ["enrolled", "enroled"];
             var closedLeads = [];
             for (let i = 0; i < dataConst.Leads.length; ++i) {
                 var leadObj = {};
                 leadObj = dataConst.Leads[i];
                 if (leadObj.F3) {
                     var f3Index = leadObj.F3.indexOf("{");
                     leadObj.F3 = leadObj.F3.slice(0, f3Index);
                     closedLeads.push(leadObj);
                 }
                 else {
                     continue;
                 }

             }
             var leads = Object.entries($$this.groupBy(closedLeads, "F3"));

             var resultleads = leads.map(f => f[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
             var filteredData = resultleads.filter((k) => LeadAdmission.indexOf(k.Status.toLowerCase()) > -1);
             return filteredData;

             break;
         //case "goalontime":
         //    return []
         //    break;
         //case "goallate":
         //    return []
         //    break;
         case "goalmet":

             var met = dataConst.Goals ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && (!m.RS || m.RS != "DELETEACTIVITY" || m.RS != "DELETE") && $$this.dateFromSDateTime(m.UDT) >= FDT && $$this.dateFromSDateTime(m.UDT) <= TDT && m.Review && m.Review.indexOf("F") == -1) : [];

             return met;
             break;
         case "goalnotmet":
             var notmet = dataConst.Goals ? dataConst.Goals.filter(m => m.Status == "REVIEWED" && ((!m.RS || m.RS != "DELETEACTIVITY" || m.RS != "DELETE")) && $$this.dateFromSDateTime(m.UDT) >= FDT && $$this.dateFromSDateTime(m.UDT) <= TDT && m.Review && m.Review.indexOf("F") > -1) : [];

             return notmet;
             break;
         case "conditionsstats":
             kidstate = dataConst && dataConst.KidStates && dataConst.KidStates.length > 0 ? dataConst.KidStates : [];
             if (kidstate) {
                 for(var i=0;i<kidstate.length;i++)
                 {
                     var e = kidstate[i];
                 //kidstate.forEach(function (e) {
                     e.Condition = e.Kid + "+" + e.TypeId + "+" + e.Category + ""
                 }//);
             }

             var groupedKidstate = kidstate ? $$this.groupBy(kidstate, "Condition") : [];
             var firstRecords = Object.entries(groupedKidstate).map(m => m[1].sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1))[0]);

             var conditionStates = $$this.groupBy(firstRecords || [], "Category");


             var categories = (dataConst.MirracleTypes || []).filter(f => f.Category == "MIRAVERSECONDITIONS");

             var allConditions = [];
             for(var i=0;i<categories.length;i++)
             {
                 var e = categories[i];
             //categories.forEach(function (e) {
                 var obj = {};
                 obj.Condition = e.Title;
                 obj.Services = categories && categories[e.Id] ? categories[e.Id].length : 0;
                 allConditions.push(obj);
             } //);

             allConditions.sort((a, b) => (b.Services - a.Services));


             break;
         case "kidconditionsandbehaviours":
             var kidstate = [];
             kidstate = dataConst && dataConst.KidStates && dataConst.KidStates.length > 0 ? dataConst.KidStates : [];
             if (kidstate) {

                 for(var i=0;i<kidstate.length;i++)
                 {
                     var e = kidstate[i];
                 //kidstate.forEach(function (e) {
                     e.Condition = e.Kid + "+" + e.TypeId + "+" + e.Category + ""
                 //});
             }
             }


             var groupedKidstate = kidstate ? $$this.groupBy(kidstate, "Condition") : [];
             var firstRecords = Object.entries(groupedKidstate).map(m => m[1].sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1))[0]);

             var cmaxScore = Math.ceil(((firstRecords.filter(f => f.Category == $$this.KidStateCategoryEnum.Condition).map(m => m.Score)).sort((a, b) => b - a)[0]) / 3);
             var bmaxScore = Math.ceil(((firstRecords.filter(f => f.Category == $$this.KidStateCategoryEnum.Tantrum).map(m => m.Score)).sort((a, b) => b - a)[0]) / 3);
             groupedKidstate = $$this.groupBy(firstRecords, "Condition");


             var allTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => (!e.RS || e.RS != "DELETEACTIVITY" || e.RS != "DELETE")) : []
           
             for(var i=0;i<allTherapies.length;i++)
             {
                 var e = allTherapies[i];
            // allTherapies.forEach(function (e) {
                 try {
                     e.Condition = groupedKidstate && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Condition] && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Condition].length > 0 ? "Yes" : "NO";
                     e.Tantrum = groupedKidstate && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Condition] && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Tantrum].length > 0 ? "Yes" : "NO";
                     e.ConditionScore = groupedKidstate && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Condition] && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Condition].length > 0 ? groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Condition][0].Score : 0;
                     e.TantrumScore = groupedKidstate && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Tantrum] && groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Tantrum].length > 0 ? groupedKidstate[e.BossId + "+" + e.TypeId + "+" + $$this.KidStateCategoryEnum.Tantrum][0].Score : 0;
                     e.ConditionsRange = e.ConditionScore == 0 ? "Pending" : 0 < e.ConditionScore && e.ConditionScore <= cmaxScore ? "0 - " + cmaxScore : cmaxScore < e.ConditionScore && e.ConditionScore <= 2 * cmaxScore ? cmaxScore + " - " + 2 * (cmaxScore) : 2 * (cmaxScore) + " - " + 3 * (cmaxScore);
                     e.BehavioursRange = e.TantrumScore == 0 ? "Pending" : 0 < e.TantrumScore && e.TantrumScore <= bmaxScore ? "0 - " + bmaxScore : bmaxScore < e.TantrumScore && e.TantrumScore <= 2 * bmaxScore ? bmaxScore + " - " + 2 * (bmaxScore) : 2 * (bmaxScore) + " - " + 3 * (bmaxScore);

                 }
                 catch (ex) {
                     e.ConditionScore = 0;
                     e.TantrumScore = 0;
                     e.ConditionsRange = "Pending";
                     e.BehavioursRange = "Pending";
                 }
             } //);
             allTherapies.sort((a, b) => (b.ConditionScore - a.ConditionScore));

             //allTherapies =  allTherapies.filter(m=> m.Condition == "NO" || m.Tantrum == "NO");



             return allTherapies;
             break;
         case "pollinate":
             var services = dataConst.Therapies;
             var serviceIds = Object.entries($$this.groupBy(dataConst.Therapies, "BossId"));

             var total = 0;
             for (var i = 0; i < $$this.servicesOfeering.length; i++) {
                 var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf($$this.servicesOfeering[i].Id) == -1);
                 total += (boss || []).length;
             }
             return total;

         case "pollinatedata":
         case "pollinationoptyst":
         case "pollinationoptyot":
         case "pollinationoptyaba":
         case "pollinationoptyse":
             var people = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter((e) => e.RS != "DELETEACTIVITY" && e.F8 != 1) : [];
             var therapiesAll = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter((e) => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
             therapiesAll = therapiesAll || [];
             people = people || [];
             var facilityTherapies = dataConst.FacilityTherapies || [];
             var facilityPeople = dataConst.FacilityPeople || [];
             people.push(...facilityPeople);
             therapiesAll.push(...facilityTherapies);

             //var fids = [];
             //if (!fids) {
             //    fids = dataConst.Centers.map(m => m.Id);
             //}


             var therapistRoleId = $$this.GetTypeIdByName(dataConst.Types, "Therapist");
             var therapists = Object.entries($$this.groupBy(people.filter(f => therapistRoleId == f.RoleId), "Id")).map(m => m[1][0]);
             var therapies = therapiesAll ? therapiesAll : [];
             var kidsServices = $$this.groupBy(therapiesAll, "BossId");
             var serviceIds = Object.entries(kidsServices);

             var peopleGroup = $$this.groupBy(people, "Id");
             var centersGroup = $$this.groupBy(dataConst.Centers, "Id");

             var pollination = [];
             var sofferings = $$this.servicesOfeering;
             switch (type.toLowerCase()) {
                 case "pollinationoptyst":
                     sofferings = $$this.servicesOfeering.filter(f => f.ShortName == "ST");
                     break;
                 case "pollinationoptyot":
                     sofferings = $$this.servicesOfeering.filter(f => f.ShortName == "OT");
                     break;
                 case "pollinationoptyaba":
                     sofferings = $$this.servicesOfeering.filter(f => f.ShortName == "BT");
                     break;
                 case "pollinationoptyse":
                     sofferings = $$this.servicesOfeering.filter(f => f.ShortName == "SE");
                     break;
             }

             if (type && (type.toLowerCase() == "pollinationoptyst" || type.toLowerCase() == "pollinationoptyot" || type.toLowerCase() == "pollinationoptyaba" || type.toLowerCase() == "pollinationoptyse")) {

             }

             for (var i = 0; i < sofferings.length; i++) {
                 var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf(sofferings[i].Id) == -1).map(m => m[0]);
                 boss = (boss || []);

                 for (var b = 0; b < boss.length; b++) {
                     var tids = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => peopleGroup && peopleGroup[m.TherapistId] && peopleGroup[m.TherapistId][0] ? peopleGroup[m.TherapistId][0].Name + "\n\n" : "\n\n") : [];
                     //therapistName+= names.Id+"#"+names.Name+"{#}"

                     var therapistNames = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => peopleGroup && peopleGroup[m.TherapistId] && peopleGroup[m.TherapistId][0] ? m.TherapistId + "#" + peopleGroup[m.TherapistId][0].Name + "\n\n" : "\n\n").join("{#}") : "";

                     var FId = kidsServices[boss[b]] ? kidsServices[boss[b]].map(m => m.CenterId)[0] : null;


                     pollination.push({ BossId: boss[b], TOId: boss[b], ServiceId: sofferings[i].Id, "KidName": (peopleGroup[boss[b]] && peopleGroup[boss[b]][0] ? peopleGroup[boss[b]][0].Name : ""), "Facility": (peopleGroup[boss[b]] && peopleGroup[boss[b]][0] && centersGroup[peopleGroup[boss[b]][0].CenterId] ? centersGroup[peopleGroup[boss[b]][0].CenterId][0].Name : ""), "Discipline": sofferings[i].ShortName, "ServiceName": sofferings[i].Name, Therapist: therapistNames, FId: FId });
                 }
             }




             return pollination;

         case "available":


             var therapists = dataConst.Therapists;
             therapists = therapists && therapists.length > 0 ? therapists.filter(e => (!e.RS || e.RS != "DELETEACTIVITY")) : therapists;

             var slots = $$this.getSlotsByData(dataConst.Therapies, therapists);
             return slots;
             break;


         case "activestaff":
             var bossRoleId = dataConst.Types.filter(m => m.Name == "Boss")[0].Id;
             // f.RoleId == therapistId &&
             var filteredStaff = dataConst.People.filter(f => f.RoleId != bossRoleId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF" && f.RS != "DELETEACTIVITY" && f.F8 != 1);
             filteredStaff = Object.entries($$this.groupBy(filteredStaff, "Id")).map(m => m[1][0]);
             return filteredStaff;
             break;
         case "activeparents":
             var pIds = dataConst.Therapies.map(m => m.BossId);
             var parentsTofilter = dataConst && dataConst.Parents ? dataConst.Parents : dataConst.People;
             var filteredParents = parentsTofilter.filter(p => pIds.indexOf(p.Id) > -1);
             var groupedParents = Object.entries($$this.groupBy(filteredParents, "Handle"));
             var uniqParents = groupedParents.map(m => m[1][0]);
             return uniqParents;
             break;
         case "leftparents":
             var available = [];
             var pIds = dataConst.InActive.filter(t => $$this.dateFromSDateTime(t.F14) >= FDT && $$this.dateFromSDateTime(t.F14) <= TDT).map(m => m.BossId);
             var parentsTofilter = dataConst && dataConst.Parents ? dataConst.Parents : dataConst.People;
             var currentparents = parentsTofilter.filter(p => pIds.indexOf(p.Id) > -1);
             var serviceData = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => (e.RS == null || e.RS != "DELETEACTIVITY") && (!e.Status || e.Status != "INACTIVE")).map(k => k.BossId) : [];

             var filteredParents = currentparents && currentparents.length > 0 ? currentparents.filter(e => serviceData.indexOf(e.Id) == -1) : [];
             // for(var i=0;i<currentparents.length;i++){
             //     var serviceData=dataConst.Therapies.filter(e=>e.BossId==currentparents[i].Id && e.RS!="DELETEACTIVITY" && e.Status!="INACTIVE")
             //     if(serviceData.length<=0){
             //         available.push(currentparents[i])
             //     }
             // }
             //  return available;
             return filteredParents;
             break;
         case "addedparents":
             var bossId = dataConst.Types.filter(m => m.Name == "Boss")[0].Id
             var filteredStaff = dataConst.People.filter(f => f.RoleId == bossId && f.F8 != 1 && f.RS != "DELETEACTIVITY");
             return filteredStaff.filter(p => p.CDT && $$this.dateFromSDateTime(p.CDT) >= FDT && $$this.dateFromSDateTime(p.CDT) <= TDT);
             break;
         case "addedstaff":
             var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
             var filteredStaff = dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF");
             return filteredStaff.filter(f => f.CDT && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT);
             break;
         case "leftstaff":
             var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id
             var filteredStaff = dataConst.People.filter(f => f.RoleId == therapistId && f.F8 == 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF");
             return filteredStaff.filter(f => f.UDT && $$this.dateFromSDateTime(f.UDT) >= FDT && $$this.dateFromSDateTime(f.UDT) <= TDT);
             break;
         case "staffbots":
             var filteredStaff = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter(f => f.F22 && f.F22 == "BOT") : [];
             if (!filteredStaff || filteredStaff.length == 0) {
                 return [];
             }
             var key = 'Handle';
             var arrayUniqueByKey = [...new Map(filteredStaff.map(item => [item[key], item])).values()];
             return arrayUniqueByKey;
             break;
         case "blockedstaff":
             var filteredStaff = dataConst && dataConst.People && dataConst.People.length > 0 ? dataConst.People.filter(f => f.RS && f.RS == "DELETEACTIVITY" && f.F22 && f.F22 == "BLOCKED") : [];
             if (!filteredStaff || filteredStaff.length == 0) {
                 return [];
             }
             var key = 'Handle';
             var arrayUniqueByKey = [...new Map(filteredStaff.map(item => [item[key], item])).values()];
             return arrayUniqueByKey;
             break;
         case "activememos":
             return dataConst.Memos.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.Status != "CLOSED");
             break;
         case "closedmemos":
             return dataConst.Memos.filter(f => f.Status == "CLOSED" && $$this.dateFromSDateTime(f.UDT) >= FDT && $$this.dateFromSDateTime(f.UDT) <= TDT);
             break;


         case "viewpayslips":

             var typeId = $$this.GetTypeIdByName(dataConst.Types, "VIEWPAYSLIP")



             return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId) : [];


             break;
         case "downloadpayslips":
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "DOWNLOADPAYSLIP")



             return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) : [];
             break;
         case "salary":

             var typeId = $$this.GetTypeIdByName(dataConst.Types, "PAYSLIP")



             return dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == typeId && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) : [];
             break;
         case "paid":
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva")
             var thismonth = dataConst.Fee.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation")).map(m => m.Id);
             return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.TypeId != typeId);
         case "paidseva":
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva")
             var thismonth = dataConst.Fee.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation")).map(m => m.Id);
             return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);

         case "advancepaid":
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva")
             //var thismonth = dataConst.FutureInvoices.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation")).map(m => m.Id);
             var thismonth = dataConst.FutureInvoicesCDTThisMonth.filter(f => (!f.Remarks || f.Remarks.toLowerCase() != "system automation")).map(m => m.Id);
             return dataConst.FeeReceipt.filter(f => thismonth.indexOf(f.FeeId) > -1 && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.TypeId != typeId);

         case "advancepaidseva":
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva")
             //var thismonth = dataConst.FutureInvoices.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
             var thismonth = dataConst.FutureInvoicesCDTThisMonth.filter(f => (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
             var groupedData = $$this.groupBy(thismonth, "Id");
             return dataConst.FeeReceipt.filter(f => groupedData && groupedData[f.FeeId] && groupedData[f.FeeId].length > 0 && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);

         case "pastpaid":
             var startDate = new Date();
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva")
             //var futuremonth = dataConst.FutureInvoices.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
             var futuremonth = dataConst.FutureInvoicesCDTThisMonth.filter(f => (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
             var thismonth = dataConst.Fee.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) || (f.Remarks && f.Remarks.toLowerCase() == "system automation"));
             var combinedData = futuremonth.concat(thismonth);
             // var combinedData = [...futuremonth,...thismonth];
             var groupedData = $$this.groupBy(combinedData, "Id");
             var pastpaidData = dataConst.FeeReceipt.filter(f => f.TypeId != typeId && !groupedData[f.FeeId] && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT);
             console.log("past paid this",$$this.GetDateDiff(startDate, new Date()))
             return pastpaidData;
         case "alreadyfulfilled":
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva")
             var oldInvoices = dataConst.Fee.filter(f => f.Type != "ASSESSMENTS" && ($$this.dateFromSDateTime(f.CDT) < FDT) && (!f.Remarks || f.Remarks.toLowerCase() != "system automation"));
             var groupedIds = $$this.groupBy(oldInvoices, "Id");
             return dataConst.FeeReceipt.filter(f => groupedIds && groupedIds[f.FeeId] && groupedIds[f.FeeId].length > 0 && $$this.dateFromSDateTime(f.CDT) < FDT && f.TypeId != typeId);

         case "tobefulfilled":
             var startDate = new Date()
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva")
             var allinvoices = dataConst.FeeAll.filter(f => f.Type != "ASSESSMENTS" && $$this.dateFromSDateTime(f.FDT) >= FDT);
             console.log("tobefulfilled", $$this.GetDateDiff(startDate, new Date()))
             return allinvoices;

         case "pastpaidseva":

             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva")
             //var futuremonth = dataConst.FutureInvoices.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT);
             var futuremonth = dataConst.FutureInvoicesCDTThisMonth;
             var thismonth = dataConst.Fee.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT);
             var combinedData = futuremonth.concat(thismonth);
             //var combinedData = [...futuremonth,...thismonth];
             var groupedData = $$this.groupBy(combinedData, "Id");

             return dataConst.FeeReceipt.filter(f => (!groupedData[f.FeeId] || groupedData[f.FeeId].length == 0) && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT && f.TypeId == typeId);


         case "discount":
             return dataConst.FeeAll.filter(f => ((f.Remarks && f.Remarks.toLowerCase() == "system automation") ? ($$this.dateFromSDateTime(f.FDT) >= FDT && $$this.dateFromSDateTime(f.FDT) <= TDT) : ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) < TDT)) && f.Discount > 0 && f.Remarks != "Renewal Offer" && f.Remarks != "PINNACLEGIFTVOUCHER");


         case "expenses":

             var typeId = dataConst.Types.find(f => f.Name.toLowerCase() == "expenses" && f.Category == "Activitytype").Id;



             return dataConst.CenterNotes ? dataConst.CenterNotes.filter(f => f.TypeId == typeId && $$this.dateFromSDateTime(f.FDT) >= FDT && $$this.dateFromSDateTime(f.FDT) <= TDT && (!f.RS || f.RS != "DELETEACTIVITY")) : [];
             break;

         //feedbacksgiven
         case "feedbacksgiven":

             return dataConst.Feedback ? dataConst.Feedback : [];
             break;

         case "totalstaff":
             var staffdata = dataConst.People ? dataConst.People.filter((e) => e.RoleId != 28) : []
             return staffdata;
             break;
         case "biometricabsent":
             var biometricabsent = []
             return biometricabsent;
             break;
         case "biometricpresent":
             var biometricpresent = []
             //var biometricpresent = $$this.groupBy(dataConst.Biometric,new Date("FDT").getDate());
             //var present = $$this.groupBy(dataConst.Biometric,m=> new Date(m.FDT).getDate());
             //var biometricpresent = dataConst.Biometric.$$this.groupBy(m => new Date(m.FDT).Date + "#" + m.TOId).map(m => m.OrderByDescending(o => o.CDT)[0]);
             return biometricpresent;
             break;
         case "biometricentryearly":
             var biometricentryearly = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? new Date(m.FDT).getTime() < $$this.getTimeData(9, 30, 0, 0, m.FDT) : new Date(m.FDT).getTime() < $$this.getTimeData(8, 35, 0, 0, m.FDT)) : [];
             return biometricentryearly;
             break;
         case "biometricentryontime":
             var biometricentryontime = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? (new Date(m.FDT).getTime() >= $$this.getTimeData(9, 30, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= $$this.getTimeData(9, 35, 0, 0, m.FDT)) : (new Date(m.FDT).getTime() >= $$this.getTimeData(8, 30, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= $$this.getTimeData(8, 35, 0, 0, m.FDT))) : [];
             return biometricentryontime;
             break;
         case "biometricentrylate":
             var biometricentrylate = dataConst.Biometric ? dataConst.Biometric.filter(m => m.F2 == 1 ? new Date(m.FDT).getTime() > $$this.getTimeData(9, 35, 0, 0, m.FDT) && new Date(m.FDT).getTime() < $$this.getTimeData(12, 0, 0, 0, m.FDT) : new Date(m.FDT).getTime() > $$this.getTimeData(8, 35, 0, 0, m.FDT)) : [];
             return biometricentrylate;
             break;
         case "biometricexitearly":
             var biometricexitearly = dataConst.Biometric ? dataConst.Biometric.filter(m => new Date(m.FDT).getTime() < $$this.getTimeData(19, 0, 0, 0, m.FDT)) : [];
             return biometricexitearly;
             break;
         case "biometricexitontime":
             var biometricexitontime = dataConst.Biometric ? dataConst.Biometric.filter(m => (new Date(m.FDT).getTime() >= $$this.getTimeData(19, 0, 0, 0, m.FDT) && new Date(m.FDT).getTime() <= $$this.getTimeData(19, 5, 0, 0, m.FDT))) : [];
             return biometricexitontime;
             break;
         case "biometricexitlate":
             var biometricexits = dataConst.Biometric ? dataConst.Biometric.filter((m) => new Date(m.FDT).getTime() > $$this.getTimeData(19, 5, 0, 0, m.FDT)) : [];
             return biometricexits;
             break;

         case "feedbackratings":
             var allFeedbacks = dataConst.Feedback ? dataConst.Feedback : [];

             var totalRating = allFeedbacks.reduce(function (accumulator, item) {
                 return accumulator + item.Rating;
             }, 0);
             return totalRating;
             break;

         case "servicerequests":
             var serviceRequests = dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest : [];
             var analytics = dataConst.ServiceRequestAnalytic.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1));
             var responses = $$this.groupBy(analytics, "SRId");

             var srs = serviceRequests.map(function (m) {
                 return {
                     ...m, "LastAnalytic"
                         : ((responses[m.Id + ""] && responses[m.Id + ""].length > 0) ? responses[m.Id + ""][0] : null)
                 }
             });
             //})
             return srs;
             break;
         case "chilatest":
             var CHITypeId = dataConst.Types.filter(f => f.Name == "CHI")[0].Id;
             var allCHIData = dataConst.CenterNotes.filter(f => f.TypeId == CHITypeId && (!f.RS || f.RS != "DELETEACTIVITY"));
             var latestCHIDate = allCHIData && allCHIData.length > 0 ? allCHIData.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : null;
             var returnData = {};
             if (latestCHIDate) {
                 var latestCHIDateValue = new Date(latestCHIDate);
                 var startCHI = new Date(latestCHIDateValue.getFullYear(), latestCHIDateValue.getMonth(), 1);

                 var allAssessments = allCHIData.filter(f => $$this.dateFromSDateTime(f.CDT) >= startCHI);
                 returnData.Assessments = allAssessments;

                 var assmids = allAssessments.map(m => m.Id);
                 var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];
                 if (allResposnese) {
                     allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
                         var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
                         if (!result[key]) {
                             result[key] = currentValue
                         }
                         return result;
                     }, {})).map(m => m[1]);


                 }

                 allResposnese = allResposnese || [];
                 returnData.Reponses = allResposnese;

             }

             return returnData;
             break;
         case "pisilatest":
             var PISITypeId = dataConst.Types.filter(f => f.Name == "PISI")[0].Id;
             var allCHIData = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == PISITypeId) : [];
             var latestCHIDate = allCHIData.length > 0 ? allCHIData.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : [];

             var returnData = {};
             if (latestCHIDate) {
                 var latestCHIDateValue = new Date(latestCHIDate);
                 var startCHI = new Date(latestCHIDateValue.getFullYear(), latestCHIDateValue.getMonth(), 1);

                 var allAssessments = allCHIData.filter(f => $$this.dateFromSDateTime(f.CDT) >= startCHI);
                 returnData.Assessments = allAssessments;

                 var assmids = allAssessments.map(m => m.Id);
                 var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];
                 if (allResposnese && allResposnese.length > 0) {
                     allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
                         var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
                         if (!result[key]) {
                             result[key] = currentValue
                         }
                         return result;
                     }, {})).map(m => m[1]);


                 }

                 allResposnese = allResposnese || [];
                 returnData.Reponses = allResposnese;

             }

             return returnData;
             break;
         case "whilatest":
             var WHITypeId = $$this.GetTypeIdByName(dataConst.Types, "WHI");//.filter(f => f.Name == "WHI")[0].Id;
             var allWHIData = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == WHITypeId) : [];
             var latest = allWHIData && allWHIData.length > 0 ? allWHIData.sort((a, b) => ($$this.dateFromSDateTime(a.CDT) > $$this.dateFromSDateTime(b.CDT) ? -1 : 1))[0].CDT : null;

             var returnData = {};

             if (latest) {

                 var latestDate = new Date(latest);
                 var start = new Date(latestDate.getFullYear(), latestDate.getMonth(), 1);
                 var allAssessments = allWHIData.filter(f => $$this.dateFromSDateTime(f.CDT) >= start);
                 returnData.Assessments = allAssessments;

                 var assmids = allAssessments.map(m => m.Id);
                 var allResposnese = dataConst.Responses ? dataConst.Responses.filter(f => assmids.indexOf(f.CenterNoteId) > -1 || assmids.indexOf(f.PeopleNoteId) > -1) : [];

                 if (allResposnese) {
                     allResposnese = Object.entries(allResposnese.reduce((result, currentValue) => {
                         var key = currentValue.Question + "_" + currentValue.CenterNoteId + "_" + currentValue.PeopleNoteId + "_" + currentValue.Type + "_" + currentValue.CBPI + "_" + currentValue.TOId;
                         if (!result[key]) {
                             result[key] = currentValue
                         }
                         return result;
                     }, {})).map(m => m[1]);



                 }
                 allResposnese = allResposnese || [];
                 returnData.Reponses = allResposnese;
                 var ranks = allResposnese.filter(f => f.Type == "RANK");
                 var suggestions = allResposnese.filter(f => f.Type == "SUGGESTION");

                 returnData.Suggestions = suggestions;

                 //var peopleData = $$this.groupBy(dataConst.People, "Id");
                 //var centers = $$this.groupBy(dataConst.Centers, "Id");
                 var final = [];
                 for (const [indexval, values] of Object.entries($$this.groupBy(ranks, 'IQMId'))) {


                     var ranks = Object.entries($$this.groupBy(values, 'TOId')).map(function (m) { return { "Id": m[0], "TOId": m[0], "RDId": indexval, "Weightage": (m[1].reduce((partialSum, a) => partialSum + parseInt(a.Response), 0)) } });

                     var length = ranks.length;


                     var P10 = Math.ceil((length * 10.0 / 100));
                     var M50 = Math.ceil((length * 50.0 / 100));
                     var B90 = Math.ceil((length * 90.0 / 100));


                     ranks = ranks.sort((a, b) => (a.Weightage > b.Weightage ? 1 : -1));


                     var weightage = $$this.groupBy(ranks, "Weightage");
                     var rank = 0;

                     for (const [index, content] of Object.entries(weightage)) {
                         rank++;

                         for(var i=0;i<content.length;i++)
                         {
                             var a = content[i];
                         //content.forEach(function (a) {
                             var rankTextId = rank <= P10 ? "top10" : rank <= M50 ? "top40" : rank <= B90 ? "bottom40" : "bottom10";
                             a = { "Rank": rank, "RankTextId": rankTextId, ...a };

                             final.push(a);
                         } //);


                     }


                 }

                 returnData.Ranks = final;
                 // console.log("returnData.Ranks");
                 //console.log(returnData.Ranks);



             }

             return returnData;


             break;

         case "leaverequestnonparentcompleted":
             var currentDate = new Date();
             const types1 = dataConst.Types ? dataConst.Types : [];
             var leaverequestId = $$this.GetTypeIdByName(types1, "LEAVEREQUEST");

             var allLeaves = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestId && f.RS!="DELETEACTIVITY" && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];

             var completednpLeaves = allLeaves.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && $$this.dateFromSDateTime(m.FDT) <= currentDate && m.Status != "Cancelled");
             return completednpLeaves;
             break;
         case "leaverequestcomposlt4":
             var currentDate = new Date();
             const types2 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIds = $$this.GetTypeIdByName(types2, "LEAVEREQUEST");

             var allLeavesData = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIds && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];

             var leaverequestcomposlt4 = allLeavesData.filter(m => m.F1 && (m.F1.toLowerCase() == "therapist" || m.F1.toLowerCase() == "adminfortherapist") && m.F2 && parseInt(m.F2) < 4);
             return leaverequestcomposlt4;
             break;
         case "leaverequestanalytic":
             var currentDate = new Date();
             const types3 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIdsforapproved = $$this.GetTypeIdByName(types3, "LEAVEREQUEST");

             var allLeavesData1 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdsforapproved &&  f.RS!="DELETEACTIVITY" &&($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];

             var approvedLeaves = allLeavesData1.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status && m.Status.toUpperCase() == "APPROVED");

             return approvedLeaves;
             break;
         case "leaverequestnonparentcanceled":
             var currentDate = new Date();
             const types4 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIdforCanceledleaves = $$this.GetTypeIdByName(types4, "LEAVEREQUEST");

             var allLeavesData2 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdforCanceledleaves && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];
             var cancellednpLeaved = allLeavesData2 ? allLeavesData2.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status == "Cancelled" && m.UDT && $$this.dateFromSDateTime(m.UDT) >= FDT && $$this.dateFromSDateTime(m.UDT) <= TDT) : [];
             return cancellednpLeaved;
             break;
         case "leaverequestanalyticunapproved":
             var currentDate = new Date();
             const types5 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIdforCanceledleaves = $$this.GetTypeIdByName(types5, "LEAVEREQUEST");
             var allLeavesData3 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdforCanceledleaves && f.RS!="DELETEACTIVITY" &&($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];
             var unapprovedLeaves = allLeavesData3.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && m.Status && m.Status.toUpperCase() == "UNAPPROVED");
             return unapprovedLeaves;
             break;
         case "leavespendingapproval":
             var currentDate = new Date();
             const types10 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIdforPendingleaves = $$this.GetTypeIdByName(types10, "LEAVEREQUEST");
             var allLeavesData3 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdforPendingleaves && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];
             var pendingleaves = allLeavesData3.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && (!m.Status || m.Status == null || m.Status == '' || m.Status == 'Pending') && m.RS != "DELETEACTIVITY");
             return pendingleaves;
             break;
         //leavespendingapproval
         // var pendingLeaves = GetReportsData("leavespendingapproval", dataConst, true, fdt, tdt, facility);

         case "leaverequestnonparentfuture":
             var currentDate = new Date();
             const types6 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIdforCanceledleaves = $$this.GetTypeIdByName(types6, "LEAVEREQUEST");
             var allLeavesData4 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIdforCanceledleaves && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT)) && (!f.F1 || f.F1.toLowerCase() != "parent") && $$this.dateFromSDateTime(f.FDT) > currentDate && f.Status != "Cancelled" && f.RS!="DELETEACTIVITY") : [];
             //var futurenpLeaves = allLeavesData4.filter(m => (!m.F1 || m.F1.toLowerCase() != "parent") && $$this.dateFromSDateTime(m.FDT) > currentDate && m.Status != "Cancelled");
             return allLeavesData4;
             break;
         case "leaverequestparentfuture":
             var currentDate = new Date();
             const types7 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIds = $$this.GetTypeIdByName(types7, "LEAVEREQUEST");
             var allLeavesData5 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIds &&  f.RS!="DELETEACTIVITY" && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];
             var futurenpLeavesParent = allLeavesData5.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && $$this.dateFromSDateTime(m.FDT) > currentDate && m.Status != "Cancelled");
             return futurenpLeavesParent;
             break;
         case "leaverequestparentcompleted":
             var currentDate = new Date();
             const types8 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIds = $$this.GetTypeIdByName(types8, "LEAVEREQUEST");
             var allLeavesData6 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIds && f.RS!="DELETEACTIVITY" && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];
             var completedParentleaves = allLeavesData6.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && $$this.dateFromSDateTime(m.FDT) <= currentDate && m.Status != "Cancelled");
             return completedParentleaves;
             break;
         case "leaverequestparentcanceled":
             var currentDate = new Date();
             const types9 = dataConst.Types ? dataConst.Types : [];
             var leaverequestIds = $$this.GetTypeIdByName(types9, "LEAVEREQUEST");
             var allLeavesData4 = dataConst.PeopleNotes ? dataConst.PeopleNotes.filter(f => f.TypeId == leaverequestIds && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];
             var cancelledLeaved = allLeavesData4.filter(m => m.F1 && m.F1.toLowerCase() == "parent" && m.Status == "Cancelled" && m.UDT && $$this.dateFromSDateTime(m.UDT) >= FDT && $$this.dateFromSDateTime(m.UDT) <= TDT);
             return cancelledLeaved;
             break;
         case "awardswon":
             var awards = dataConst.Awards ? dataConst.Awards.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) : [];
             return awards;
             break;
         case "lockedaccounts":
             var adminId = $$this.GetTypeIdByName(dataConst.Types, "Receptionist")
             var TherapistId = $$this.GetTypeIdByName(dataConst.Types, "Therapist")
             var caretakerId = $$this.GetTypeIdByName(dataConst.Types, "CareTaker")
             var accounts = dataConst.People ? dataConst.People.filter(e => ((e.F8 != 0 || e.F8 != null) || (e.RS != "ACTIVE" || e.RS != null)) && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId) && e.F17 && (e.F17).indexOf("SYSTEM INACTIVATED DUE TO CONSEQUITE LEAVES MORE THAN") > -1) : [];
             // var accounts=[];
             var key = 'Handle';
             var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
             return arrayUniqueByKey;
             break;
         case "unlockedaccounts":
             var adminId = $$this.GetTypeIdByName(dataConst.Types, "Receptionist")
             var TherapistId = $$this.GetTypeIdByName(dataConst.Types, "Therapist")
             var caretakerId = $$this.GetTypeIdByName(dataConst.Types, "CareTaker")
             var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 == 0 || e.RS == "ACTIVE" && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId) && e.F17 && (e.F17).indexOf("SYSTEM ACTIVATED THE ACCOUNT FROM BIOMETRIC SYNC") > -1) : [];
             var key = 'Handle';
             var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
             return arrayUniqueByKey;
             break;
         case "staffutil":
             var TherapistId = $$this.GetTypeIdByName(dataConst.Types, "Therapist")
             var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 != 1 && e.RS != "DELETEACTIVITY" && e.RoleId == TherapistId) : [];
             var key = 'Handle';
             var arrayUniqueByKey = [...new Map(accounts.map(item => [item[key], item])).values()];
             return arrayUniqueByKey;
             break;
         case "birthdayreports":
             var adminId = $$this.GetTypeIdByName(dataConst.Types, "Receptionist")
             var TherapistId = $$this.GetTypeIdByName(dataConst.Types, "Therapist")
             var caretakerId = $$this.GetTypeIdByName(dataConst.Types, "CareTaker")
             var ownerId = $$this.GetTypeIdByName(dataConst.Types, "Owner");
             var accounts = dataConst.People ? dataConst.People.filter(e => e.F8 != 1 && e.RS != "DELETEACTIVITY" && (e.RoleId == adminId || e.RoleId == TherapistId || e.RoleId == caretakerId || e.RoleId == ownerId) && (new Date(e.DOB).getMonth() == new Date(FDT).getMonth())) : [];
             return accounts;

             break;
         case "gracecompensation":
             var gracetypeId = dataConst.Types.filter(f => f.Name == "Grace Compensation Request" && f.Category == "Service Request")[0].Id;
             var servicerequestAnalytics = Object.entries($$this.groupBy((dataConst.ServiceRequestAnalytic || []), "SRId")).map(m => m[1].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? -1 : 1))[0]);
             var allPeople = dataConst.People;
             var parentId = $$this.GetTypeIdByName(dataConst.Types, "Boss");
             var filterKids = allPeople && allPeople.length > 0 ? allPeople.filter(e => e.RoleId != parentId && (null == e.RS || e.RS != "DELETEACTIVITY")) : [];
             var kids = filterKids && filterKids.length > 0 ? filterKids.map(e => e.Id) : []; //NEED TO FIX STOPPEd FOR CF ERRORS
             var srData = $$this.groupBy((dataConst.ServiceRequestAnalytic || []), "SRId");
             // var requests = dataConst && dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(f => f.TypeId == gracetypeId && srData[f.Id] && srData[f.Id].Status == "CLOSED" && srData[f.Id].CBPI == f.CBPI && kids.indexOf(f.TOId) > -1 && ($$this.dateFromSDateTime(f.FDT) >= FDT) && ($$this.dateFromSDateTime(f.FDT) <= TDT) && srData[f.Id].Amount > 0) : [];
             var requests = dataConst && dataConst.ServiceRequest && dataConst.ServiceRequest.length > 0 ? dataConst.ServiceRequest.filter(f => f.TypeId == gracetypeId && ($$this.dateFromSDateTime(f.FDT) >= FDT) && ($$this.dateFromSDateTime(f.FDT) <= TDT)) : [];

             return requests;
             break;
         case "noprofileusers":
             var allPeople = dataConst.People;
             var leadId = $$this.GetTypeIdByName(dataConst.Types, "Lead");
             var parentId = $$this.GetTypeIdByName(dataConst.Types, "Boss");
             var filteredByPeople = allPeople.filter(e => e.RoleId != leadId && e.RoleId != parentId);
             var filtereByProfile = filteredByPeople.filter(e => e.IsProfileSet != 1);
             return filtereByProfile;
             break;
         case "dangpendingtoday":
             var dangAnalyticTypeId = $$this.GetTypeIdByName(dataConst.Types, "DANGANALYTIC");
             var dangType = dataConst && dataConst.Types && dataConst.Types.length > 0 ? dataConst.Types.filter(e => e.Name == "DANG")[0] : '';

             var currentDang = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(f => f.TypeId == dangAnalyticTypeId && new Date(f.CDT) >= FDT && new Date(f.CDT) <= TDT) : [];
             var dtN = new Date();
             dtN.setHours(5);
             dtN.setMinutes(30);
             var todayDang = currentDang.filter(f => $$this.dateFromSDateTime(f.CDT).toDateString() == new Date().toDateString());
             var pendingorToday = $$this.CalculateDangPendingForToday(todayDang, dangType, new Date(), new Date(), facility, dataConst.People);
             return pendingorToday;
             break;
         case "allpendingcourses":
             var totalPending = 0;
             var totalTantrumsPending = 0;
             var totalConditionsPending = 0;
             var ptiPendingAssesmsnets = 0;
             var leaveApprovalPending = 0;

             var pendingObj = {};

             var allCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? dataConst.MirracleTypes.filter(function (e) { return (e.Category == "MIRAVERSETANTRUMS" || e.Category == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];
             var coursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter( function (e) { return (e.AT == "MIRACOURSECOMPLETED") && e.RS != "DELETEACTIVITY" }) : [];
             totalPending = allCourses && allCourses.length > 0 ? allCourses.length : 0;
             if (totalPending > 0 && coursesCompleted && coursesCompleted.length > 0) {
                 totalPending = totalPending - coursesCompleted.length;

             }
             if (allCourses) {
                 var allTantrumsCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? dataConst.MirracleTypes.filter( function (e) { return (e.Category == "MIRAVERSETANTRUMS") && e.RS != "DELETEACTIVITY" }) : [];
                 var tantrumcoursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter( function (e) { return (e.Category == "MIRACOURSECOMPLETED" && e.F5 == "MIRAVERSETANTRUMS") && e.RS != "DELETEACTIVITY" }) : [];

                 totalTantrumsPending = tantrumcoursesCompleted && tantrumcoursesCompleted.length > 0 ? allTantrumsCourses.length - tantrumcoursesCompleted.length : allTantrumsCourses.length;


                 var allConditionCourses = dataConst && dataConst.MirracleTypes && dataConst.MirracleTypes.length > 0 ? dataConst.MirracleTypes.filter( function (e) { return (e.Category == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];
                 var conditioncoursesCompleted = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter( function (e) { return (e.AT == "MIRACOURSECOMPLETED" && e.F5 == "MIRAVERSECONDITIONS") && e.RS != "DELETEACTIVITY" }) : [];

                 totalConditionsPending = conditioncoursesCompleted && conditioncoursesCompleted.length > 0 ? allConditionCourses.length - conditioncoursesCompleted.length : allConditionCourses.length;
             }
             pendingObj.totalPending = totalPending;
             pendingObj.totalTantrumsPending = totalTantrumsPending;
             pendingObj.totalConditionsPending = totalConditionsPending;
             pendingObj.ptiPendingAssesmsnets = ptiPendingAssesmsnets;
             pendingObj.leaveApprovalPending = leaveApprovalPending;

             return pendingObj;

             break;
         case "bossachivements":

             var bossObj = {};
             var bossTherapies = dataConst && dataConst.Therapies && dataConst.Therapies.length > 0 ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY") : [];
             var bossGoals = dataConst && dataConst.Goals && dataConst.Goals.length > 0 ? dataConst.Goals.filter(e => e.RS != "DELETEACTIVITY") : [];
             var bossFeedBacks = 0;
             bossObj.totalBossTherapies = bossTherapies.length;
             bossObj.totalBossGoals = bossGoals.length;
             bossObj.totalBossFeedback = 0;

             return bossObj;

             break;

         case "bosshomework":
             var attendanceData = dataConst.Attendance ? dataConst.Attendance.filter(r => r.TypeId != 238 && r.Status.toLowerCase() == "present") : []
             var feedbacksDataforboss = dataConst.Feedback && dataConst.Feedback.length > 0 ? dataConst.Feedback.filter(r => r.CBPI).map(e => e.AttendanceId) : []
             var combinedDatas = attendanceData.length > 0 && feedbacksDataforboss.length > 0 ? attendanceData.filter(e => feedbacksDataforboss && feedbacksDataforboss.indexOf(e.Id) < 0) : attendanceData;
             return combinedDatas;
             break;
         case "bosspendingfee":
             var pendingAmount = 0;
             var typeId = $$this.GetTypeIdByName(dataConst.Types, "Seva");
             var paymentsParent = dataConst && dataConst.Fee && dataConst.Fee.length > 0 ? dataConst.Fee.filter(t => t.ServiceId && t.ServiceId != null) : [];
             var mapids = paymentsParent ? paymentsParent.map(m => m.Id) : []
             var receiptpayment = dataConst && dataConst.FeeReceipt && dataConst.FeeReceipt ? dataConst.FeeReceipt.filter(f => mapids.indexOf(f.FeeId) > -1 && typeId != f.TypeId) : [];


             var invoiceamount = paymentsParent.reduce(function (accumulator, item) {
                 return accumulator + item.Amount;
             }, 0);
             var paymentamount = receiptpayment ? receiptpayment.reduce(function (accc, items) {
                 return accc + items.Amount;
             }, 0) : 0;
             pendingAmount = invoiceamount - paymentamount;

             return pendingAmount
             break;

         case "demographicaipending":
             var data = [];
             var DemographicNotes=$$this.groupBy(dataConst.DemoGraphicNotes, "DId");
             var AllDemographicsData=dataConst.DemoGraphics;
             var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");
             if (isItKPI) {
                 return AllDemographicsData.filter(e=> !DemographicNotes[e.Id]);
             }

             for(var i=0;i<AllDemographicsData.length;i++)
             {
              var a = AllDemographicsData[i];
             

           //  AllDemographicsData.forEach(function (k, a) {
                 var obj = {};
                 obj.Facility= facilitiesGroup[a.CenterId][0].Name
                 obj.Category=a.Type?a.Type:"";
                 obj.Status=DemographicNotes[a.Id] && DemographicNotes[a.Id].length >0 ?"COMPLETED":"PENDING";
                 data.push(obj)
             } //);

             return data;
         break;
         case "pinnacleclaritypending":
             var allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity.filter(e => (e.RS != "DELETEACTIVITY") && !e.Reply) : [];
             if (isItKPI) {
                 return allPinnacleClarity;
             }

             // allPinnacleClarity = dataConst && dataConst.PinnacleClarity && dataConst.PinnacleClarity.length > 0 ? dataConst.PinnacleClarity : [];


             var data = [];
             var facilitiesGroup = $$this.groupBy(dataConst.Centers, "Id");
             var peopleGroup = $$this.groupBy(dataConst.People, "Id");
             var activetherapies = dataConst.Therapies ? dataConst.Therapies.filter(e => e.RS != "DELETEACTIVITY" && e.Status != "INACTIVE") : [];
             var dt = new Date();
             var futureCredits = dataConst.FeeAll.filter(f => f.Type == "services" && f.FDT == "9999-01-01 00:00:00");

             //var futureCredits = dataConst.FeeAll;


             var futureCreditsOfBoss = $$this.groupBy(futureCredits, "BOSSId");
             if (allPinnacleClarity) {

                 var forIds = allPinnacleClarity.map(m => m.ForId + "");

                 var usedCredits = dataConst.FeeAll.filter(f => f.Type == "services" && forIds.indexOf(f.BOSSId + "") > -1);


                 var usedCreditsOfBoss = $$this.groupBy(usedCredits, "BOSSId");

                 var groupedClarity = $$this.groupBy(allPinnacleClarity, "ForId");

                 // console.log(groupedClarity);

                 for(var i=0;i<allPinnacleClarity.length;i++)
                 {
                  var a = allPinnacleClarity[i];

                // allPinnacleClarity.forEach(function (k, a) {
                     var obj = {};

                     if (a.Category.indexOf("Inactivation") > -1 && !isItKPI) {

                         var numberOfTherapies = usedCreditsOfBoss && usedCreditsOfBoss[a.ForId] && usedCreditsOfBoss[a.ForId].length > 0 ? usedCreditsOfBoss[a.ForId].sort((a, b) => (new Date(b.CDT) > new Date(a.CDT) ? 1 : -1))[0].NoOfTherapies : 1;
                         obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                         obj.Kid = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                         obj.AdminReply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";
                         obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                         //futureCreditsOfBoss[a.ForId] && futureCreditsOfBoss[a.ForId].length > 0 ? futureCreditsOfBoss[a.ForId][0].NoOfTherapies
                         //peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].F12  : 1;
                         obj.Package = numberOfTherapies;
                         obj.Credits = futureCreditsOfBoss[a.ForId] ? futureCreditsOfBoss[a.ForId].length : 0;
                         obj.CDT = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].CDT : "";
                         obj.Uneven = obj.TherapistReply == "Pending" || obj.AdminReply == "Pending" || obj.TherapistReply.split("-")[0].trim() == obj.AdminReply.split("-")[0].trim() ? "No" : "Yes";
                         obj.KidId = a.ForId;
                         obj.ServiceId = a.F2;
                         obj.AllServices = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => e && e.Reply && e.Reply.toLowerCase() == "continue empowerment").length > 0 ? "Continue" : "Discontinue" : "Pending";

                         try {
                             var therapistId = activetherapies.filter(f => a.F2 + "" == f.Id + "")[0].TherapistId;
                             // obj.For = (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                             obj.Therapist = therapistId + "#" + (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                         }
                         catch {

                         }

                         obj.Category = a.Category;
                         obj.Reply = obj.TherapistReply == "Pending" || obj.AdminReply == "Pending" || obj.TherapistReply.split("-")[0].trim() == obj.AdminReply.split("-")[0].trim() ? obj.AdminReply : "Uneven";
                     }
                     else if (a.Category.indexOf("Pollination") > -1 && !isItKPI) {
                         if (!data.filter(f => f.ForId == a.ForId)[0]) {
                             obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                             obj.Name = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                             obj.ForId = a.ForId;
                             obj.Category = a.Category;
                             var filteredData1St = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => (e.Category == 'January Admin Pollination 2024' || e.Category == 'January Therapist Pollination 2024') && e.Message.indexOf("5th january") > -1)[0] : '';
                             var filteredData2nd = groupedClarity && groupedClarity[a.ForId] && groupedClarity[a.ForId].length > 0 ? groupedClarity[a.ForId].filter(e => (e.Category == 'January Admin Pollination 2024' || e.Category == 'January Therapist Pollination 2024') && e.Message.indexOf("7th january") > -1)[0] : '';
                             obj["Total Pollination sessions"] = a.F2;
                             obj["By 1st"] = filteredData1St && filteredData1St.Reply && filteredData1St.Reply.indexOf("0 - Others") == -1 ? filteredData1St.Reply : 0;
                             obj["By 5th"] = filteredData2nd && filteredData2nd.Reply && filteredData2nd.Reply.indexOf("0 - Others") == -1 ? filteredData2nd.Reply : 0;
                         }
                     }
                     else {
                         var alltherapiesforkid = activetherapies.filter(e => e.BossId == a.ForId)
                         var therapistName = ""
                         var speechtherapy = ""
                         var specialeducation = ""
                         var behavioraltherapy = ""
                         var occupationaltherapy = ""
                         for (i = 0; i < alltherapiesforkid.length; i++) {

                             var names = dataConst.People.filter(e => e.Id == alltherapiesforkid[i].TherapistId)[0]
                             // if(names!=null &&alltherapiesforkid ){
                             //     alltherapiesforkid.filter(e=>e.TherapistId == names.Id && )
                             // }
                             //  if(names!=null){
                             //  therapistName+= names.Id+"#"+names.Name+"{#}"
                             //  }

                             //obj.Therapist=therapistName ? therapistName :null;
                             if (names.Designation && names.Designation == "Occupational Therapist") {
                                 occupationaltherapy += names.Id + "#" + names.Name + "{#}";
                             } else if (names.Designation && names.Designation == "Behavioural Therapist") {
                                 behavioraltherapy += names.Id + "#" + names.Name + "{#}";
                             }
                             else if (names.Designation && names.Designation == "Speech Therapist") {
                                 speechtherapy += names.Id + "#" + names.Name + "{#}";
                             }
                             else if (names.Designation && names.Designation == "Special Educator ") {
                                 specialeducation += names.Id + "#" + names.Name + "{#}";
                             }

                         }

                         obj.Facility = facilitiesGroup[a.CenterId] && facilitiesGroup[a.CenterId][0] ? facilitiesGroup[a.CenterId][0].Name : "";
                         obj.For = peopleGroup[a.ForId] && peopleGroup[a.ForId][0] ? peopleGroup[a.ForId][0].Name : "";
                         obj.HBDT = a.HBDT;
                         obj.Category = a.Category;
                         obj.Message = a.Message;
                         obj.KidId = a.ForId;

                         if (a.Category.indexOf("Fee Pending") > -1 || a.Category.indexOf("Renewals") > -1) {



                             obj.OT = occupationaltherapy ? occupationaltherapy : null;

                             obj.BT = behavioraltherapy ? behavioraltherapy : null;

                             obj.ST = speechtherapy ? speechtherapy : null;

                             obj.SE = specialeducation ? specialeducation : null;

                         }
                         obj.Remarks = a.F5;
                         obj.TOId = a.UBPI;

                         obj.Reply = a.Reply && a.Reply.trim() != "" ? a.Reply : "Pending";
                         if (a.Category.indexOf("Inactivation") > -1 && !isItKPI) {
                             obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                             obj.Uneven = obj.TherapistReply == "Pending" || obj.Reply == "Pending" || a.TherapistReply == a.Reply ? "" : "Uneven";
                             try {
                                 var therapistId = activetherapies.filter(f => a.F2 + "" == f.Id + "")[0].TherapistId;
                                 obj.For = (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                                 obj.Therapist = therapistId + "#" + (peopleGroup[therapistId] && peopleGroup[therapistId][0] ? peopleGroup[therapistId][0].Name : "");
                             }
                             catch {

                             }

                         }
                         if (a.Category.indexOf("Renewals") > -1 && !isItKPI) {
                             obj.TherapistReply = a.TherapistReply && a.TherapistReply.trim() != "" ? a.TherapistReply : "Pending";
                             obj.Uneven = obj.Reply == obj.TherapistReply ? "No" : "Yes";
                             obj["Offer Amount"] = a.F1;
                             obj.Package = a.F4;
                         }

                         obj.Amount = a.F2 ? a.F2 : a.Message.replace(obj.For + " ", "").replace(" Fee Clearing ETA ?", "");
                     }
                     data.push(obj);
                 }//);
             }

             return data;

             break;

         default:
             return [];
             break;


     }
 } catch (e) {
     console.log("EXCEPTION IN REPORTS FOR: " + type + " isItKPI: " + isItKPI + "  FDT: " + FDT + " TDT: " + TDT);
     console.log(e);

     //SaveCleintWaufli(e, "Client Reports Failed", " GetReportsData " + type);
     return [];
 }
}



GetPrepData(role, data, fromDate, toDate, fids, $this) {
 var $$this=this;

 var todayDate = new Date();

 var fdt = fromDate ? fromDate : new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
 var tdt = toDate ? toDate : new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0, 23, 59, 59);
 var FDT = fdt;
 var TDT = tdt;
 var logs = [];
 var inittialStart = new Date();
 var startDate = new Date();

 var fsIds = fids.map(m => m + "");

 const totalworkingdays = this.GetTotalWorkingDays(FDT, TDT);
 const therapies = data.Therapies ? data.Therapies.filter(f => fids.indexOf(f.CenterId) > -1 && f.RS != "DELETEACTIVITY" && f.Status != "INACTIVE" && ($this.IsUserTherapist && role != "Senior" ? data.CFUser.Id == f.TherapistId : true)) : [];
 const pinnacleClarities = data.PinnacleClarity ? data.PinnacleClarity.filter(f => fids.indexOf(f.CenterId) > -1 && f.RS != "DELETEACTIVITY") : [];



 var therapyIds = therapies ? therapies.map(m => m.Id) : [];
 const goals = data.Goals ? data.Goals.filter(f => therapyIds.indexOf(f.TherapyId) > -1) : [];
 const types = data.Types ? data.Types : [];
 const usersettings = data.UserSettings;

 const holidays = this.GetHolidaysList();

 var people = (data.People || []).filter(f => fids.indexOf(f.CenterId) > -1 && ($this.IsUserTherapist && role != "Senior" ? data.CFUser.Id == f.Id : true));
 //For BDC we have to consider all centers otherwise pending not matched
 var leads = (data.Leads || []).filter(f => (role && role.toLowerCase() == "bdc") ? true : fids.indexOf(f.CenterId) > -1);
// var gfId = $("#insightsFacility").val();
 //if(gfId && gfId != ""){
     leads = (data.Leads || []).filter(f => fids.indexOf(f.CenterId) > -1);
 //}
 people = people || [];
 var pIds = people.map(m => m.Id);
 const allPeopleNotes = data.PeopleNotes ? data.PeopleNotes.filter(f => pIds.indexOf(f.TOId) > -1) : [];
 data.Mirracles = (data.Mirracles || []);
 const mirracles = data.Mirracles.filter(m => pIds.indexOf(m.PersonId) > -1 && $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT);

 data.Dang = (data.Dang || []);
 const dang = data.Dang.filter(f => fids.indexOf(f.CenterId) > -1 && $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT);

 const allCenterNotes = data.CenterNotes ? data.CenterNotes.filter(f => fids.indexOf(f.CenterId) > -1 && (!f.RS || f.RS != "DELETEACTIVITY")) : [];


 const allLeaveRequests = allPeopleNotes ? allPeopleNotes.filter(f => f.TypeId == $$this.GetTypeIdByName(types, "LEAVEREQUEST")) : [];

 var compoTypeId = $$this.GetTypeIdByName(types, "SERVICECOMPENSATION");
 const allCompensations = data.Attendance ? data.Attendance.filter(f => f.TypeId == compoTypeId && therapyIds.indexOf(f.ServiceId) > -1 && $$this.dateFromSDateTime(f.ForDate) >= FDT && $$this.dateFromSDateTime(f.ForDate) <= TDT) : [];
 //pIds.indexOf(f.BOSSId) > -1 ||
 data.Fee = data.Fee ? data.Fee.filter(f => f.BOSSId ? true : false) : [];

 var feeThisMonth = data.Fee ? data.Fee.filter(f => $$this.dateFromSDateTime(f.FDT) >= FDT && $$this.dateFromSDateTime(f.TDT) <= TDT && (fids.indexOf(f.CenterId) > -1 || fsIds.indexOf(f.CenterId) > -1) && f.RS != "DELETEACTIVITY") : [];

 var inactiveServices = data.Therapies ? data.Therapies.filter(m => null != m.F14 && $$this.dateFromSDateTime(m.F14) <= TDT && m.Status.toUpperCase() == "INACTIVE" && fids.indexOf(m.CenterId) > -1) : [];

 var fututreMonthInvoices = data.Fee ? data.Fee.filter(f => $$this.dateFromSDateTime(f.FDT) > TDT && (fids.indexOf(f.CenterId) > -1 || fsIds.indexOf(f.CenterId) > -1) && f.RS != "DELETEACTIVITY") : [];

 var futureInvoicesCreatedThisMonth = fututreMonthInvoices && fututreMonthInvoices.length > 0 ? fututreMonthInvoices.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) : [];

 var attendance = data.Attendance ? data.Attendance.filter(f => $$this.dateFromSDateTime(f.ForDate) >= FDT && $$this.dateFromSDateTime(f.ForDate) <= TDT && therapyIds.indexOf(f.ServiceId) > -1) : [];
 var paymentsThisMonth = data.FeeReceipt ? data.FeeReceipt.filter(e => e.RS != "DELETEACTIVITY" && (fids.indexOf(e.CenterId) > -1 || fsIds.indexOf(e.CenterId) > -1)) : [];
 var servicerequest = data.ServiceRequests ? data.ServiceRequests.filter(m => pIds.indexOf(m.TOId) > -1 || pIds.indexOf(m.CBPI) > -1 && (!m.RS || m.RS != "DELETEACTIVITY")) : [];
 var ServiceRequestAnalytic = data.ServiceRequestsAnalytics ? data.ServiceRequestsAnalytics.filter(m => m.RS != "DELETEACTIVITY") : [];

 var memoTypeId = $$this.GetTypeIdByName(types, "MEMO")
 var leaverequestId = $$this.GetTypeIdByName(types, "LEAVEREQUEST");
 var awardId = $$this.GetTypeIdByName(types, "AWARD");
 var mirracleAssignId = $$this.GetTypeIdByName(types, "MIRRACLEASSIGNED");

 var allLeaves = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == leaverequestId && ($$this.dateFromSDateTime(f.FDT) >= FDT || ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT))) : [];

 var allMirraclesAssigned = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == mirracleAssignId) : [];

 var allMemos = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == memoTypeId) : [];
 var allawards = data.PeopleNotes ? data.PeopleNotes.filter(f => f.TypeId == awardId) : [];

 var feeAllMonths = data.Fee ? data.Fee.filter(e => (fids.indexOf(e.CenterId) > -1 || fsIds.indexOf(e.CenterId) > -1) && e.RS != "DELETEACTIVITY") /*.filter(f => $$this.dateFromSDateTime(f.FDT) >= FDT && $$this.dateFromSDateTime(f.TDT) < TDT)*/ : [];
 var allassessmentdata = data.Assessments ? data.Assessments.filter(e => e.RS != "DELETEACTIVITY") : [];
 var filteringfeedback = data.Feedback ? data.Feedback.filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) <= TDT) : []
 var dataConst = {};

 var leadsGroupsForKPI = leads && leads && leads.length > 0 ? Object.entries($$this.groupBy(leads, "F17")) : [];
 var leadsDataForKPI = leadsGroupsForKPI && leadsGroupsForKPI.length > 0 ? leadsGroupsForKPI.map(m => m[1].sort((a, b) => (new Date(a.CDT) > new Date(b.CDT) ? -1 : 1))) : [];
 var demographics=data.DemoGraphicAI ? data.DemoGraphicAI.filter(e=>e.RS!="DELETEACTIVITY"):[];
 var demographicsNotes=data.DemoGraphicAINotes ? data.DemoGraphicAINotes.filter(e=>e.RS!="DELETEACTIVITY"):[];

 dataConst.Therapies = therapies;
 dataConst.Goals = goals;

 dataConst.Types = types;
 dataConst.Centers = data.Centers;
 dataConst.UserSettings = usersettings;
 dataConst.Holidays = holidays;
 dataConst.People = people;
 dataConst.TWD = totalworkingdays;
 dataConst.Leaves = allLeaveRequests;
 dataConst.Compos = allCompensations;
 dataConst.Fee = feeThisMonth;
 dataConst.InActive = inactiveServices;
 dataConst.Attendance = attendance;
 dataConst.FutureInvoices = fututreMonthInvoices;
 dataConst.FutureInvoicesCDTThisMonth = futureInvoicesCreatedThisMonth;
 dataConst.FeeReceipt = paymentsThisMonth;
 dataConst.ServiceRequest = servicerequest;
 dataConst.ServiceRequestAnalytic = ServiceRequestAnalytic;
 dataConst.Leaverequestall = allLeaves;
 dataConst.MirraclesAssigned = allMirraclesAssigned;
 dataConst.FeeAll = feeAllMonths;
 dataConst.PeopleNotes = allPeopleNotes;
 dataConst.CenterNotes = allCenterNotes;
 dataConst.Assessmentsdata = allassessmentdata;
 dataConst.Leads = leads;
 dataConst.Memos = allMemos;
 dataConst.Responses = data.Responses;
 dataConst.Awards = allawards;
 dataConst.Feedback = filteringfeedback;
 dataConst.Biometric = data.Biometric;
 dataConst.MirraclesData = mirracles;
 dataConst.MirracleTypes = data.MirracleTypes;
 dataConst.Dang = dang;
 dataConst.LeadGroups = leadsGroupsForKPI;
 dataConst.GroupedLeads = leadsDataForKPI;
 dataConst.PinnacleClarity = pinnacleClarities;
 dataConst.KidStates = data && data.KidStates ? data.KidStates : [];
 dataConst.DemoGraphics=demographics;
 dataConst.DemoGraphicNotes=demographicsNotes;
 dataConst.FacilityPeople=data.FacilityPeople?data.FacilityPeople:[];
 dataConst.CFUser = data.CFUser;
 return dataConst;
}




PrepBossAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese) {
 var $$this=this;
 var logs = [];
 //credits available
 var aggregate = {};
 var startDate = new Date();
 var FDT = fdt;
 var TDT = tdt;
 aggregate.FCI = $$this.GetReportsData("availablecredits", dataConst, true, fdt, tdt, facility).length;
 logs.push("FCI:" + this.GetDateDiff(startDate, new Date()));

 //goals
 startDate = new Date();
 aggregate.TAG = $$this.GetReportsData("activegoals", dataConst, true, fdt, tdt, facility).length;
 logs.push("TAG:" + this.GetDateDiff(startDate, new Date()));
 //Goal Reviewed

 startDate = new Date();
 aggregate.GR = $$this.GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
 logs.push("GR:" + this.GetDateDiff(startDate, new Date()));

 //Goal Pending
 startDate = new Date();
 aggregate.GP = $$this.GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
 console.log("GOALS PENDING Time: " + this.GetDateDiff(startDate, new Date()));
 logs.push("GP:" + this.GetDateDiff(startDate, new Date()));


 // Pending - assessments

 aggregate.ASP = dataConst.Assessmentsdata.filter(m => m.Status.toLowerCase() != "completed" && $$this.dateFromSDateTime(m.CDT) >= FDT).length;

 // Completed -assessments
 aggregate.AST = dataConst.Assessmentsdata.filter(m => m.Status.toLowerCase() == "completed" && $$this.dateFromSDateTime(m.CDT) >= FDT).length;

 // pending attendance
 //startDate = new Date();
 //aggregate.AP = $$this.GetReportsData("attendancepending", dataConst, true, fdt, tdt, facility);
 //logs.push("AP:" + this.GetDateDiff(startDate, new Date()));


 // attendance present

 startDate = new Date();
 aggregate.AGP = $$this.GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
 logs.push("AGP:" + this.GetDateDiff(startDate, new Date()));

 //attendance absent
 startDate = new Date();
 aggregate.AGA = $$this.GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
 logs.push("AGA:" + this.GetDateDiff(startDate, new Date()));

 // attendance
 aggregate.AG = aggregate.AGP + aggregate.AGA;

 // Homework pending
 startDate = new Date();
 aggregate.RP = $$this.GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
 logs.push("RP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RG = $$this.GetReportsData("homeworkcompleted", dataConst, true, fdt, tdt, facility).length;
 logs.push("RG:" + this.GetDateDiff(startDate, new Date()));

 // Homework pending
 // startDate = new Date();
 // aggregate.RG = $$this.GetReportsData("homeworkgiven", dataConst, true, fdt, tdt, facility).length;
 // logs.push("RG:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 var servicerequests = $$this.GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
 var inprocess = servicerequests.filter(m => !m.LastAnalytic || m.LastAnalytic.Status == "REOPEN");
 aggregate.SRIP = (inprocess || []).length;
 console.log("SERVICEREQUEST TIME :" + this.GetDateDiff(startDate, new Date()));
 logs.push("srip:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var waiting = servicerequests.filter(m => m.LastAnalytic && (m.LastAnalytic.Status == "CLOSED" || m.LastAnalytic.Status == "UPDATED")&& m.CBPI != m.LastAnalytic.CBPI);
 aggregate.SRW = (waiting || []).length;
 logs.push("SRW:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var closed = servicerequests.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
 aggregate.SRR = (closed || []).length;
 logs.push("SRR:" + this.GetDateDiff(startDate, new Date()));



 startDate = new Date();
 var reopen = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");
 aggregate.SRRO = (reopen || []).length;
 logs.push("SRRO:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 //aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
 aggregate.SRT = servicerequests.length;

 startDate = new Date();
 var compodataa = $$this.GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
 aggregate.CPC = compodataa > 0 ? compodataa : 0;
 logs.push("CPC:" + this.GetDateDiff(startDate, new Date()));

 var pendingCourses = $$this.GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);

 aggregate.TCOP = pendingCourses.totalPending;
 aggregate.TTP = pendingCourses.totalTantrumsPending;
 aggregate.TCNP = pendingCourses.totalConditionsPending;
 aggregate.TPISIP = pendingCourses.ptiPendingAssesmsnets;

 aggregate.HWP = $$this.GetReportsData("bosshomework", dataConst, true, fdt, tdt, facility).length;


 var bossAchivements = $$this.GetReportsData("bossachivements", dataConst, true, fdt, tdt, facility);

 //   aggregate.TBOT = bossAchivements.totalBossTherapies;
 aggregate.TBOG = bossAchivements.totalBossGoals;
 aggregate.TBOF = bossAchivements.totalBossFeedback;

 var bossPendingFee = $$this.GetReportsData("bosspendingfee", dataConst, true, fdt, tdt, facility);

 aggregate.BPF = bossPendingFee;


 return aggregate;
}


PrepTherapistAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese) {
 var $$this=this;
 var aggregate = {};
 var logs = [];
 var initialStart = new Date();
 var startDate = new Date();
 var FDT = fdt;
 var TDT = tdt;

 var logs = [];
 var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id;

 aggregate.FId = fids;

 dataConst.Therapists = Object.entries($$this.groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);
 aggregate.PCP = $$this.GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
 logs.push("PCP:" + this.GetDateDiff(startDate, new Date()));

 // startDate = new Date();
 // aggregate.TGNS = $$this.GetReportsData("goalsnotset", dataConst, true, fdt, tdt, facility).length;
 // logs.push("TGNS:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.TGNS = $$this.GetReportsData("aigoalsnotset", dataConst, true, fdt, tdt, facility).length;
 logs.push("TGNS:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.AHWP = $$this.GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
 logs.push("AHWP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.GP = $$this.GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
 console.log("GOALS PENDING Time: " + this.GetDateDiff(startDate, new Date()));
 logs.push("GP:" + this.GetDateDiff(startDate, new Date()));

 // startDate = new Date();
 // aggregate.AP = $$this.GetReportsData("kpiattendancepending", dataConst, true, fdt, tdt, facility);
 // logs.push("AP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.AP = $$this.GetReportsData("kidattendancepending", dataConst, true, fdt, tdt, facility);
 logs.push("AP:" + this.GetDateDiff(startDate, new Date()));





 // startDate = new Date();
 // aggregate.KIDAP = $$this.GetReportsData("kidattendancepending", dataConst, true, fdt, tdt, facility);
 // logs.push("KIDAP:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 var compodataa = $$this.GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
 aggregate.CPC = compodataa > 0 ? compodataa : 0;
 logs.push("CPC:" + this.GetDateDiff(startDate, new Date()));

 //startDate = new Date();
 //aggregate.AGP = $$this.GetReportsData("therapiesprovided", dataConst, true, fdt, tdt, facility).length;
 //logs.push("AGP:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.AGP = $$this.GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
 logs.push("AGP:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.AGA = $$this.GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
 logs.push("AGA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.GR = $$this.GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
 logs.push("GR:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.AWARDS = $$this.GetReportsData("awardswon", dataConst, true, fdt, tdt, facility).length;
 logs.push("AWARDS:" + this.GetDateDiff(startDate, new Date()));

 ///POLLINATION

 startDate = new Date();
 aggregate.PCP = $$this.GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
 logs.push("PCP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PCC = $$this.GetReportsData("pollinationclaritycompleted", dataConst, true, fdt, tdt, facility);
 logs.push("PCC:" + this.GetDateDiff(startDate, new Date()));

   // Homework pending
   startDate = new Date();
   aggregate.RP = $$this.GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
   logs.push("RP:" + this.GetDateDiff(startDate, new Date()));


   startDate = new Date();
   aggregate.RG = $$this.GetReportsData("homeworkcompleted", dataConst, true, fdt, tdt, facility).length;
   logs.push("RG:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PCYT = $$this.GetReportsData("pollinationclarityyetto", dataConst, true, fdt, tdt, facility);
 logs.push("RPCYTCTD:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PCZ = $$this.GetReportsData("pollinationclarityzero", dataConst, true, fdt, tdt, facility);
 logs.push("PCZ:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.PCLT = $$this.GetReportsData("pollinationclaritylessthanthree", dataConst, true, fdt, tdt, facility);
 logs.push("PCLT:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PCGT = $$this.GetReportsData("pollinationclaritygreaterthanthree", dataConst, true, fdt, tdt, facility);
 logs.push("PCGT:" + this.GetDateDiff(startDate, new Date()));


 //  startDate = new Date();
 //  aggregate.PAO=$$this.GetReportsData("pollinationopty", dataConst, true, fdt, tdt, facility);
 //  logs.push("PAO:" + this.GetDateDiff(startDate, new Date()));



 startDate = new Date();
 aggregate.AMEMO = $$this.GetReportsData("activememos", dataConst, true, fdt, tdt, facility).length;
 logs.push("AMEMO:" + this.GetDateDiff(startDate, new Date()));

 ///POLLINATION


 /*startDate = new Date();
 var pisiLatesttherapy = $$this.GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

 var pisiids = pisiLatesttherapy.Reponses.map(m => m.PeopleNoteId);


 startDate = new Date();
 var TOA = pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy"));
 aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
 logs.push("TOE:" + this.GetDateDiff(startDate, new Date()));

 var TAS = pisiLatesttherapy && pisiLatesttherapy.length > 0 ? pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



 aggregate.TASS = TAS.length;
 //aggregate.TCA = pisiLatest && pisiLatest.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
 logs.push("TASS:" + this.GetDateDiff(startDate, new Date()));
 */

 // #region PISI
 startDate = new Date();
 var pisiLatest = $$this.GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

 var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

 aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
 logs.push("TPA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
 aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
 logs.push("TOE:" + this.GetDateDiff(startDate, new Date()));

 // therapy improvemnet
 startDate = new Date();
 var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
 aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
 logs.push("TTI:" + this.GetDateDiff(startDate, new Date()));

 // Daily Homework Feedback
 startDate = new Date();
 var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

 aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
 logs.push("TDH:" + this.GetDateDiff(startDate, new Date()));
 // Daily after therapy interaction

 startDate = new Date();
 var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
 aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
 logs.push("TDA:" + this.GetDateDiff(startDate, new Date()));
 // Daily Homework Feedback

 startDate = new Date();
 var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



 aggregate.TASS = TAS.length;
 aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
 logs.push("TASS:" + this.GetDateDiff(startDate, new Date()));
 // #endregion PISI

 startDate = new Date();
 var whiLatest = $$this.GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
 var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
 aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
 logs.push("PROA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROS = whiLatest && whiLatest.length > 0 ? whiLatest.Suggestions.length : 0;
 logs.push("PROS:" + this.GetDateDiff(startDate, new Date()));


 //if (role == "Therapist") {
 //    startDate = new Date();
 //    aggregate.TOE = $$this.GetReportsData("pisirating", dataConst, true, fdt, tdt, facility).length;
 //    logs.push("TOE:" + this.GetDateDiff(startDate, new Date()));
 //}



 //startDate = new Date();
 //aggregate.MIRT = $$this.GetReportsData("mirracles", dataConst, true, fdt, tdt, facility).length;
 //logs.push("MIRT:" + this.GetDateDiff(startDate, new Date()));

 /*startDate = new Date();
 aggregate.RP = $$this.GetReportsData("feedbackspending", dataConst, true, fdt, tdt, facility).length;
 logs.push("RP:" + this.GetDateDiff(startDate, new Date()));*/
 //Change below like above

   // Homework pending
 //   startDate = new Date();
 //   aggregate.RP = $$this.GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
 //   logs.push("RP:" + this.GetDateDiff(startDate, new Date()));

 // startDate = new Date();
 // aggregate.RG = $$this.GetReportsData("feedbacksgiven", dataConst, true, fdt, tdt, facility).length;
 // logs.push("RG:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 //aggregate.RP = aggregate.AGP - aggregate.RG;//  $$this.GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
 //logs.push("RP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RGT = $$this.GetReportsData("feedbackratings", dataConst, true, fdt, tdt, facility);
 logs.push("RGT:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.RAT = aggregate.RG ? (aggregate.RGT / aggregate.RG).toFixed(2) : 0;
 logs.push("RAT:" + this.GetDateDiff(startDate, new Date()));

 //TOE
 //AGP
 //CPC
 //Goals for therapist
 startDate = new Date();
 aggregate.GR = $$this.GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
 logs.push("GR:" + this.GetDateDiff(startDate, new Date()));

 //Goal Pending for therapist
 // startDate = new Date();
 // aggregate.GP = $$this.GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
 // console.log("GOALS PENDING Time: "+GetDateDiff(startDate,new Date()));
 // logs.push("GP:" + this.GetDateDiff(startDate, new Date()));

 //services

 startDate = new Date();
 aggregate.SF = $$this.GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
 logs.push("SF:" + this.GetDateDiff(startDate, new Date()));

 //Assessments

 startDate = new Date();
 var allAssessmentsData = dataConst.Assessmentsdata;

 startDate = new Date();
 aggregate.ASP = allAssessmentsData.filter(m => m.Status.toLowerCase() != "completed" && $$this.dateFromSDateTime(m.CDT) >= FDT).length;
 logs.push("ASP:" + this.GetDateDiff(startDate, new Date()));

 // Completed assessment
 startDate = new Date();
 aggregate.AST = $$this.GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
 logs.push("AST:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var whiLatest = $$this.GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
 aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
 logs.push("PROA:" + this.GetDateDiff(startDate, new Date()));




 startDate = new Date();
 aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
 logs.push("PROS:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
 aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
 logs.push("PROP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
 logs.push("PROT10:" + this.GetDateDiff(startDate, new Date()));




 startDate = new Date();
 aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
 logs.push("PROT40:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
 logs.push("PROT40:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
 logs.push("PROB10:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 var allrenewalClarity = $$this.GetReportsData("renewalclarityall", dataConst, true, fdt, tdt, facility);
 // var AllFeeETA = data.filter(e =>  (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity"+e.Details.toLowerCase()+""));

 aggregate.RCA = allrenewalClarity.length;
 logs.push("RCA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();

 aggregate.RCOD = allrenewalClarity.filter(f => f.Details == "overdue").length;//  $$this.GetReportsData("renewalclarityoverdue", dataConst, true, fdt, tdt, facility);
 logs.push("RCOD:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCTD = allrenewalClarity.filter(f => f.Details == "today").length; //$$this.GetReportsData("renewalclaritytoday", dataConst, true, fdt, tdt, facility);
 logs.push("RCTD:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCTR = allrenewalClarity.filter(f => f.Details == "tomorrow").length; //$$this.GetReportsData("renewalclaritytomorrow", dataConst, true, fdt, tdt, facility);
 logs.push("RCTR:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.RCTW = allrenewalClarity.filter(f => f.Details == "thisweek").length; //$$this.GetReportsData("renewalclaritythisweek", dataConst, true, fdt, tdt, facility);
 logs.push("RCTW:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCNW = allrenewalClarity.filter(f => f.Details == "nextweek").length; //$$this.GetReportsData("renewalclaritynextweek", dataConst, true, fdt, tdt, facility);
 logs.push("RCNW:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.RCTM = allrenewalClarity.filter(f => f.Details == "thismonth").length; //$$this.GetReportsData("renewalclaritythismonth", dataConst, true, fdt, tdt, facility);
 logs.push("RCTM:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCNM = allrenewalClarity.filter(f => f.Details == "nextmonth").length; //$$this.GetReportsData("renewalclaritynextmonth", dataConst, true, fdt, tdt, facility);
 logs.push("RCNM:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCOT = allrenewalClarity.filter(f => f.Details == "others").length; //$$this.GetReportsData("renewalclarityothers", dataConst, true, fdt, tdt, facility);
 logs.push("RCOT:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCP = allrenewalClarity.filter(f => f.Details == "pending").length; //$$this.GetReportsData("renewalclaritypending", dataConst, true, fdt, tdt, facility);
 logs.push("RCP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCR = allrenewalClarity.filter(f => f.Details == "renewed").length; //$$this.GetReportsData("renewalclarityrenewed", dataConst, true, fdt, tdt, facility);
 logs.push("RCR:" + this.GetDateDiff(startDate, new Date()));
 startDate = new Date();
 aggregate.RCTBR = aggregate.RCA - aggregate.RCR - aggregate.RCP - aggregate.RCOT;
 logs.push("RCTBR:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var servicerequests = $$this.GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
 var inprocess = servicerequests.filter(m => !m.LastAnalytic || m.LastAnalytic.Status == "REOPEN");
 aggregate.SRIP = (inprocess || []).length;
 console.log("SERVICEREQUEST TIME :" + this.GetDateDiff(startDate, new Date()));
 logs.push("srip:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var waiting = servicerequests.filter(m => m.LastAnalytic && (m.LastAnalytic.Status == "CLOSED" ||  m.LastAnalytic.Status == "UPDATED") && m.CBPI != m.LastAnalytic.CBPI);
 aggregate.SRW = (waiting || []).length;
 logs.push("SRW:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var closed = servicerequests.filter(m =>  m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
 aggregate.SRR = (closed || []).length;
 logs.push("SRR:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var reopen = servicerequests.filter(m => m.LastAnalytic && m.LastAnalytic.Status == "REOPEN");
 aggregate.SRRO = (reopen || []).length;
 logs.push("SRRO:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 //aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
 aggregate.SRT =servicerequests.length

 startDate = new Date();
 aggregate.LVP = $$this.GetReportsData("leavespending", dataConst, true, fdt, tdt, facility).length;
 logs.push("LVP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.LVAL = $$this.GetReportsData("leavesall", dataConst, true, fdt, tdt, facility).length;
 logs.push("LVAL:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.LVAP = $$this.GetReportsData("leavesapproved", dataConst, true, fdt, tdt, facility).length;
 logs.push("LVAP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.LVUA = $$this.GetReportsData("leavesunapproved", dataConst, true, fdt, tdt, facility).length;
 logs.push("LVUA:" + this.GetDateDiff(startDate, new Date()));


 var services = dataConst.Therapies;
 var serviceIds = Object.entries($$this.groupBy(dataConst.Therapies, "BossId"));

 var total = 0;
 var totalST = 0;
 var totalOT = 0;
 var totalBT = 0;
 var totalSE = 0;
 for (var i = 0; i < this.servicesOfeering.length; i++) {
     var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf($$this.servicesOfeering[i].Id) == -1);
     total += (boss || []).length;
     if ($$this.servicesOfeering[i].ShortName == "ST") {
         totalST += (boss || []).length;
     }
     else if ($$this.servicesOfeering[i].ShortName == "BT") {
         totalBT += (boss || []).length;
     }
     else if ($$this.servicesOfeering[i].ShortName == "OT") {
         totalOT += (boss || []).length;
     }
     else if ($$this.servicesOfeering[i].ShortName == "SE") {
         totalSE += (boss || []).length;
     }
 }


 startDate = new Date();
 aggregate.POL = total;
 logs.push("POL:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.AVL = $$this.GetReportsData("available", dataConst, true, fdt, tdt, facility).length;
 logs.push("AVL:" + this.GetDateDiff(startDate, new Date()));

 var pendingCourses = $$this.GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);

 aggregate.TCOP = pendingCourses.totalPending;
 aggregate.TTP = pendingCourses.totalTantrumsPending;
 aggregate.TCNP = pendingCourses.totalConditionsPending;
 aggregate.TPISI = pendingCourses.ptiPendingAssesmsnets;

 console.log("THERAPISTAGGREGTAES:" + this.GetDateDiff(initialStart, new Date()));

 return aggregate;
}


PrepOwnerAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese, role) {
 var $$this=this;
 var initialStart = new Date();
 var logs = [];
 var therapistId = dataConst.Types.filter(m => m.Name == "Therapist")[0].Id;
 var startDate = new Date();
 var aggregate = {};
 var FDT = fdt;
 var TDT = tdt;

 var adminId = dataConst.Types.filter(m => m.Name == "Receptionist")[0].Id;
 var bossid = dataConst.Types.filter(m => m.Name == "Boss")[0].Id
 dataConst.Therapists = Object.entries($$this.groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 != 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);


 dataConst.LeftTherapists = Object.entries($$this.groupBy(dataConst.People.filter(f => f.RoleId == therapistId && f.F8 == 1 && f.F21 != "CENTERNUMBER" && f.F21 != "NONSTAFF"), 'Id')).map(m => m[1][0]);

 dataConst.Parents = Object.entries($$this.groupBy(dataConst.People.filter(f => f.RoleId == bossid && f.F8 != 1), 'Id')).map(m => m[1][0]);;

 if (null == onlyThese || onlyThese.indexOf("kubera") > -1) {
     // #region kubera



     startDate = new Date();

     var aggregateKu18 = $$this.GetReportsData("kuberamonthlyfee", dataConst, true, fdt, tdt, facility);
     aggregate.KU18 = aggregateKu18 && aggregateKu18.length > 0 ? aggregateKu18.length : 0;
     logs.push("KU18:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.KUM = $$this.GetReportsData("kuberamissing", dataConst, true, fdt, tdt, facility).length;
     logs.push("KUM:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var aggregateKUAB = $$this.GetReportsData("kuberaabnormal", dataConst, true, fdt, tdt, facility);
     aggregate.KUAB = aggregateKUAB && aggregateKUAB.length > 0 ? aggregateKUAB.length : 0;
     logs.push("KUAB:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var aggregateTotalInvoices = $$this.GetReportsData("allinvoicesthismonth", dataConst, true, fdt, tdt, facility);

     var filtered = [...aggregateKu18, ...aggregateKUAB];
     var totalInvoices = aggregateTotalInvoices && aggregateTotalInvoices.length > 0 ? aggregateTotalInvoices.filter(val => !filtered.includes(val)).length : 0;

     //aggregate.KUR = totalInvoices - aggregate.KU18 - aggregate.KUAB;
     aggregate.KUR = totalInvoices;
     logs.push("KUR:" + this.GetDateDiff(startDate, new Date()));
     // #endregion kubera
 }

 if (null == onlyThese || onlyThese.indexOf("empower2") > -1) {
     // #region Empower2empwoer2single
     startDate = new Date();
     aggregate.EMPM = $$this.GetReportsData("empwoer2monthly", dataConst, true, fdt, tdt, facility).length;
     logs.push("EMPM:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.EMPS = $$this.GetReportsData("empwoer2single", dataConst, true, fdt, tdt, facility).length;
     logs.push("EMPS:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.EMPRNW = $$this.GetReportsData("empwoer2lostparents", dataConst, true, fdt, tdt, facility).length;
     logs.push("EMPRNW:" + this.GetDateDiff(startDate, new Date()));


     // startDate = new Date();

     // var renewalsData = $$this.GetReportsData("renewals", dataConst, true, fdt, tdt, facility);
     // renewalsData = renewalsData || [];
     // aggregate.RWT = renewalsData.length;
     // logs.push("RWT:" + this.GetDateDiff(startDate, new Date()));

     // startDate = new Date();
     // aggregate.RWP = (renewalsData.filter(f => f.Renewed == "No") || []).length;
     // logs.push("RWP:" + this.GetDateDiff(startDate, new Date()));
     // startDate = new Date();
     // aggregate.RWC = (renewalsData.filter(f => f.Renewed == "Yes") || []).length;
     // logs.push("RWC:" + this.GetDateDiff(startDate, new Date()));
     // startDate = new Date();
     // aggregate.RW3 = (renewalsData.filter(f => f.Renewed == "No" && f.Package >= 2 && f.Package <= 3) || []).length;
     // logs.push("RW3:" + this.GetDateDiff(startDate, new Date()));
     // startDate = new Date();
     // aggregate.RW6 = (renewalsData.filter(f => f.Renewed == "No" && f.Package > 3 && f.Package <= 6) || []).length;;
     // logs.push("RW6:" + this.GetDateDiff(startDate, new Date()));
     // startDate = new Date();
     // aggregate.RW12 = (renewalsData.filter(f => f.Renewed == "No" && f.Package > 6 && f.Package <= 48) || []).length;;
     // logs.push("RW12:" + this.GetDateDiff(startDate, new Date()));
     // startDate = new Date();

     // aggregate.RWC3 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package >= 2 && f.Package <= 3) || []).length;
     // logs.push("RWC3:" + this.GetDateDiff(startDate, new Date()));
     // startDate = new Date();
     // aggregate.RWC6 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package > 3 && f.Package <= 6) || []).length;;
     // logs.push("RWC6:" + this.GetDateDiff(startDate, new Date()));
     // startDate = new Date();
     // aggregate.RWC12 = (renewalsData.filter(f => f.Renewed == "Yes" && f.Package > 6 && f.Package <= 48) || []).length;;

     // logs.push("RWC12:" + this.GetDateDiff(startDate, new Date()));

     // #endregion Empwoer2
 }

 if (null == onlyThese || onlyThese.indexOf("seeta") > -1) {
     // #region Seeta
     startDate = new Date();
     aggregate.SETT = $$this.GetReportsData("seetatotal", dataConst, true, fdt, tdt, facility).length;
     logs.push("SETT:" + this.GetDateDiff(startDate, new Date()));




     startDate = new Date();
     var allseetainvoices = $$this.GetReportsData("seetaallinvoicedata", dataConst, true, fdt, tdt, facility);
     aggregate.SETP = (allseetainvoices.filter(f => !f.Status)).length;
     logs.push("SETP:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.SETPP = (allseetainvoices.filter(f => f.Status == "PARTIALLYPAID")).length;
     logs.push("SETPP:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.SETPA = (allseetainvoices.filter(f => f.Status == "PAID")).length;
     logs.push("SETPA:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.SETKI = $$this.GetReportsData("seetakids", dataConst, true, fdt, tdt, facility).length;
     logs.push("SETKI:" + this.GetDateDiff(startDate, new Date()));
     // #endregion Seeta
 }

 //#Walkin Region
 
 startDate = new Date();
 aggregate.TMWTA = $$this.GetReportsData("walkintoadmisssion", dataConst, true, fdt, tdt, facility).length;
 logs.push("TMWTA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.TMAW = $$this.GetReportsData("activewalkins", dataConst, true, fdt, tdt, facility).length;
 logs.push("TMAW:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.TMCW = $$this.GetReportsData("closedwalkins", dataConst, true, fdt, tdt, facility).length;
 logs.push("TMCW:" + this.GetDateDiff(startDate, new Date()));

 if (null == onlyThese || onlyThese.indexOf("achievements") > -1) {
     // #region Achievements
     startDate = new Date();
     aggregate.OW = $$this.GetReportsData("walkins", dataConst, true, fdt, tdt, facility).length;
     console.log("Walkins Time :" + this.GetDateDiff(startDate, new Date()))
     logs.push("OW:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.FCI = $$this.GetReportsData("credits", dataConst, true, fdt, tdt, facility).length;
     logs.push("FCI:" + this.GetDateDiff(startDate, new Date()));

     //credits

     startDate = new Date();
     aggregate.ADM = $$this.GetReportsData("admissionleads", dataConst, true, fdt, tdt, facility).length;
     console.log("ADMISSION LEADS TIME :" + this.GetDateDiff(startDate, new Date()));
     logs.push("ADM:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.ADD = $$this.GetReportsData("additions", dataConst, true, fdt, tdt, facility).length;
     logs.push("ADD:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TCS = $$this.GetReportsData("inactivations", dataConst, true, fdt, tdt, facility).length;
     logs.push("TCS:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.AC = $$this.GetReportsData("availablecredits", dataConst, true, fdt, tdt, facility).length;
     logs.push("AC:" + this.GetDateDiff(startDate, new Date()));
     // #endregion Achievements
 }


 if (null == onlyThese || onlyThese.indexOf("pendings") > -1) {
     // #region Pendings


     var services = dataConst.Therapies;
     var serviceIds = Object.entries($$this.groupBy(dataConst.Therapies, "BossId"));

     var total = 0;
     var totalST = 0;
     var totalOT = 0;
     var totalBT = 0;
     var totalSE = 0;
     for (var i = 0; i < $$this.servicesOfeering.length; i++) {
         var boss = serviceIds.filter(f => f[1].map(m => m.TypeId).indexOf($$this.servicesOfeering[i].Id) == -1);
         total += (boss || []).length;
         if ($$this.servicesOfeering[i].ShortName == "ST") {
             totalST += (boss || []).length;
         }
         else if ($$this.servicesOfeering[i].ShortName == "BT") {
             totalBT += (boss || []).length;
         }
         else if ($$this.servicesOfeering[i].ShortName == "OT") {
             totalOT += (boss || []).length;
         }
         else if ($$this.servicesOfeering[i].ShortName == "SE") {
             totalSE += (boss || []).length;
         }
     }


     startDate = new Date();
     aggregate.POL = total;
     logs.push("POL:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PAST = totalST;
     logs.push("PAST:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PAOT = totalOT;
     logs.push("PAOT:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PAABA = totalBT;
     logs.push("RCP:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PASE = totalSE;
     logs.push("RCR:" + this.GetDateDiff(startDate, new Date()));
     startDate = new Date();




     startDate = new Date();
     aggregate.AVL = $$this.GetReportsData("available", dataConst, true, fdt, tdt, facility).length;
     logs.push("AVL:" + this.GetDateDiff(startDate, new Date()));




     startDate = new Date();
     aggregate.AHWP = $$this.GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
     logs.push("AHWP:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.RG = $$this.GetReportsData("homeworkcompleted", dataConst, true, fdt, tdt, facility).length;
     logs.push("RG:" + this.GetDateDiff(startDate, new Date()));



     startDate = new Date();
     aggregate.ASP = $$this.GetReportsData("assessmentpending", dataConst, true, fdt, tdt, facility).length;
     logs.push("ASP:" + this.GetDateDiff(startDate, new Date()));


     //startDate = new Date();
     //aggregate.CPC = $$this.GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
     //logs.push("CPC:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.LVP = $$this.GetReportsData("leavespending", dataConst, true, fdt, tdt, facility).length;
     logs.push("LVP:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.LVAL = $$this.GetReportsData("leavesall", dataConst, true, fdt, tdt, facility).length;
     logs.push("LVAL:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.LVAP = $$this.GetReportsData("leavesapproved", dataConst, true, fdt, tdt, facility).length;
     logs.push("LVAP:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.LVUA = $$this.GetReportsData("leavesunapproved", dataConst, true, fdt, tdt, facility).length;
     logs.push("LVUA:" + this.GetDateDiff(startDate, new Date()));

     // startDate = new Date();
     // aggregate.SRIP = $$this.GetReportsData("servicerequestpending", dataConst, true, fdt, tdt, facility).length;
     // console.log("ServiceRequest Pending:"+GetDateDiff(startDate, new Date()));
     // logs.push("SRIP:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.CPA = 0;// $$this.GetReportsData("chipending", dataConst, true, fdt, tdt, facility).length;
     logs.push("CPA:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.WPA = 0;// $$this.GetReportsData("whipending", dataConst, true, fdt, tdt, facility).length;
     logs.push("WPA:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TPA = 0;// $$this.GetReportsData("pisipending", dataConst, true, fdt, tdt, facility).length;
     logs.push("TPA:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.CST = $$this.GetReportsData("compos", dataConst, true, fdt, tdt, facility).length;
     logs.push("CST:" + this.GetDateDiff(startDate, new Date()));

     // #endregion pendings
 }


 if (null == onlyThese || onlyThese.indexOf("services") > -1) {
     startDate = new Date();
     aggregate.SF = $$this.GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
     logs.push("SF:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TCS = $$this.GetReportsData("inactiveservices", dataConst, true, fdt, tdt, facility).length;
     logs.push("TCS:" + this.GetDateDiff(startDate, new Date()));

     //INACTIVATION ROOT CAUSE PENDING
     startDate = new Date();
     aggregate.TCSR = $$this.GetReportsData("inactivecausepending", dataConst, true, fdt, tdt, facility).length;
     logs.push("TCSR:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TFADD = $$this.GetReportsData("futureservices", dataConst, true, fdt, tdt, facility).length;
     logs.push("TFADD:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.ADDS = $$this.GetReportsData("newservices", dataConst, true, fdt, tdt, facility).length;
     logs.push("ADDS:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TSTS = $$this.GetReportsData("newservicesst", dataConst, true, fdt, tdt, facility).length;
     logs.push("TSTS:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TBTS = $$this.GetReportsData("newservicesbt", dataConst, true, fdt, tdt, facility).length;
     logs.push("TBTS:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.TSES = $$this.GetReportsData("newservicesse", dataConst, true, fdt, tdt, facility).length;
     logs.push("TSES:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.TOTS = $$this.GetReportsData("newservicesot", dataConst, true, fdt, tdt, facility).length;
     logs.push("TOTS:" + this.GetDateDiff(startDate, new Date()));
 }
 if (null == onlyThese || onlyThese.indexOf("attendance") > -1) {
     startDate = new Date();
     aggregate.CSC = $$this.GetReportsData("compenstationcompleted", dataConst, true, fdt, tdt, facility).length;
     logs.push("CSC:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.CSF = $$this.GetReportsData("compenstationfuture", dataConst, true, fdt, tdt, facility).length;
     logs.push("CSF:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.CSTO = $$this.GetReportsData("compenstationtoday", dataConst, true, fdt, tdt, facility).length;
     logs.push("CSTO:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.CSO = $$this.GetReportsData("compenstationorphan", dataConst, true, fdt, tdt, facility).length;
     logs.push("CSO:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.CCL = $$this.GetReportsData("compenstationcanceled", dataConst, true, fdt, tdt, facility).length;
     logs.push("CCL:" + this.GetDateDiff(startDate, new Date()));

 }


 if (null == onlyThese || onlyThese.indexOf("misc") > -1) {
     startDate = new Date();
     aggregate.TStaff = $$this.GetReportsData("activestaff", dataConst, true, fdt, tdt, facility).length;
     logs.push("TStaff:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.ASTAFF = $$this.GetReportsData("addedstaff", dataConst, true, fdt, tdt, facility).length;
     logs.push("ASTAFF:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TLStaff = $$this.GetReportsData("leftstaff", dataConst, true, fdt, tdt, facility).length;
     logs.push("TLStaff:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.KIDS = $$this.GetReportsData("activeparents", dataConst, true, fdt, tdt, facility).length;
     logs.push("KIDS:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.TLKIDS = $$this.GetReportsData("leftparents", dataConst, true, fdt, tdt, facility).length;
     logs.push("TLKIDS:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.AKIDs = $$this.GetReportsData("addedparents", dataConst, true, fdt, tdt, facility).length;
     logs.push("AKIDs:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.AMEMO = $$this.GetReportsData("activememos", dataConst, true, fdt, tdt, facility).length;
     logs.push("AMEMO:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.CMEMO = $$this.GetReportsData("closedmemos", dataConst, true, fdt, tdt, facility).length;
     logs.push("CMEMO:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TVPS = $$this.GetReportsData("viewpayslips", dataConst, true, fdt, tdt, facility).length;
     logs.push("TVPS:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.TDPS = $$this.GetReportsData("downloadpayslips", dataConst, true, fdt, tdt, facility).length;
     logs.push("TDPS:" + this.GetDateDiff(startDate, new Date()));

 }

 if (null == onlyThese || onlyThese.indexOf("money") > -1) {
     startDate = new Date();
     aggregate.PP = $$this.GetReportsData("paymentpending", dataConst, true, fdt, tdt, facility);
     logs.push("PP:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.APEN = $$this.GetReportsData("advancepending", dataConst, true, fdt, tdt, facility);
     logs.push("APEN:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PPE = $$this.GetReportsData("paid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     logs.push("PPE:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PA = $$this.GetReportsData("advancepaid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     logs.push("PA:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     var allexpenses = $$this.GetReportsData("expenses", dataConst, true, fdt, tdt, facility);
     aggregate.E = allexpenses.reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     console.log("EXPENSES TIME :" + this.GetDateDiff(startDate, new Date()));
     logs.push("E:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     var fixedHeaderIds = (dataConst.Types.filter(f => f.Category == "Expenses" && $$this.fixedExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

     aggregate.EF = allexpenses.filter(f => fixedHeaderIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);

     logs.push("EF:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var benefitsHeadersIds = (dataConst.Types.filter(f => f.Category == "Expenses" && $$this.benefitExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

     aggregate.EBT = allexpenses.filter(f => benefitsHeadersIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);

     logs.push("EBT:" + this.GetDateDiff(startDate, new Date()));



     startDate = new Date();
     var incentivesHeadersIds = (dataConst.Types.filter(f => f.Category == "Expenses" && $$this.incentiveExpenses.indexOf(f.Name.toLowerCase()) > -1).map(m => m.Id) || []);

     aggregate.EIT = allexpenses.filter(f => incentivesHeadersIds.indexOf(f.TOId) > -1).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);

     logs.push("EIT:" + this.GetDateDiff(startDate, new Date()));

     aggregate.EVE = aggregate.E - aggregate.EF - aggregate.EBT - aggregate.EIT;
     aggregate.EVE = aggregate.EVE > 0 ? aggregate.EVE : 0;


     startDate = new Date();
     aggregate.PIP = $$this.GetReportsData("pastpending", dataConst, true, fdt, tdt, facility);
     logs.push("PIP:" + this.GetDateDiff(startDate, new Date()));

 }




 if (null == onlyThese && (role == "Owner" || role == "FacilityOwner")) {
     startDate = new Date();
     aggregate.TS = $$this.GetReportsData("salary", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     logs.push("TS:" + this.GetDateDiff(startDate, new Date()));



     // startDate = new Date();
     // aggregate.PPE = $$this.GetReportsData("paid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
     //     return accc + items.Amount;
     // }, 0);
     // logs.push("PPE:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PTS = $$this.GetReportsData("paidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     logs.push("PTS:" + this.GetDateDiff(startDate, new Date()));




     startDate = new Date();
     aggregate.AS = $$this.GetReportsData("advancepaidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     console.log("ADVANCEPAID SEVA Time :" + this.GetDateDiff(startDate, new Date()));
     logs.push("AS:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TPMPA = $$this.GetReportsData("pastpaid", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     console.log("PAST PAID TIME: " + this.GetDateDiff(startDate, new Date()))
     logs.push("TPMPA:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.TPMSPA = $$this.GetReportsData("pastpaidseva", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     logs.push("TPMSPA:" + this.GetDateDiff(startDate, new Date()));
     console.log("past paid seva:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.ALFP = $$this.GetReportsData("alreadyfulfilled", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Amount;
     }, 0);
     console.log("ALREADY FULL FILLED :" + this.GetDateDiff(startDate, new Date()));
     logs.push("ALFP:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.ATBF = $$this.GetReportsData("tobefulfilled", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + (items.Amount - items.SevaAmount);
     }, 0);
     logs.push("ATBF:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TDB = $$this.GetReportsData("discount", dataConst, true, fdt, tdt, facility).reduce(function (accc, items) {
         return accc + items.Discount;
     }, 0);
     console.log("DISCOUNT TIME :" + this.GetDateDiff(startDate, new Date()));
     logs.push("TDB:" + this.GetDateDiff(startDate, new Date()));

 }
 else {
     aggregate.TS = 0;
     aggregate.PTS = 0;
     aggregate.AS = 0;
     aggregate.TPMPA = 0;
     aggregate.TPMSPA = 0;
     aggregate.ALFP = 0;
     aggregate.ATBF = 0;
     aggregate.TDB = 0;

 }








 if (null == onlyThese || onlyThese.indexOf("servicerequests") > -1) {

     // #region servicerequests



     startDate = new Date();
     var servicerequests = $$this.GetReportsData("servicerequests", dataConst, true, fdt, tdt, facility);
     var inprocess = servicerequests.filter(m => !m.LastAnalytic || m.LastAnalytic.Status == "REOPEN");
     aggregate.SRIP = (inprocess || []).length;
     console.log("SERVICEREQUEST TIME :" + this.GetDateDiff(startDate, new Date()));
     logs.push("srip:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var waiting = servicerequests.filter(m => m.LastAnalytic && (m.LastAnalytic.Status == "CLOSED" || m.LastAnalytic.Status == "UPDATED") && m.CBPI != m.LastAnalytic.CBPI);
     aggregate.SRW = (waiting || []).length;
     logs.push("SRW:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var closed = servicerequests.filter(m => $$this.dateFromSDateTime(m.CDT) >= FDT && $$this.dateFromSDateTime(m.CDT) <= TDT && m.LastAnalytic && m.LastAnalytic.Status == "CLOSED" && m.CBPI == m.LastAnalytic.CBPI);
     aggregate.SRR = (closed || []).length;
     logs.push("SRR:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var reopen = servicerequests.filter(m => m.LastAnalytic && (m.LastAnalytic.Status == "REOPEN"));
     aggregate.SRRO = (reopen || []).length;
     logs.push("SRRO:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     //aggregate.SRT = aggregate.SRRO + aggregate.SRR + aggregate.SRW + aggregate.SRIP;
     aggregate.SRT=servicerequests.length
     //aggregate.SRT = $$this.GetReportsData("servicerequestall", dataConst, true, fdt, tdt, facility).length;

     aggregate.SR5 = servicerequests.filter(m => m.Rating == 5).length;
     logs.push("SR5:" + this.GetDateDiff(startDate, new Date()));
     startDate = new Date();
     aggregate.SR4 = servicerequests.filter(m => m.Rating == 4).length;
     logs.push("SR4:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.SR3 = servicerequests.filter(m => m.Rating == 3).length;
     logs.push("SR3:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.SR2 = servicerequests.filter(m => m.Rating == 2).length;
     logs.push("SR2:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.SR1 = servicerequests.filter(m => m.Rating == 1).length;
     logs.push("SR1:" + this.GetDateDiff(startDate, new Date()));

     // #endregion servicerequests

 }
 if (null == onlyThese || onlyThese.indexOf("leads") > -1) {

     // #region lead

     startDate = new Date();
     aggregate.LEP = $$this.GetReportsData("leadspending", dataConst, true, fdt, tdt, facility).length;
     logs.push("LEP:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var allLeads = dataConst.Leads;


     //active
     startDate = new Date();
     var activeLeads = $$this.GetReportsData("activeleadsdata", dataConst, true, fdt, tdt, facility);
     aggregate.LA = activeLeads.length;
     console.log("LEADS ACTIVE TIME:" + this.GetDateDiff(startDate, new Date()));
     logs.push("LA:" + this.GetDateDiff(startDate, new Date()));


     //closed
     startDate = new Date();
     var closedLeads = $$this.GetReportsData("closedleadsdata", dataConst, true, fdt, tdt, facility);
     aggregate.LC = closedLeads.length;
     logs.push("LC:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.LTO = aggregate.LA + aggregate.LC;
     logs.push("LTO:" + this.GetDateDiff(startDate, new Date()));

     // New
     startDate = new Date();
     aggregate.LN = $$this.GetReportsData("newleads", dataConst, true, fdt, tdt, facility).length;
     logs.push("LN:" + this.GetDateDiff(startDate, new Date()));


     // Else where

     startDate = new Date();
     var elseWhere = $$this.GetReportsData("leadselsewhere", dataConst, true, fdt, tdt, facility);
     aggregate.JSW = elseWhere.length;
     logs.push("JSW:" + this.GetDateDiff(startDate, new Date()));
     // Assessments - Doubt
     //var lIds = groupBy(allLeads,"TOId").map(m => m.Id);
     //aggregate.LASM = data.ANALYTICS.Where(m => m.AT == EnumSharb.ActivityType.BookAssessment.ToString().ToUpper() && lIds.Contains(m.TOId)).Count();

     // Admissions

     startDate = new Date();
     var filteredLta = $$this.GetReportsData("leadstoadmission", dataConst, true, fdt, tdt, facility);
     aggregate.LTA = filteredLta.length;
     logs.push("LTA:" + this.GetDateDiff(startDate, new Date()));

     // #endregion lead
 }
 if (null == onlyThese || onlyThese.indexOf("goals") > -1) {

     // #region Goals

     //total goals

     startDate = new Date();
     aggregate.TGO = $$this.GetReportsData("totalgoals", dataConst, true, fdt, tdt, facility).length;
     logs.push("TGO:" + this.GetDateDiff(startDate, new Date()));


     //active goals

     startDate = new Date();
     aggregate.TAG = $$this.GetReportsData("activegoals", dataConst, true, fdt, tdt, facility).length;
     logs.push("TAG:" + this.GetDateDiff(startDate, new Date()));

     // Today pending goals
     startDate = new Date();
     aggregate.TGP = $$this.GetReportsData("todaypendinggoals", dataConst, true, fdt, tdt, facility).length;
     logs.push("TGP:" + this.GetDateDiff(startDate, new Date()));

     //Goal Reviewed

     startDate = new Date();
     aggregate.GR = $$this.GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
     logs.push("GR:" + this.GetDateDiff(startDate, new Date()));


     // Goal ontime
     //startDate = new Date();
     //aggregate.TGONT = $$this.GetReportsData("goalontime", dataConst, true, fdt, tdt, facility).length;
     //logs.push("TGONT:" + this.GetDateDiff(startDate, new Date()));


     //// Goal late
     //startDate = new Date();
     //aggregate.TGOOT = $$this.GetReportsData("goallate", dataConst, true, fdt, tdt, facility).length;
     //logs.push("TGOOT:" + this.GetDateDiff(startDate, new Date()));


     // Goal Met
     startDate = new Date();
     aggregate.TGM = $$this.GetReportsData("goalmet", dataConst, true, fdt, tdt, facility).length;
     logs.push("TGM:" + this.GetDateDiff(startDate, new Date()));

     // Goal Not Met
     startDate = new Date();
     aggregate.GNM = $$this.GetReportsData("goalnotmet", dataConst, true, fdt, tdt, facility).length;
     logs.push("GNM:" + this.GetDateDiff(startDate, new Date()));

     // #endregion Goals
 }

 if (null == onlyThese || onlyThese.indexOf("assessments") > -1) {

     // #region assessments
     startDate = new Date();
     var allAssessmentsData = dataConst.Assessmentsdata;
     aggregate.TAB = $$this.GetReportsData("assessmentall", dataConst, true, fdt, tdt, facility).length;
     logs.push("TAB:" + this.GetDateDiff(startDate, new Date()));
     // Pending - NIPL

     startDate = new Date();
     aggregate.ASP = allAssessmentsData.filter(m => m.Status.toLowerCase() != "completed" && $$this.dateFromSDateTime(m.CDT) >= FDT).length;
     logs.push("ASP:" + this.GetDateDiff(startDate, new Date()));

     // Completed assessment
     startDate = new Date();
     aggregate.AST = $$this.GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
     // aggregate.AST = allAssessmentsData.filter(m => m.Status.toLowerCase() == "completed").length;
     logs.push("AST:" + this.GetDateDiff(startDate, new Date()));


     /*   var assessmentIds = allAssessmentsData.map(m => m.Id);
        var assessmnetInvoices = facilityInvoices.Where(m => null != m.RDUId && m.RDUId.Count() > 0 && assessmentIds.Contains(m.RDUId[0].ToString())).ToList();
        aggregate.TPFA = assessmnetInvoices.Sum(m => m.F7);
        aggregate.TSPFA = assessmnetInvoices.Sum(m => m.F8);*/

     // #endregion assessments
 }

 if (null == onlyThese || onlyThese.indexOf("leaves") > -1) {

     // #region Leave Requests


     var currentDate = new Date();

     startDate = new Date();
     var futureLeaves = $$this.GetReportsData("leaverequestparentfuture", dataConst, true, fdt, tdt, facility);
     aggregate.PLF = (futureLeaves || []).length;
     logs.push("PLF:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var completedLeaves = $$this.GetReportsData("leaverequestparentcompleted", dataConst, true, fdt, tdt, facility);
     aggregate.PLC = (completedLeaves || []).length;
     logs.push("PLC:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var cancelledLeaved = $$this.GetReportsData("leaverequestparentcanceled", dataConst, true, fdt, tdt, facility);
     aggregate.PLCA = (cancelledLeaved || []).length;
     logs.push("PLCA:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.TOPL = aggregate.PLF + aggregate.PLC + aggregate.PLCA;
     logs.push("TOPL:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var futurenpLeaves = $$this.GetReportsData("leaverequestnonparentfuture", dataConst, true, fdt, tdt, facility);
     aggregate.SLF = (futurenpLeaves || []).length;
     logs.push("SLF:" + this.GetDateDiff(startDate, new Date()));



     startDate = new Date();
     var lrclt4 = $$this.GetReportsData("leaverequestcomposlt4", dataConst, true, fdt, tdt, facility);
     aggregate.SLCLT4 = (lrclt4 || []).length;
     logs.push("SLCLT4:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     var completednpLeaves = $$this.GetReportsData("leaverequestnonparentcompleted", dataConst, true, fdt, tdt, facility);
     aggregate.SLC = (completednpLeaves || []).length;
     logs.push("SLC:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var cancellednpLeaved = $$this.GetReportsData("leaverequestnonparentcanceled", dataConst, true, fdt, tdt, facility);
     aggregate.SLCA = (cancellednpLeaved || []).length;
     logs.push("SLCA:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.TOSL = aggregate.SLF + aggregate.SLC + aggregate.SLCA;
     logs.push("TOSL:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var approvedLeaves = $$this.GetReportsData("leaverequestanalytic", dataConst, true, fdt, tdt, facility);
     aggregate.SLA = (approvedLeaves || []).length;
     logs.push("SLA:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var unapprovedLeaves = $$this.GetReportsData("leaverequestanalyticunapproved", dataConst, true, fdt, tdt, facility);
     aggregate.SLUA = (unapprovedLeaves || []).length;
     logs.push("SLUA:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.SLAP = aggregate.SLF + aggregate.SLC - aggregate.SLA - aggregate.SLUA;
     logs.push("SLAP:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var pendingLeaves = $$this.GetReportsData("leavespendingapproval", dataConst, true, fdt, tdt, facility);
     aggregate.SLPA = (pendingLeaves || []).length;
     logs.push("SLPA:" + this.GetDateDiff(startDate, new Date()));



     // #endregion Leave Requests
 }

 if (null == onlyThese || onlyThese.indexOf("whi") > -1) {

     // #region WHI
     startDate = new Date();
     var whiLatest = $$this.GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
     aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
     logs.push("PROA:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
     logs.push("PROS:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
     aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
     logs.push("PROP:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
     logs.push("PROT10:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
     logs.push("PROT40:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
     logs.push("PROT40:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
     logs.push("PROB10:" + this.GetDateDiff(startDate, new Date()));
     // #endregion WHI
     // start biometric

     //totalstaff


     /*  startDate = new Date();
       aggregate.TStaff = $$this.GetReportsData("totalstaff", dataConst, true, fdt, tdt, facility).length;
       logs.push("TStaff:" + this.GetDateDiff(startDate, new Date()));
*/
     // biometric absent
     // startDate = new Date();
     // aggregate.BMA = $$this.GetReportsData("biometricabsent", dataConst, true, fdt, tdt, facility).length;
     // logs.push("BMA:" + this.GetDateDiff(startDate, new Date()));

     // // biometric present
     // startDate = new Date();
     // aggregate.BMP = $$this.GetReportsData("biometricpresent", dataConst, true, fdt, tdt, facility).length;
     // logs.push("BMP:" + this.GetDateDiff(startDate, new Date()));
     // // biometric entry early
     // startDate = new Date();
     // aggregate.BMENE = $$this.GetReportsData("biometricentryearly", dataConst, true, fdt, tdt, facility).length;
     // logs.push("BMENE:" + this.GetDateDiff(startDate, new Date()));
     // // biometric entry ontime
     // startDate = new Date();
     // aggregate.BMENOT = $$this.GetReportsData("biometricentryontime", dataConst, true, fdt, tdt, facility).length;
     // logs.push("BMENOT:" + this.GetDateDiff(startDate, new Date()));
     // // biometric entry late
     // startDate = new Date();
     // aggregate.BMENL = $$this.GetReportsData("biometricentrylate", dataConst, true, fdt, tdt, facility).length;
     // logs.push("BMENL:" + this.GetDateDiff(startDate, new Date()));
     // // biometric exit early
     // startDate = new Date();
     // aggregate.BMEXE = $$this.GetReportsData("biometricexitearly", dataConst, true, fdt, tdt, facility).length;
     // logs.push("BMEXE:" + this.GetDateDiff(startDate, new Date()));
     // // biometric exit ontime
     // startDate = new Date();
     // aggregate.BMEXOT = $$this.GetReportsData("biometricexitontime", dataConst, true, fdt, tdt, facility).length;
     // logs.push("BMEXOT:" + this.GetDateDiff(startDate, new Date()));
     // // biometric exit late
     // startDate = new Date();
     // aggregate.BMEXL = $$this.GetReportsData("biometricexitlate", dataConst, true, fdt, tdt, facility).length;
     // logs.push("BMEXL:" + this.GetDateDiff(startDate, new Date()));


     // #endregion biometric
 }


 if (null == onlyThese || onlyThese.indexOf("chi") > -1) {

     // #region CHI
     startDate = new Date();
     var chiLatest = $$this.GetReportsData("chilatest", dataConst, true, fdt, tdt, facility);

     var chiids = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.map(m => m.CenterNoteId) : [];

     aggregate.CPA = chiLatest && chiLatest.Assessments && chiLatest.Assessments.length > 0 ? chiLatest.Assessments.filter(f => chiids.indexOf(f.Id) == -1).length : 0;

     logs.push("CPA:" + this.GetDateDiff(startDate, new Date()));
     // Overall efficacy

     startDate = new Date();
     var COA = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
     logs.push("COA:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.COE = !COA || COA.length == 0 ? 0 : Math.round(COA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (COA.length * 5), 2);
     logs.push("COE:" + this.GetDateDiff(startDate, new Date()));



     // center hygiene
     startDate = new Date();
     var CHG = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("center hygiene")) : [];


     aggregate.CHG = !CHG || CHG.length == 0 ? 0 : Math.round(CHG.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CHG.length * 5), 2);
     logs.push("CHG:" + this.GetDateDiff(startDate, new Date()));

     // washroom hygiene
     startDate = new Date();
     var CWH = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("washroon hygiene")) : [];

     aggregate.CWH = !CWH || CWH.length == 0 ? 0 : Math.round(CWH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CWH.length * 5), 2);
     logs.push("CWH:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     // center welcomeness
     var CWN = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("center welcomeness")) : [];

     aggregate.CWN = !CWN || CWN.length == 0 ? 0 : Math.round(CWN.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (CWN.length * 5), 2);
     logs.push("CWN:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     // Suggestions
     var suggestions = chiLatest && chiLatest.Reponses && chiLatest.Reponses.length > 0 ? chiLatest.Reponses.filter(m => m.Question && -1 < m.Question.indexOf("Appreciations / Suggestions") && m.Response) : [];
     aggregate.CAS = suggestions.length;
     logs.push("CAS:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.CCA = chiLatest && chiLatest.Assessments && chiLatest.Assessments.length > 0 ? chiLatest.Assessments.length : 0 - aggregate.CPA;
     logs.push("CCA:" + this.GetDateDiff(startDate, new Date()));

     // #endregion CHI
 }
 if (null == onlyThese || onlyThese.indexOf("pisi") > -1) {

     // #region PISI
     startDate = new Date();
     var pisiLatest = $$this.GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

     var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

     aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
     logs.push("TPA:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
     aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
     logs.push("TOE:" + this.GetDateDiff(startDate, new Date()));

     // therapy improvemnet
     startDate = new Date();
     var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
     aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
     logs.push("TTI:" + this.GetDateDiff(startDate, new Date()));

     // Daily Homework Feedback
     startDate = new Date();
     var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

     aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
     logs.push("TDH:" + this.GetDateDiff(startDate, new Date()));
     // Daily after therapy interaction

     startDate = new Date();
     var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
     aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
     logs.push("TDA:" + this.GetDateDiff(startDate, new Date()));
     // Daily Homework Feedback

     startDate = new Date();
     var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



     aggregate.TASS = TAS.length;
     aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
     logs.push("TASS:" + this.GetDateDiff(startDate, new Date()));
     // #endregion PISI

     // #region Mirracles*/

     startDate = new Date();
     aggregate.MIRT = $$this.GetReportsData("mirraclestotal", dataConst, true, fdt, tdt, facility).length;
     logs.push("MIRT:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.MIRC = $$this.GetReportsData("mirraclescontributed", dataConst, true, fdt, tdt, facility).length;
     logs.push("MIRC:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.MIRNC = $$this.GetReportsData("mnotcontributed", dataConst, true, fdt, tdt, facility).length;
     logs.push("MIRNC:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.MIRV = $$this.GetReportsData("allmirraclesviews", dataConst, true, fdt, tdt, facility);
     logs.push("MIRV:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.MIRT100 = $$this.GetReportsData("mirraclestop100", dataConst, true, fdt, tdt, facility).length;
     logs.push("MIRT100:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.MIRB100 = $$this.GetReportsData("mirraclesbottom100", dataConst, true, fdt, tdt, facility).length;
     logs.push("MIRB100:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.MIRLC = $$this.GetReportsData("mirracleslc", dataConst, true, fdt, tdt, facility).length;
     logs.push("MIRLC:" + this.GetDateDiff(startDate, new Date()));

     startDate = new Date();
     aggregate.MIRLNC = $$this.GetReportsData("mirraclesnotcovered", dataConst, true, fdt, tdt, facility);
     logs.push("MIRLNC:" + this.GetDateDiff(startDate, new Date()));


     startDate = new Date();
     aggregate.MAC = $$this.GetReportsData("mirraclepending", dataConst, true, fdt, tdt, facility).length;
     logs.push("MAC:" + this.GetDateDiff(startDate, new Date()));

     //var mirraclesFiltered = (mirracles || []).filter(f => $$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) < TDT);
     //var allmirracles = data.Mirracles.filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) < TDT) || (f.UDT && $$this.dateFromSDateTime(f.UDT) >= FDT && $$this.dateFromSDateTime(f.UDT) < TDT)).sort((a, b) => (b.F8 < a.F8 ? -1 : 1));

     //var top100Mirracles = (allmirracles || []).slice(0, 99).map(m=> m.Id);
     //var bottom100Mirracles = (allmirracles || []).slice(-100).map(m=> m.Id);

     //var mirraclesFilteredIncludingUpdate = (mirracles || []).filter(f => ($$this.dateFromSDateTime(f.CDT) >= FDT && $$this.dateFromSDateTime(f.CDT) < TDT) || (f.UDT && $$this.dateFromSDateTime(f.UDT) >= FDT && $$this.dateFromSDateTime(f.UDT) < TDT));

     //aggregate.MIRT100 =  mirraclesFilteredIncludingUpdate.filter(m => top100Mirracles.indexOf(m.Id) > -1).length;

     //aggregate.MIRB100 = mirraclesFilteredIncludingUpdate.filter(m => bottom100Mirracles.indexOf(m.Id) > -1).length;


     //mirraclesFiltered = mirraclesFiltered || [];

     //aggregate.MIRT = mirraclesFiltered.length;
     //try {
     //    aggregate.MIRC = Object.keys(groupBy(mirraclesFiltered, "PersonId")).length;
     //} catch (e) {

     //}



     //aggregate.MIRNC = Object.keys(groupBy(dataConst.People.filter(m => (m.RoleId == therapistId || m.RoleId == adminId) && m.F8 != 1 && m.RS != "DELETEACTIVITY"), "Id")).length - aggregate.MIRC;


     //aggregate.MIRV = (mirraclesFilteredIncludingUpdate || []).reduce(function (accumulator, item) {
     //    return accumulator + item.F8;
     //}, 0);


     //var languageIds = data.Types.filter(m => m.Category == "Languages").map(m => m.Id);
     //aggregate.MIRLC = Object.keys(groupBy(mirraclesFiltered, "LanguageId")).length;
     //aggregate.MIRLNC = languageIds.length - aggregate.MIRLC;

     // #endregion Mirracles*/
 }
 if (null == onlyThese || onlyThese.indexOf("dang") > -1) {

     // #region Dang*/
     var dangTypeId = $$this.GetTypeIdByName(dataConst.Types, "DANGANALYTIC");
     var currentDang = dataConst && dataConst.PeopleNotes && dataConst.PeopleNotes.length > 0 ? dataConst.PeopleNotes.filter(f => f.TypeId == dangTypeId && new Date(f.CDT) >= FDT && new Date(f.CDT) <= TDT) : [];

     aggregate.DYES = currentDang && currentDang && currentDang.length > 0 ? currentDang.filter(f => f.F7 == 1).length : 0;
     aggregate.DNO = currentDang && currentDang && currentDang.length > 0 ? currentDang.filter(f => f.F7 != 1).length : 0;

     // aggregate.DYES = dang.filter(f => f.IsDone == 1).length;
     // aggregate.DNO = dang.filter(f => f.IsDone != 1).length;
     aggregate.DOT = currentDang.filter(f => f.F6 != 1).length;
     aggregate.DLATE = currentDang.filter(f => f.F6 == 1).length;

     aggregate.DPM = $$this.CalculateDangPendingCount(currentDang, $$this.dangConfig, FDT, TDT, fids);

     var todayDang = currentDang.filter(f => $$this.dateFromSDateTime(f.CDT).toDateString() == new Date().toDateString());
     aggregate.DPD = $$this.CalculateDangPendingCount(todayDang, $$this.dangConfig, new Date(), new Date(), fids);
     // #endregion Dang*/
 }


 // startDate = new Date();
 // aggregate.DA=$$this.GetReportsData("pollincationclarity", dataConst, true, fdt, tdt, facility);
 // logs.push("DA:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 var dueAll = $$this.GetReportsData("dueall", dataConst, true, fdt, tdt, facility);


 //     return invoicesamount;
 aggregate.DA = dueAll ? dueAll.reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0) : 0;
 logs.push("DA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();

 aggregate.DO = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "overdue").reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0);//  $$this.GetReportsData("dueoverdue", dataConst, true, fdt, tdt, facility);
 logs.push("DO:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.DT = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "today").reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0);  // $$this.GetReportsData("duetoday", dataConst, true, fdt, tdt, facility);
 logs.push("DT:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.DTM = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "tomorrow").reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0); //  $$this.GetReportsData("duetomorrow", dataConst, true, fdt, tdt, facility);
 logs.push("DTM:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.DTW = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "thisweek").reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0); //$$this.GetReportsData("duethisweek", dataConst, true, fdt, tdt, facility);
 logs.push("DTW:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.DNW = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "nextweek").reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0);  //$$this.GetReportsData("duenextweek", dataConst, true, fdt, tdt, facility);
 logs.push("DNW:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.DTMN = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "thismonth").reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0); //$$this.GetReportsData("duethismonth", dataConst, true, fdt, tdt, facility);
 logs.push("DTMN:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.DNM = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "nextmonth").reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0); //$$this.GetReportsData("duenextmonth", dataConst, true, fdt, tdt, facility);
 logs.push("DNM:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.DF = dueAll.filter(f => f.ETA && f.ETA.toLowerCase() == "future").reduce(function (accumulator, item) {
     return accumulator + (item["Amount"]);
 }, 0);//$$this.GetReportsData("duefuture", dataConst, true, fdt, tdt, facility);
 logs.push("DF:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.DEP = $$this.GetReportsData("etapending", dataConst, true, fdt, tdt, facility);
 console.log("ETA PENDING Time:" + this.GetDateDiff(startDate, new Date()));
 logs.push("DEP:" + this.GetDateDiff(startDate, new Date()));













 startDate = new Date();
 aggregate.WD = dataConst.TWD;
 logs.push("TWD:" + this.GetDateDiff(startDate, new Date()));

 var pendingClarity = $$this.GetReportsData("pinnacleclaritypending", dataConst, true, fdt, tdt, facility);
 var pinnacleClarityPending = (pendingClarity || []).filter(e => (!e.Reply || e.Reply == ''));
 var pinnacleClarityCompleted = (pendingClarity || []).filter(e => !(!e.Reply || e.Reply == ''));
 aggregate.PCLAP = pinnacleClarityPending && pinnacleClarityPending.length > 0 ? pinnacleClarityPending.length : 0;
 aggregate.PCLAC = pinnacleClarityCompleted && pinnacleClarityCompleted.length > 0 ? pinnacleClarityCompleted.length : 0;

 aggregate.BUSINESS = (parseInt(aggregate.PP) + parseInt(aggregate.PPE) + parseInt(aggregate.PA) + parseInt(aggregate.APEN));


 startDate = new Date();
 aggregate.PCP = $$this.GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
 logs.push("PCP:" + this.GetDateDiff(startDate, new Date()));

 // startDate = new Date();
 // aggregate.TGNS = $$this.GetReportsData("goalsnotset", dataConst, true, fdt, tdt, facility).length;
 // logs.push("TGNS:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.TGNS = $$this.GetReportsData("aigoalsnotset", dataConst, true, fdt, tdt, facility).length;
 logs.push("TGNS:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.DAIP = $$this.GetReportsData("demographicaipending", dataConst, true, fdt, tdt, facility).length;
 console.log("demographicai PENDING Time: "+$$this.GetDateDiff(startDate,new Date()));
 logs.push("DAIP:" + this.GetDateDiff(startDate, new Date()));

 // startDate = new Date();
 // aggregate.KPIAP = $$this.GetReportsData("attendancepending", dataConst, true, fdt, tdt, facility);
 // logs.push("AP:" + this.GetDateDiff(startDate, new Date()));

 // startDate = new Date();
 // aggregate.AP = $$this.GetReportsData("kpiattendancepending", dataConst, true, fdt, tdt, facility);
 // logs.push("AP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.AP = $$this.GetReportsData("kidattendancepending", dataConst, true, fdt, tdt, facility);
 logs.push("AP:" + this.GetDateDiff(startDate, new Date()));

 // startDate = new Date();
 // aggregate.KIDAP = $$this.GetReportsData("kidattendancepending", dataConst, true, fdt, tdt, facility);
 // logs.push("KIDAP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var compodataa = $$this.GetReportsData("compospending", dataConst, true, fdt, tdt, facility);
 aggregate.CPC = compodataa > 0 ? compodataa : 0;
 logs.push("CPC:" + this.GetDateDiff(startDate, new Date()));

 //startDate = new Date();
 //aggregate.AGP = $$this.GetReportsData("therapiesprovided", dataConst, true, fdt, tdt, facility).length;
 //logs.push("AGP:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.AGP = $$this.GetReportsData("attendancepresent", dataConst, true, fdt, tdt, facility).length;
 logs.push("AGP:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.AGA = $$this.GetReportsData("attendanceabsent", dataConst, true, fdt, tdt, facility).length;
 logs.push("AGA:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.TOA = aggregate.AP + aggregate.AGP + aggregate.AGA;
 logs.push("TOA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.ABS = (aggregate.AGA - aggregate.CST) > 0 ? (aggregate.AGA - aggregate.CST) : 0;
 logs.push("ABS:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.GR = $$this.GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
 logs.push("GR:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.AWARDS = $$this.GetReportsData("awardswon", dataConst, true, fdt, tdt, facility).length;
 logs.push("AWARDS:" + this.GetDateDiff(startDate, new Date()));

 ///POLLINATION

 // startDate = new Date();
 // aggregate.PCP =$$this.GetReportsData("pollinationclaritypromised", dataConst, true, fdt, tdt, facility);
 // logs.push("PCP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PCC = $$this.GetReportsData("pollinationclaritycompleted", dataConst, true, fdt, tdt, facility);
 logs.push("PCC:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PCYT = $$this.GetReportsData("pollinationclarityyetto", dataConst, true, fdt, tdt, facility);
 logs.push("RPCYTCTD:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PCZ = $$this.GetReportsData("pollinationclarityzero", dataConst, true, fdt, tdt, facility);
 logs.push("PCZ:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.PCLT = $$this.GetReportsData("pollinationclaritylessthanthree", dataConst, true, fdt, tdt, facility);
 logs.push("PCLT:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PCGT = $$this.GetReportsData("pollinationclaritygreaterthanthree", dataConst, true, fdt, tdt, facility);
 logs.push("PCGT:" + this.GetDateDiff(startDate, new Date()));


 //  startDate = new Date();
 //  aggregate.PAO=$$this.GetReportsData("pollinationopty", dataConst, true, fdt, tdt, facility);
 //  logs.push("PAO:" + this.GetDateDiff(startDate, new Date()));





 ///POLLINATION


 /*startDate = new Date();
 var pisiLatesttherapy = $$this.GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

 var pisiids = pisiLatesttherapy.Reponses.map(m => m.PeopleNoteId);


 startDate = new Date();
 var TOA = pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy"));
 aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
 logs.push("TOE:" + this.GetDateDiff(startDate, new Date()));

 var TAS = pisiLatesttherapy && pisiLatesttherapy.length > 0 ? pisiLatesttherapy.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



 aggregate.TASS = TAS.length;
 //aggregate.TCA = pisiLatest && pisiLatest.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
 logs.push("TASS:" + this.GetDateDiff(startDate, new Date()));
 */

 // #region PISI
 startDate = new Date();
 var pisiLatest = $$this.GetReportsData("pisilatest", dataConst, true, fdt, tdt, facility);

 var pisiids = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.map(m => m.PeopleNoteId) : [];

 aggregate.TPA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.filter(f => pisiids.indexOf(f.Id) == -1).length : 0;
 logs.push("TPA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var TOA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("overall efficacy")) : [];
 aggregate.TOE = !TOA || TOA.length == 0 ? 0 : Math.round(TOA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TOA.length * 5), 2);;
 logs.push("TOE:" + this.GetDateDiff(startDate, new Date()));

 // therapy improvemnet
 startDate = new Date();
 var TTI = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("improvemnet")) : [];
 aggregate.TIP = !TTI || TTI.length == 0 ? 0 : Math.round(TTI.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TTI.length * 5), 2);;
 logs.push("TTI:" + this.GetDateDiff(startDate, new Date()));

 // Daily Homework Feedback
 startDate = new Date();
 var TDH = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily homework feedback")) : [];

 aggregate.TDH = !TDH || TDH.length == 0 ? 0 : Math.round(TDH.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDH.length * 5), 2);
 logs.push("TDH:" + this.GetDateDiff(startDate, new Date()));
 // Daily after therapy interaction

 startDate = new Date();
 var TDA = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("daily after therapy interaction")) : [];
 aggregate.TDA = !TDA || TDA.length == 0 ? 0 : Math.round(TDA.reduce((partialSum, a) => partialSum + parseInt(a.Response), 0) * 100 / (TDA.length * 5), 2);
 logs.push("TDA:" + this.GetDateDiff(startDate, new Date()));
 // Daily Homework Feedback

 startDate = new Date();
 var TAS = pisiLatest && pisiLatest.Reponses && pisiLatest.Reponses.length > 0 ? pisiLatest.Reponses.filter(m => m.Question && -1 < m.Question.toLowerCase().indexOf("appreciations / suggestions") && m.Response) : [];



 aggregate.TASS = TAS.length;
 aggregate.TCA = pisiLatest && pisiLatest.Assessments && pisiLatest.Assessments.length > 0 ? pisiLatest.Assessments.length : 0 - aggregate.TPA;
 logs.push("TASS:" + this.GetDateDiff(startDate, new Date()));
 // #endregion PISI

 startDate = new Date();
 var whiLatest = $$this.GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);
 aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 > 0 ? whiLatest.Assessments.length : 0;
 logs.push("PROA:" + this.GetDateDiff(startDate, new Date()));
 var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];

 startDate = new Date();
 aggregate.PROS = whiLatest && whiLatest.length > 0 ? whiLatest.Suggestions.length : 0;
 logs.push("PROS:" + this.GetDateDiff(startDate, new Date()));


 //if (role == "Therapist") {
 //    startDate = new Date();
 //    aggregate.TOE = $$this.GetReportsData("pisirating", dataConst, true, fdt, tdt, facility).length;
 //    logs.push("TOE:" + this.GetDateDiff(startDate, new Date()));
 //}



 //startDate = new Date();
 //aggregate.MIRT = $$this.GetReportsData("mirracles", dataConst, true, fdt, tdt, facility).length;
 //logs.push("MIRT:" + this.GetDateDiff(startDate, new Date()));

 /*startDate = new Date();
 aggregate.RP = $$this.GetReportsData("feedbackspending", dataConst, true, fdt, tdt, facility).length;
 logs.push("RP:" + this.GetDateDiff(startDate, new Date()));*/
 //Change below like above


 startDate = new Date();
 aggregate.RG = $$this.GetReportsData("feedbacksgiven", dataConst, true, fdt, tdt, facility).length;
 logs.push("RG:" + this.GetDateDiff(startDate, new Date()));


  // Homework pending
  startDate = new Date();
  aggregate.RP = $$this.GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
  logs.push("RP:" + this.GetDateDiff(startDate, new Date()));

 // startDate = new Date();
 // aggregate.RP = aggregate.AGP - aggregate.RG;//  $$this.GetReportsData("homeworkpending", dataConst, true, fdt, tdt, facility).length;
 // logs.push("RP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RGT = $$this.GetReportsData("feedbackratings", dataConst, true, fdt, tdt, facility);
 logs.push("RGT:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RAT = aggregate.RG ? (aggregate.RGT / aggregate.RG).toFixed(2) : 0;
 logs.push("RAT:" + this.GetDateDiff(startDate, new Date()));
 //TOE
 //AGP
 //CPC
 //Goals for therapist
 startDate = new Date();
 aggregate.GR = $$this.GetReportsData("goalreviewed", dataConst, true, fdt, tdt, facility).length;
 logs.push("GR:" + this.GetDateDiff(startDate, new Date()));

 //Goal Pending for therapist
 startDate = new Date();
 aggregate.GP = $$this.GetReportsData("goalspending", dataConst, true, fdt, tdt, facility).length;
 console.log("GOALS PENDING Time: " + this.GetDateDiff(startDate, new Date()));
 logs.push("GP:" + this.GetDateDiff(startDate, new Date()));

 //services

 startDate = new Date();
 aggregate.SF = $$this.GetReportsData("activeservices", dataConst, true, fdt, tdt, facility).length;
 logs.push("CST:" + this.GetDateDiff(startDate, new Date()));

 //Assessments

 startDate = new Date();
 var allAssessmentsData = dataConst.Assessmentsdata;

 startDate = new Date();
 aggregate.ASP = allAssessmentsData.filter(m => m.Status.toLowerCase() != "completed" && $$this.dateFromSDateTime(m.CDT) >= FDT).length;
 logs.push("ASP:" + this.GetDateDiff(startDate, new Date()));

 // Completed assessment
 startDate = new Date();
 aggregate.AST = $$this.GetReportsData("assessmentcompleted", dataConst, true, fdt, tdt, facility).length;
 logs.push("AST:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var whiLatest = $$this.GetReportsData("WHILATEST", dataConst, true, fdt, tdt, facility);

 aggregate.PROA = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.length : 0;
 logs.push("PROA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROS = whiLatest && whiLatest.Suggestions && whiLatest.Suggestions.length > 0 ? whiLatest.Suggestions.length : 0;
 logs.push("PROS:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 var whiids = whiLatest && whiLatest.Reponses && whiLatest.Reponses.length > 0 ? whiLatest.Reponses.map(m => m.PeopleNoteId) : [];
 aggregate.PROP = whiLatest && whiLatest.Assessments && whiLatest.Assessments.length > 0 ? whiLatest.Assessments.filter(f => whiids.indexOf(f.Id) == -1).length : 0;
 logs.push("PROP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROT10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top10").length : 0;
 logs.push("PROT10:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROT40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "top40").length : 0;
 logs.push("PROT40:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROB40 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom40").length : 0;
 logs.push("PROT40:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PROB10 = whiLatest && whiLatest.Ranks && whiLatest.Ranks.length > 0 ? whiLatest.Ranks.filter(m => m.RankTextId == "bottom10").length : 0;
 logs.push("PROB10:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 var allrenewalClarity = $$this.GetReportsData("renewalclarityall", dataConst, true, fdt, tdt, facility);
 // var AllFeeETA = data.filter(e =>  (type.toLowerCase() == "renewalclarityall" ? true : type.toLowerCase() == "renewalclaritytoberenewed" ? tobeRenewed.indexOf(e.Details.toLowerCase()) == -1 : type.toLowerCase() == "renewalclarity"+e.Details.toLowerCase()+""));

 aggregate.RCA = allrenewalClarity.length;
 logs.push("RCA:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();

 aggregate.RCOD = allrenewalClarity.filter(f => f.Details == "overdue").length;//  $$this.GetReportsData("renewalclarityoverdue", dataConst, true, fdt, tdt, facility);
 logs.push("RCOD:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCTD = allrenewalClarity.filter(f => f.Details == "today").length; //$$this.GetReportsData("renewalclaritytoday", dataConst, true, fdt, tdt, facility);
 logs.push("RCTD:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCTR = allrenewalClarity.filter(f => f.Details == "tomorrow").length; //$$this.GetReportsData("renewalclaritytomorrow", dataConst, true, fdt, tdt, facility);
 logs.push("RCTR:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.RCTW = allrenewalClarity.filter(f => f.Details == "thisweek").length; //$$this.GetReportsData("renewalclaritythisweek", dataConst, true, fdt, tdt, facility);
 logs.push("RCTW:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCNW = allrenewalClarity.filter(f => f.Details == "nextweek").length; //$$this.GetReportsData("renewalclaritynextweek", dataConst, true, fdt, tdt, facility);
 logs.push("RCNW:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.RCTM = allrenewalClarity.filter(f => f.Details == "thismonth").length; //$$this.GetReportsData("renewalclaritythismonth", dataConst, true, fdt, tdt, facility);
 logs.push("RCTM:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCNM = allrenewalClarity.filter(f => f.Details == "nextmonth").length; //$$this.GetReportsData("renewalclaritynextmonth", dataConst, true, fdt, tdt, facility);
 logs.push("RCNM:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCOT = allrenewalClarity.filter(f => f.Details == "others").length; //$$this.GetReportsData("renewalclarityothers", dataConst, true, fdt, tdt, facility);
 logs.push("RCOT:" + this.GetDateDiff(startDate, new Date()));


 startDate = new Date();
 aggregate.RCP = allrenewalClarity.filter(f => f.Details == "pending").length; //$$this.GetReportsData("renewalclaritypending", dataConst, true, fdt, tdt, facility);
 logs.push("RCP:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.RCR = allrenewalClarity.filter(f => f.Details == "renewed").length; //$$this.GetReportsData("renewalclarityrenewed", dataConst, true, fdt, tdt, facility);
 logs.push("RCR:" + this.GetDateDiff(startDate, new Date()));
 startDate = new Date();
 aggregate.RCTBR = aggregate.RCA - aggregate.RCR - aggregate.RCP - aggregate.RCOT;
 logs.push("RCTBR:" + this.GetDateDiff(startDate, new Date()));
 startDate = new Date();
 var pendingCourses = $$this.GetReportsData("allpendingcourses", dataConst, true, fdt, tdt, facility);


 //start kid state Region

 startDate = new Date();
 var kidStatuses = $$this.GetReportsData("kidconditionsandbehaviours", dataConst, true, fdt, tdt, facility);

 aggregate.KIDCON = kidStatuses && kidStatuses.length > 0 ? kidStatuses.filter(e => e.ConditionsRange == "Pending").length : 0;
 aggregate.KIDBEH = kidStatuses && kidStatuses.length > 0 ? kidStatuses.filter(e => e.BehavioursRange == "Pending").length : 0;
 logs.push("RCTBR:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.PMILES = $$this.GetReportsData("pendingmilestones", dataConst, true, fdt, tdt, facility);
 console.log("PMILES:" + this.GetDateDiff(startDate, new Date()));
 logs.push("PMILES:" + this.GetDateDiff(startDate, new Date()));

 startDate = new Date();
 aggregate.CMILES = $$this.GetReportsData("completedmilestones", dataConst, true, fdt, tdt, facility);
 console.log("CMILES:" + this.GetDateDiff(startDate, new Date()));
 logs.push("CMILES:" + this.GetDateDiff(startDate, new Date()));


 aggregate.TCOP = pendingCourses.totalPending;
 aggregate.TTP = pendingCourses.totalTantrumsPending;
 aggregate.TCNP = pendingCourses.totalConditionsPending;
 aggregate.TPISI = pendingCourses.ptiPendingAssesmsnets;
 logs.push("PENDINGCOURCES:" + this.GetDateDiff(startDate, new Date()));

 console.log("OWNERAGGREGTAES:" + this.GetDateDiff(initialStart, new Date()));
 console.log(logs);
 return aggregate;
}




PrepAggregates(role, data, aggregateType, facility, $this, onlyThese, fromDate, toDate, prepedData) {
 try {

     var $$this=this;
     console.log("LEADERS SYNC : START " + new Date());
     onlyThese = onlyThese || null;
     if (!data || !data.Centers) {
         return {};
     }
     var aggregate = {};



     // console.log(facility);
     var fids = [];
     if (facility && facility != "null") {
         fids = (facility + "").split(",").map(m => parseInt(m));
     }
     else {
         fids = data.Centers.map(m => m.Id);
     }

     aggregate.FId = fids;

     var fsIds = fids.map(m => m + "");

     //console.log(fids);

     var todayDate = new Date();

     var fdt = fromDate ? fromDate : new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
     var tdt = toDate ? toDate : new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0, 23, 59, 59);
     var FDT = fdt;
     var TDT = tdt;
     var logs = [];
     var inittialStart = new Date();
     var startDate = new Date();
     var dataConst = {};

     dataConst = $$this.GetPrepData(role, data, fromDate, toDate, fids, $this);
     // if(prepedData)
     // {
     //     dataConst = prepedData;
     // }
     // else{

     // }
     var startDate = new Date();
     switch (role.toUpperCase()) {
         case "BOSS":
             console.log("BOSS SYNC : START " + new Date());
             startDate = new Date();
             aggregate =  $$this.PrepBossAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese);
             console.log("BOSS SYNC : END " + this.GetDateDiff(startDate, new Date()));
             break;
         case "THERAPIST":
             console.log("Therapist SYNC : START " + new Date());
             startDate = new Date();
             aggregate =  $$this.PrepTherapistAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese);
             console.log("Therapist SYNC : END " + this.GetDateDiff(startDate, new Date()));
             break;
         default:
             console.log("Senior SYNC : START " + new Date());
             startDate = new Date();
             aggregate =  $$this.PrepOwnerAggregates(fids, dataConst, fdt, tdt, facility, $this, onlyThese, role);
             console.log("Senior SYNC : END " + this.GetDateDiff(startDate, new Date()));
             break;

     }

     //THIS IS FOR AUTISM GPT STORE BUILDING
     //localStorage.setItem("AutismGPTConfigRefresh", "TRUE");

     // logs.push("Prep:" + this.GetDateDiff(startDate, new Date()));
     // if (role == "Admin" || role == "Receptionist" || role == "NCC" || role == "Owner"|| role=="FacilityOwner" || role=="Senior" || role=="Manager" || role == "Investor" || role == "Harvest") {


     //     // #endregion Pendings
     // }

     // try {

     //     if ((!onlyThese || onlyThese.length == 0) && (role == "Therapist" || role == "Senior" || role == "Admin" || role == "Harvest" || role == "Receptionist" || role == "Receptionist" || role == "NCC" || role == "Owner"|| role == "FacilityOwner" || role == "Investor" || role== 'Manager')) {



     //     }



     // }
     // catch (e) {
     //     console.log(e);
     // }
     // try {
     //     if (role == "Boss") {


     //     }

     //     else
     //     {

     //     }
     // }
     // catch (e) {

     //     SaveCleintWaufli(e,"Prep Aggregates Failed","PrepAggregates");

     //     console.log(e);
     // }



     if (null == onlyThese) {


         var endDate = new Date();
         console.log(inittialStart);
         var log = data.CFUser.Handle + "," + role + ","
             + inittialStart.getHours() + ":" + inittialStart.getMinutes() + ":" + inittialStart.getUTCSeconds() + ","
             + endDate.getHours() + ":" + endDate.getMinutes() + ":" + endDate.getUTCSeconds() + "," +
             this.GetDateDiff(inittialStart, endDate) + ","
             + logs.join(",");
         var exception = {};
         exception.Type = "CLIENTPREPAGGREGATES1V";
         exception.Message = log;
         // SaveExceptionToSentry(exception, "Transaction", getUserToken(), "CLIENTPREPAGGREGATES1V");
     }

     console.log("LEADERS SYNC : END " + new Date());
    // bbp.Log("PA", inittialStart, new Date());
     aggregate.CDT = new Date();
     return aggregate;
 }
 catch (e) {
     console.log(e);
   //  SaveCleintWaufli(e, "Prep Aggregates Failed", "PrepAggregates");

 }
}
  GetDateDiff(date1, date2) {
    return date2.getTime() - date1.getTime();
}


  fixedExpenses = [
    "rent",
        "internet",
        "internet charges",
        "establishment",
        "maintenance"

];

      benefitExpenses = [
    "team out"

];


   incentiveExpenses = [
    "incentives"


];
 CalculateDangPendingCount(list,config,from,to,fids)
{
    list = (list || []);
    console.log(fids);
    var facilititesLength = ((fids || []).length);
    var startDate = new Date(2022,9,12);
    from = from <= startDate ? startDate : from;
    var currentDateTime = new Date();
    var currentCDT = new Date();
    currentCDT.setDate(currentCDT.getDate() + 1) 
    var toDate = currentDateTime.getDate() <= to ? currentCDT  : to;
    to = currentDateTime.getDate() <= to ? currentDateTime : to;

    var noofWorkingDays = Math.ceil(this.GetTotalWorkingDays(from, toDate));

    var stringArray = config && config.F1 && config.F1.includes("{=}") ? config.F1.split("{=}"): [];
    var timespanList = [];
    if (stringArray.length > 0) {
        for (let i = 0; i < stringArray.length; ++i) {
            var val = stringArray[i].split("{#}")[0];
            timespanList.push(this.GetTimeSlotTotal(val));
        }
    }

    var total = noofWorkingDays * timespanList.length;
    if (currentDateTime.getDate() == to.getDate()) {
        var currentHoursMins = currentDateTime.getHours() * 60 + currentDateTime.getMinutes();
        total += timespanList.filter(m => currentHoursMins >= m).length;
    }
    var totalPendings = (facilititesLength * total) - list.length;
    return totalPendings > 0 ? totalPendings : 0;

}

 dangConfig = {
    "F1": "8:30{#}Biometric Punch-In,  Supervise Readiness: Cleaning, Hygiene, Ambience, Organize, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync{=}9:00{#}Supervise Readiness: Ambience, Organize Reception, Therapy Rooms, Playzone, Pantry. Clear Pending: Goals, Attendance, Fee, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync{=}9:30{#}Staff Check-In, Biometric Sync, Staff Leaves, Handle unapproved leaves, Compensations. Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Clear Pending: Goals, Attendance, Fee, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync,  Parents 1:1{=}10:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize, Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync,  Parents 1:1{=}11:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}12:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}13:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}14:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}15:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}16:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}16:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}17:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}17:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}18:00{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1{=}18:30{#}Welcome Parents, Greet Kids, Offer Water, Call Absented Kids. Attention to Cleanliness, Hygiene, Organize. Clear Pending: Goals, Attendance, Seeta, Kubera, Lead Follow-Up, Red KPI, NCC, Harvest, Finance Sync, Parents 1:1",
    "F2": "LEP,AP,GP,TGNS,PP,KUM,SETP",
    "F7": 15,
    "S": "ADMINISTRATOR"
}




   PrepIndividualCenterAggregates($this, data) {
  console.log("PrepIndividualCenterAggregates");
  console.log(data);
    if(data && data.Centers)
    {
      this.userSettings = data.UserSettings;
          var aggregates = [];
          console.log(this);
          var $this = this;
        //  data.Centers.forEach(function (center) {

          for(var i=0;i<data.Centers.length;i++)
          {             
          var center =   data.Centers[i]; 
           var agg = $this.PrepAggregates("Owner", data, "MONTHLYAGGREGATES", center.Id + "", $this, ["leads", "money", "services"]);
              agg.GID = center.Id;
              agg.CenterName = center.Name;
              aggregates.push(agg);
              console.log("aggregates");
          }
          
    

      return aggregates;
    }
  
}


/*
THIS METHOD IS MENT TO MERGE THE INCOMING DATA
*/
MergeData(existingData, newData) {
 try {
     //IF NO ASSESSMENT EXITS ASSIGN DIRECTLY
     if (!existingData) {

         existingData = newData;
     }
     else {
         //REMOVE INCOMINGS
         var eIds = newData.map(function(val,i){
           
             return val.Id + ""


         });
         
         // $.map(newData, function (val, i) {
             
         // });

         if (eIds != null && eIds.length > 0) {

             existingData = existingData.filter(function(e){ return !(eIds.indexOf(e.Id + "") > -1) });// $.grep(existingData, function (e) { return !(eIds.indexOf(e.Id + "") > -1) });
             Array.prototype.push.apply(existingData, newData);
         }
     }

     return existingData;
 }
 catch (e) {

   //  SaveCleintWaufli(e,"MergeData Failed"," MergeData ");
    
     console.log("Error in Merging Local Data", e);
 }
}


HandleSyncResponseDataMerges()
{

}




}

const workerInstance = new AggregateManger();






var workercode = () => {


  
     // importScripts("RUtility.js");
      onmessage = function(e) {
        // self.importScripts("./testModule"); // eslint-disable-line no-restricted-globals
        // eslint-disable-line no-restricted-globals
        console.log("Message received from main script");
        console.log(e);
       // PrepAggregates(); PrepIndividualCenterAggregates($this, $this.props.UserData)
    //var agg =new Aggregates();
       if(e.data.Method == "IndividualAggregates")
       {
      var dataF = workerInstance.PrepIndividualCenterAggregates(this,e.data.Data);
       // setTimeout(() => {
        var d = {
            "Method": e.data.Method,
            "Data":dataF
        };
          // var workerResult =  "Received from main: " + JSON.stringify(dataF);
          // console.log("Posting message back to main script");
          // self.postMessage(api.message()); // eslint-disable-line no-restricted-globals
           
  
          postMessage(d); // eslint-disable-line no-restricted-globals
      }
      else if(e.data.Method == "Aggregate")
      {
        console.log("On Message - Aggregate");
       // PrepAggregates(role, data, aggregateType, facility, $this, onlyThese, fromDate, toDate, prepedData)
        var dataF = workerInstance.PrepAggregates(e.data.Role, e.data.Data, e.data.Type, e.data.FacilityId + "",e.data.$this,null,null,null,null);
        console.log("FFFF"+JSON.stringify(dataF));
        var d = {
          "Method": e.data.Method,
          "Data":dataF
        };
        // var workerResult =  "Received from main: " + JSON.stringify(dataF);
        // console.log("Posting message back to main script");
        // self.postMessage(api.message()); // eslint-disable-line no-restricted-globals
         
  
        postMessage(d); // eslint-disable-line no-restricted-globals
      }
       // }, 3000)
      };
    };
       let code = workercode.toString();
    code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
    
    const blob = new Blob([code], { type: "application/javascript" });
    const worker_script = URL.createObjectURL(blob);
    
    export default worker_script;
  
    
  
  
   
  
   
       